import * as React from "react";
import { DraftType, getGroupIdByName, isStringValidated, NewContractFileds, SelectTheme } from "../Global/constants";
import TextField from '../UtilityFunctions/CustomTextField';
import $ from "jquery";
import * as yup from "yup";
import axios from "axios";
import Select from "react-select";
import { v4 as uuid } from "uuid";
import { Web } from "sp-pnp-js";
// import Autocomplete from "react-autocomplete";
// import { Guid } from "@microsoft/sp-core-library";
import {
  Callout,
  ChoiceGroup,
  DatePicker,
  Dialog,
  DialogType,
  Dropdown,
  IChoiceGroupOption,
  IChoiceGroupStyles,
  Icon,
  IDialogStyleProps,
  IDialogStyles,
  MessageBar,
  MessageBarType,
  PrimaryButton,
} from "@fluentui/react";
import { useBoolean } from "@uifabric/react-hooks";
import { SweetAlerts } from "../UtilityFunctions/SweetAlerts";
import moment from "moment";
import SettingService from "../../services/SettingService";
import { useImmer } from "use-immer";
import ContextService from "../../services/ContextService";
import ActivityService from "../../services/ActivityService";
import {
  Checkbox,
  DefaultButton,
  ICheckboxStyles,
  IconButton,
  IDropdownOption,
  IDropdownStyles,
  IIconProps,
  IModalProps,
  IStyleFunctionOrObject,
  ITooltipHostStyles,
  Label,
  Link,
  mergeStyleSets,
  ResponsiveMode,
  Spinner,
  Stack,
  TooltipHost,
} from "office-ui-fabric-react";
import CustomAttachment from "../DragnDrop/CustomAttachment";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { customStyles } from "../UtilityFunctions/ReactSelectStyles";
import { languageModal } from "../loc/Clm365ContractManagementWebPartStrings";
import { GetAllBusinessUnitName } from "../Fetchers/HomeRequest";
import { sortArrayAscendingorder } from "../UtilityFunctions/SortArrayorderby";
import { GetAllContractTypeNameHome, GetAllDocDisplayFieldName } from "../Fetchers/CurrentContractType";
import DragAndDrop from "../DragnDrop/DragAndDrop";
import AddTermDialog from "./AddTermDialog";
import { GetAllDisplayFieldName } from "../Fetchers/CurrentRequestFields";
import { useAppSelector } from "../Store/hooks";
import { AddRegular, ChevronDownRegular, ChevronUpRegular, DeleteRegular, Dismiss32Filled, DocumentAddRegular, DraftsRegular, SendRegular } from "@fluentui/react-icons";
import { Button } from "@fluentui/react-components";
import { CalcuateBusinessDays, handleTokenExpiration, uploadFilesInBatch } from "../UtilityFunctions/CommonFunction";
import { fetchAzureOpenAIData, setContractKeysValues } from "./AIIntegrations";
import { ContractCostTextField, convertCurrency, getFilteredPaymentTerms } from "../UtilityFunctions/RequestFunctions";
import { CopilotExtractText } from "./CopilotIntegration/CopilotFunctions";
let UsersOptions = [];
let setatt = [];
let setatt1 = [];
let remarksetatt = [];
let remarksetatt1 = [];
let GJsonFormFields;
let _JsonFormFields;
let counterPartyItems = [];
let filepath;
let attachment;
let standardfileData;
let standardfileName;
let approvalAccess = [];
let legalAccessUsers = [];
let RequestApproval = "";
let DraftApproval = "";
let AutoBusinessApproval = false;
let AutoLegalReviewApproval = false;
let MSAGuid;
let businessData = [];
let allApprovalData = [];
let draftData = [];
let taskJSON = [];
let DraftTaskData=[]
let executionData=[]
let requestApprovalData = []
let isOptional = false;
let sowGuid_ListName = "";
let businessuserManager;
let businessuserManagerManger;
let workflowempapproversemail;
let workflowempapproversids;
let workflowempapproversname;
let draftid;
let requestsequencenum;
let RequestNumberSeq: any;
let RequestNumberSeq2: any;
let requestnumbertemp: any;
let placeholders = [];
let orgDetailsFinal = [];
let AllfieldValues;
let allAttachementFiles = [];
let draftfiledata = [];
let allMails;
let allActivityLogs = [];
let generalListId;
let RequestSequenceValue = [];
let addattachmentNameGuids = [];
let Contract_Request_Title;
let busClicked = false;
let optionBU = [];
let approvalInfoTemp = [];
let addattachmentNames = [];
let allRoleOptions: any;
let userGroups = []
const TextFieldStyles = {
  root: {
    marginLeft: "5px",
  },
};

const dropdownStyles: Partial<IDropdownStyles> = {
  dropdownItemsWrapper: {
    maxHeight: "350px",
  },
};
const dropdownStylesapprove: Partial<IDropdownStyles> = {
  dropdownItemsWrapper: {
    maxHeight: "350px",
  },
  title: {
    height: "32px !important",
  },
};

let newColumn = [];

function NewContract(props) {
  const settingsCurrency = JSON.parse(props?.SettingsListData.OrganizationInfo || "[]")[0]?.Currency || JSON.parse('{"key":"USD_$","text":"USD"}')
  const CurrentUser = JSON.parse(localStorage.getItem("CurrentUser")||"{}");
  const AzureAI:any= JSON.parse(localStorage.getItem("AzureAI") || "{}")
  const Copilot:any= JSON.parse(localStorage.getItem("Copilot") || "{}");
  const strings = languageModal.getLanguageContent();
  const uniqueGUID = uuid();
  const JSZip = require("jszip");
  const attachyourFile=props?.isFromAI?"Select file from Outlook":"Attach your own file"
  const businessUnit=props.SettingsListData['DisplayBusinessUnit']||"No";
  const department=props.SettingsListData['DisplayDepartment'] || "No";
  const ContractApprovalEnabled = props.SettingsListData.ContractApprovalEnabled === "No"
  const [selectedTerm, setSelectedTerm] = React.useState("");
  const { SweetAlert: Sweetalertremarksdailoge } = SweetAlerts("#Sweetalertremarksdailoge");
  const [currentbusUnitName, setcurrentbusUnitName] = React.useState({});
  const [currentContractName, setcurrentContractName] = React.useState({});
  const [submitDisabled, setSubmitDisabled] = React.useState<boolean>(false);
  const [isFromAI, setisFromAI] = React.useState<boolean>(false);
  // console.log(props.allContracts);
  const [showDurationTextField,  setShowDurationTextField] = React.useState(true)
  const [businessunitdropvalue, setBusinessunitdropvalue] = React.useState<string>("");
  const [filtercbusinessName, setfiltercbusinessName] = React.useState<string>();
  const [attachremarkFile1, setattachremarkFile1] = React.useState([]);
  const [attachremarkFile2, setattachremarkFile2] = React.useState([]);
  const [FileImported, setFileImported] = React.useState(false);
  const [AttachYourOwnFile, setAttachYourOwnFile] = React.useState(true);
  const [orgDetailsfinal, setorgDetailsfinal] = React.useState([]);
  const [approvalInfo, setApprovalInfo] = useImmer([]);
  const [standardTemplate, setStandardTemplate] = React.useState<any>();
  const [optionsCounterparty, setoptionsCounterparty] = React.useState([]);
  const [ShareWith, setShareWith] = React.useState({
    shareWithSelected : [],
    ShareWithOptions: []
  });
  const [dataText, setdataText] = React.useState({});
  const [loader, setLoader] = React.useState(false);
  const [requesttypevalue, setrequesttypevalue] = React.useState<string>('Contract');
  const [counterparty, setcounterparty] = React.useState(false);
  const [counterpartyname, setcounterpartyname] = React.useState([]);
  const [validatestate, setvalidatestate] = React.useState({});
  const [dataNumber, setdataNumber] = React.useState({});
  const [contracttypename, setcontracttypename] = React.useState([]);
  const [selectedChoiceKey, setselectedChoiceKey] = React.useState<string | undefined>("Definite");
  const [isDialogvisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
  const [dataNote, setdataNote] = React.useState({});
  const [conditionaldata, setconditionaldata] = React.useState([]);
  const [dateDatepicker, setdateDatepicker] = React.useState({});
  const [isDisabled, setIsDisabled] = React.useState(false)
  const [dataChoice2, setdataChoice2] = React.useState({});
  const [contractGUID, setContractGUID] = React.useState<string>();
  const [conditionaljson, setconditionaljson] = React.useState<string>();
  const [finalconditional, setfinalconditional] = React.useState([]);
  const [finalconditionNumber, setfinalconditionNumber] = React.useState([]);
  const [formfieldjson, setformfieldjson] = React.useState<string>();
  const [selectedchoice, setselectedchoice] = React.useState<string>();
  const [TitleOptions, setTitleOptions] = React.useState<any>([]);
  const [textValue, setTextValue] = React.useState<string>("");
  const [errormsgValue, seterrormsgValue] = React.useState<string>();
  const [errormsgStatus, seterrormsgStatus] = React.useState(false);
  const { SweetAlert: SweetalertsApproved } = SweetAlerts("#SweetalertsRequest");
  const [termPeriodObj, setTermPeriodObj] = React.useState({});
  const [RequiredColumnMessage, setRequiredColumnMessage] = React.useState(false);
  const [remark, setRemark] = React.useState<string>();
  const [selectfilemsg, setselectfilemsg] = React.useState(false);
  const [spinnerLoading, setspinnerLoading] = React.useState(false);
  const [filtercontractName, setfiltercontractName] = React.useState<string>();
  const [contracttypeId, setcontracttypeId] = React.useState<string>();
  const [contracttypeKey, setcontracttypeKey] = React.useState<any>();
  const [contractCode, setContractCode] = React.useState<string>();
  const [businessCode, setBusinessCode] = React.useState<string>();
  const [Component12, setComponent12] = React.useState(false);
  const [Component13, setComponent13] = React.useState(false);
  const [documentTypes, setDocumentTypes] = React.useState<any>();
  const [documentTypesData, setDocumentTypesData] = React.useState({});
  const [documentTypeFiles, setDocumentTypeFiles] = React.useState<any>([]);
  const [documenttitle, setDocumenttitle]: any = React.useState("");
  const [activeContractsCount, setActiveContractsCount] = React.useState(0);
  const [drafttypelist, setDrafttypelist] = React.useState<string>();
  const [AIAttachment, setAIAttachment] = React.useState<any>();
  const [CurrentdisplayfieldsName, setCurrentdisplayfieldsName] = React.useState({});
  const [CurrentdisplayDocfields, setCurrentDocdisplayfields] = React.useState({});
  const [requestdraft, setRequestdraft] = React.useState<string>();
  const [attachFile1, setattachFile1] = React.useState([]);
  const [attachFile2, setattachFile2] = React.useState([]);
  const [selecteddocfile, setselecteddocfile] = React.useState();
  const [isCustomFieldsOpen, setisCustomFieldsOpen] = React.useState(false);
  const [isSelecRequestOpen, setisSelecRequestOpen] = React.useState(true);
  const [selectedStandfile, setselectedStandfile] = React.useState<any>();
  const [attachmentFileData, setAttachmentFileData] = React.useState({});
  const [attachmentFile, setAttachmentFile] = React.useState<any>([]);
  const [loading1, setLoading1] = React.useState(false);
  const [ButtonSaveText1, setButtonSaveText1] = React.useState<string>("Submit");
  const [loading, setLoading] = React.useState(false);
  const [isremarkDialogvisible, { setTrue: showremarkDialog, setFalse: hideremarkDialog }] = useBoolean(false);
  const [isDialogvisibleOptional, { setTrue: showDialogOptional, setFalse: hideDialogOptional }] = useBoolean(false);
  const [ButtonSaveText, setButtonSaveText] = React.useState<string>("Save as Draft");
  const [loadApprovalsInfos, setloadApprovalsInfos] = React.useState(false);
  const { SweetAlert: SweetalertsRequest, SweetPrompt } = SweetAlerts("#SweetalertsRequest");
  const Delete: IIconProps = { iconName: "Cancel" };
  const [businessNameValue, setBusinessNameValue] = React.useState<string>();
  const [businessunitoptions, setbusinessunitoptions] = React.useState([]);
  const [fromFields, setFromFields] = React.useState({});
  const licence_Key = "trial";
  const hostStyles: Partial<ITooltipHostStyles> = {
    root: { display: "inline-block" },
  };
  const { SweetAlert: Sweetalertsoptional } = SweetAlerts("#Sweetalertsoptional");
  const [isFocused, setIsFocused] = React.useState(false);
  const [iconHideMBNavClassnew, seticonHideMBNavClassnew] = React.useState("hideMBCancelnew");
  const [menuIsOpen, setMenuIsOpen] = React.useState(false);
  const [Component20, setComponent20] = React.useState(false);
  const [isTermDialogvisible, setIsTermDialogvisible] = React.useState<boolean>(false);
  const [DepartmentDetails,setDepartmentDetails] = React.useState({
    SelectedDepartment : "",
    DepartmentOptions:[]
  })
  const [ContractCostData, setContractCostData] = React.useState({
    selectedCurrencyKey:settingsCurrency?.key,
    selectedCurrency:settingsCurrency?.text,
    selectedAmount:"",
    settingsCurrency:settingsCurrency?.text,
    settingsAmount:""
  });
  const counterpartyoption: IChoiceGroupOption[] = [
    { key: "Definite", text: "Definite" },
    { key: "Indefinite", text: "Indefinite" },
  ];
  const requesttype: IDropdownOption[] = [
    { key: "Contract", text: "New Contract" },
    { key: "Amendment", text: "Amendment" },
    { key: "Renewal", text: "Renewal" },
  ].filter((item) =>
    !["p3a", "p4a", "trial"].includes(licence_Key) ? (!["Renewal", "Amendment"].includes(item.key) ? true : null) : true
  );
  const stylesCallout = mergeStyleSets({
    callout: {
      width: 300,
      maxWidth: "90%",
      height: 128,
      padding: "8px 8px",
      background: "var(--settingsCardBackground) !important",
      overflowy: "hidden",
    },
  });
  const dialogContentProps = {
    type: DialogType.normal,
    title: strings.AddCounterparty,
  };
  const checkboxStyles: ICheckboxStyles = {
    text: {
      // fontWeight: 600,
      marginRight: "15px",
    },
    checkmark: {
      // color: 'var(--lightdarkColor)',
      color: SettingService.GetTheme() == "light" ? "var(--lightdarkColor)" : "var(--lightdarkBGGray)",
      // backgroundColor: 'var(--lightdarkBGGray)',
      backgroundColor: "#fff",
      padding: "3px",
      width: "20px",
    },
    checkbox: {
      color: "var(--lightdarkBGGray)",
      backgroundColor: "#fff",
      border: "1px solid #333 !important",
    },
    root: {
      // marginLeft: "40px",
      marginTop: "5px",
      "&:hover": {
        ".ms-Checkbox-checkbox": {
          color: "var(--lightdarkBGGray)",
          backgroundColor: "#fff",
          // backgroundColor: 'var(--lightdarkBGGray)',
          // color: 'var(--lightdarkColor)',
        },
      },
    },
  };

  const modalProps = {
    isBlocking: true,
    styles: {
      scrollableContent: {
        overflowY: "auto !important",
      },
      main: {
        selectors: {
          ["@media (min-width: 650px)"]: {
            width: 100,
            minWidth: 600,
            maxWidth: "1000px",
          },
        },
        fontSize: "18",
        height: 490,
      },
    },
  };
  const dialogOptionalContentProps = {
    type: DialogType.normal,
    title: strings.RequestApproval,
    showCloseButton: true
  };
  const dialogModalPropsoptional: IModalProps = {
    isBlocking: true,
    containerClassName: "DEV_MDAL_TEXT_HEADER",
    className: "DEV_optional_TEXT_HEADER",

    styles: {
      scrollableContent: {
        overflowY: "",
      },
      main: {
        selectors: {
          ["@media (min-width: 480px)"]: {
            // width: 600,
            minWidth: 800,
            maxWidth: 850,
          },
        },
        // height: 400,
        minHeight: "max-content",
        maxHeight: 500,
        fontSize: 10,
      },
    },
  };
  const remarkMod: IStyleFunctionOrObject<IDialogStyleProps, IDialogStyles> = {
    main: {
      Title: {
        padding: "11px 0px 11px 24px !important",
        border: "2px solid red",
      },
    },
  };
  const [draftTypeOptions, setDraftTypeOptions] = React.useState<any>();
  const optionalAssignedto: IDropdownOption[] = [
    { key: "EmployeeName", text: "Employee's Name" },
    { key: "EmployeeManager", text: "Business User's Manager" },
    { key: "EmployeeManagersManager", text: "Business User's Manager's Manager" },
    { key: "Role", text: "Role" },
  ];
  var reA = /[^a-zA-Z]/g;
  var reN = /[^0-9]/g;

  function sortAlphaNum(a, b) {
    var aA = a?.text?.replace(reA, "");
    var bA = b?.text?.replace(reA, "");

    if (aA === bA) {
      var aN = parseInt(a?.text?.replace(reN, ""), 10);
      var bN = parseInt(b?.text?.replace(reN, ""), 10);

      return aN === bN ? 0 : aN > bN ? 1 : -1;
    } else {
      return aA > bA ? 1 : -1;
    }
  }
  const Users = useAppSelector((c) => c.UserValues.Users);
  React.useEffect(() => {
    //console.log(Users, "1234567qwertyuiasdfghj");
    UsersOptions = Users.map((Users) => ({
      key: Users.email,
      text: Users.text,
      id: Users.Id,
    }));
    // console.log(UsersOptions);
  }, [Users]);

  React.useEffect(() => {
    setLoader(true)
    busClicked = false;
    (async () => {
      
      const Busunitdata = await GetAllBusinessUnitName({});
      const Contractunitdata = await GetAllContractTypeNameHome({});
      const Currentdisplayfields = await GetAllDisplayFieldName({});
      Currentdisplayfields["Contract_End_Date"] = "Contract Duration"   
      const CurrentDocdisplayfields = await GetAllDocDisplayFieldName({});
      setcurrentbusUnitName(Busunitdata);
      setCurrentdisplayfieldsName(Currentdisplayfields);
      // setCurrentDocdisplayfields(CurrentDocdisplayfields);
      setcurrentContractName(Contractunitdata);


      if(businessUnit != "Yes"){
        busClicked = true;
        getContractOptionDetails("");
      }else if(businessUnit == "Yes"){
        getbusinessunitnameByCurrentUser(Busunitdata, Contractunitdata);
      }
    })();
    getCounterpartyDetails();
    getAllApprovalInfos();
    _FetchColumns();
    ResetFields();
    getroledata();
    // getContractsCount();
    // createFolder()
    allAttachementFiles = [];
    setisFromAI(props?.isFromAI)
    
  }, []);
  function base64ToBlob(base64, contentType) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
}

// React.useEffect(()=>{
//   if(props?.AiAttachment?.name&&GJsonFormFields!=undefined){

//     const AzureAI:any= JSON.parse(props?.SettingsListData["AzureAI"]||"{}")
//     fetchAzureOpenAI(props?.AiAttachment?.file,AzureAI)
//   }

// },[isFromAI,GJsonFormFields])
  async function createFolder() {
    
  //   try {
  //     const folderName =uniqueGUID.toString() ;
  //     const token = localStorage.getItem("CurrentToken");
     
  //     // const API_URL = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365TaskAttachment')/RootFolder/folders`;
  //     const headers = {
  //         Authorization: `Bearer ${token}`,
  //         Accept: "application/json;odata=nometadata",
  //         "Content-type": "application/json;odata=nometadata",
  //     };
  
  //   //   const folderData = {
  //   //     'ServerRelativeUrl': `/sites/clm365test/Shared Documents/${folderName}`
  //   // };

  //   const apiUrl = `${ContextService.GetUrl()}/_api/web/lists/getByTitle('CLM365TaskAttachment')/items`;

  //   const data = {
  //     "__metadata": { "type": "SP.Data.CLM365TaskAttachmentListItem" },
  //     "FileLeafRef": folderName,  // The name of the folder
  //     "ContentTypeId": "0x0120"   // Specifies the content type for a folder (0x0120 is typically for folder)
  //   };
    

  //     const response = await axios.post(apiUrl, {data}, { headers });
  //     console.log("Folder created successfully:", response.data);
  // } catch (error) {
  //     if (error.response) {
  //         // Handle API-specific errors
  //         console.error("API Error:", error.response.data);
  //     } else {
  //         // Handle network errors or other issues
  //         console.error("Error creating folder:", error.message);
  //     }
  // }
  // Define the document library name and folder name
const documentLibraryName = "CLM365TaskAttachment"; // Replace with your document library name
const newFolderName = uniqueGUID.toString(); // The name of the new folder you want to create

// URL to create a new folder in the root of the document library
const createFolderUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('${documentLibraryName}')/rootfolder/folders`;

// Payload to specify the folder details
const folderPayload = {
  "ServerRelativeUrl": `/sites/clm365test/${documentLibraryName}/${newFolderName}` // Adjust path as necessary
};

const token = localStorage.getItem("CurrentToken");
// Send the POST request to create the new folder
try {
  const response = await axios.post(createFolderUrl, folderPayload, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  });

  console.log('Folder created successfully:', response.data);
} catch (error) {
  console.error('Error creating folder:', error);
}

}

async function getShareWithOptions() {
  try {
    let groupOptions = []
    setShareWith({shareWithSelected:[], ShareWithOptions:[]});
    const newUsers = UsersOptions?.filter(i=>i.id !== CurrentUser?.currentUserId).map(i => ({
    ...i,
    label: i.text,
    value : i.text,
    isShareWith: true
  }));
    if(userGroups){
     groupOptions = await Promise.all(
      Object.keys(userGroups).map(async (group) => {
        const groupId = await getGroupIdByName(group);
        return {
          key: group,
          text: group,
          value: group,
          label: group,
          id: groupId,
        };
      })
    );     
  }
   setShareWith({shareWithSelected:[], ShareWithOptions:[...newUsers, ...groupOptions]});
  } catch (err) {
    console.error(err);
  }
}

  const handleTermChange = (term) => {
    setSelectedTerm(term); // Sougata
  };

  async function getAllApprovalInfos() {
    allApprovalData = [];
    const token = localStorage.getItem("CurrentToken");
    const url="/_api/web/lists/getbytitle('CLM365ApprovalLevels')/items?$top=5000";
    try {
      const response = await axios.get(`${ContextService.GetUrl()}${url}`, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
        },
      });
      const items=response?.data.value||[];
      let finaltemp = [];
      items.map((item) => {
        ////console.log(item)
        allApprovalData.push({
          WorkflowName: item.WorkflowName,
          WorkflowId: item.Id,
          ApprovalType: item.ApprovalType,
          ApprovalLevel: item.ApproverLevel
            ? JSON.parse(item.ApproverLevel)
            : [],
          ApprovalLocation: item.Location,
          Contracttype: item.Contracttype
            ? JSON.parse(item.Contracttype)
            : [],
          ApprovalStage: item.ApprovalStage,
          BusinessUnit: item.BusinessUnit
            ? JSON.parse(item.BusinessUnit)
            : [],
          Counterparty: item?.Counterparty
            ? JSON.parse(item?.Counterparty||"[]")
            : [],
          Department: item.Department
            ? JSON.parse(item.Department||"[]")
            : [],
          DefaultFlow: item.DefaultFlow || "No"
        });
      });
    } catch (error) {
      console.log(error)
      const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
        return await handleTokenExpiration(getAllApprovalInfos());
      }
    }
  }

  function ResetFields() {
    setattachFile2(null);
    setattachFile1(null);
    setatt1 = [];
    setattachremarkFile1([]);
    setattachremarkFile2([]);
    remarksetatt1 = [];
    remarksetatt = [];
  }

  async function _FetchColumns() {
    try {
      // const token = token; // Replace with the actual token
      const baseUrl = ContextService.GetUrl();
      const listName = "CLM365Request";
      const token = localStorage.getItem("CurrentToken");
      const response = await axios.get(
        `${baseUrl}/_api/web/lists/getbytitle('${listName}')/Fields?$select=*&$filter=ReadOnlyField eq false`,
        {
          headers: {
            Accept: "application/json;odata=nometadata",
            "odata-version": "",
            Authorization: `Bearer ${token}`, // Include the token here
          },
        }
      );

      const fields = response.data;

      fields.value.map((templ) => {
        if (
          !["Guid_ID", "MetaInfo", "PropertyBag", "FileLeafRef", "Order", "ContentType"].includes(templ.InternalName)
        ) {
          let finaltem = [
            {
              key: templ.InternalName,
              Value: templ.Title,
            },
          ];
          let nColumn = [
            {
              type: templ.TypeAsString,
              intName: templ.InternalName,
              Choices: templ.Choices,
            },
          ];
          newColumn.push(...nColumn);
          placeholders.push(...finaltem);
        }
      });
    } catch (error) {
      console.error("Error fetching columns:", error);
    }
  }

  const onchangeUser = (item, id): void => {
    if (!item) return;
    let selectedValues = [];
    setApprovalInfo((approvalInfo) => {
      const taskData = JSON.parse(approvalInfo[id].TaskData || "{}");

      if (item.selected) {
        taskData.AssignedToEmail.push(item.key);
        taskData.AssignedToId.push(item.id);
        taskData.ApproverName.push(item.text);
      } else {
        taskData.AssignedToEmail = taskData.AssignedToEmail.filter((c) => c != item.key);
        taskData.AssignedToId = taskData?.AssignedToId?.filter((c) => c != item.id);
        taskData.ApproverName = taskData?.ApproverName?.filter((c) => c != item.text);
      }
      taskData.TaskName == "Legal Review" ? (taskData.LegalUserId = taskData.AssignedToId) : null;
      approvalInfo[id].TaskData = JSON.stringify(taskData);
    });
  };

  const getroledata = async () => {
    try {
      const token = localStorage.getItem("CurrentToken");
      const response = await axios.get(`${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365General')/items`, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`, // Include token for authentication
        },
        params: {
          $select: "Role,OrganizationInfo,Department,UserGroups",
          $filter: `Title eq 'GeneralData'`,
        },
      });

      if (response.status === 200) {
        const items = response.data?.value || [];
        const allRoleOptions: Array<{ key: string; text: string }> = [];
        const orgDetailsFinals: any[] = [];

        if (items.length > 0 && items[0]?.Role != null) {
          // Parse Role and OrganizationInfo fields
          const roleArr = JSON.parse(items[0].Role);
          const orgDetails = JSON.parse(items[0].OrganizationInfo);

          // Populate role options
          roleArr.forEach((curr: any) => {
            allRoleOptions.push({ key: curr?.Name, text: curr?.Name });
          });
           const AllDepartmentData = JSON.parse(items?.[0]?.Department||"[]").filter(i => i.Status == "Active")
          const DeptOptions = AllDepartmentData.map(item => ({
            label: item.Name,
            value: item.Name,
            text: item.Name,
            key: item.GUID,
            code: item.DepartmentCode
          }))
          setDepartmentDetails((prev)=>({...prev,DepartmentOptions:DeptOptions}))
          userGroups = JSON.parse(items[0]?.UserGroups || '{}');
          // Populate organization details
          const finalOrg = {
            Organization_Title: orgDetails[0]?.OrganizationTitle,
            Organization_URL: orgDetails[0]?.OrganizationURL,
            Organization_Country: orgDetails[0]?.Country,
            Organization_Address_Line_1: orgDetails[0]?.Address1,
            Organization_Address_Line_2: orgDetails[0]?.Address2,
            Organization_City: orgDetails[0]?.City,
            Organization_State: orgDetails[0]?.State,
            Organization_ZipCode: orgDetails[0]?.ZipCode,
            Organization_Website: orgDetails[0]?.Website,
            Organization_Currency: orgDetails[0]?.Currency,
            Organization_Contact_Number: orgDetails[0]?.ContactNumber,
            Organization_Jurisdiction: orgDetails[0]?.OrganizationJurisdiction,
          };

          orgDetailsFinals.push(finalOrg);
        }

        // Set state with the parsed data
        setorgDetailsfinal(orgDetailsFinals);
        // setAllRoleOptions(allRoleOptions);
      }
    } catch (error) {
      console.error("Error fetching role data:", error);
      const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
        return await handleTokenExpiration(getroledata());
      }
    }
  };

  const onchangeapprover = (item, id): void => {
    if (!item) return;
    let value =
      item.key == "EmployeeName"
        ? "EmpName"
        : item.key == "EmployeeManager"
          ? "EmpManager"
          : item.key == "EmployeeManagersManager"
            ? "EmpManagersManager"
            : item.key == "Role"
              ? "JobTitle"
              : null;
    setApprovalInfo((approvalInfo) => {
      approvalInfo[id][value] = item.selected || false;

      const taskData = JSON.parse(approvalInfo[id].TaskData || "{}");
      if (item.selected) {
        if (value == "EmpName") {
          workflowempapproversemail?.map((ele) => {
            taskData.AssignedToEmail.push(ele);
          });
          workflowempapproversids?.map((ele) => {
            taskData.AssignedToId.push(ele);
          });
          workflowempapproversname?.map((ele) => {
            taskData.ApproverName.push(ele);
          });
        } else if (value == "EmpManager") {
          taskData.AssignedToId.push(businessuserManager?.ID);
          taskData.AssignedToEmail.push(businessuserManager?.EMail);
          taskData.ApproverName.push(businessuserManager?.Title);
        } else if (value == "EmpManagersManager") {
          taskData.AssignedToId.push(businessuserManagerManger?.ID);
          taskData.AssignedToEmail.push(businessuserManagerManger?.EMail);
          taskData.ApproverName.push(businessuserManagerManger?.Title);
        }
      } else {
        if (value == "EmpName") {
          taskData.AssignedToEmail = taskData?.AssignedToEmail?.filter(function (item) {
            return workflowempapproversemail.indexOf(item) === -1;
          });
          taskData.AssignedToId = taskData?.AssignedToId?.filter(function (item) {
            return workflowempapproversids.indexOf(item) === -1;
          });

          taskData.ApproverName = taskData?.ApproverName?.filter(function (item) {
            return workflowempapproversname.indexOf(item) === -1;
          });
        } else if (value == "EmpManager") {
          taskData.AssignedToEmail = taskData.AssignedToEmail.filter((c) => c != businessuserManager?.EMail);
          taskData.AssignedToId = taskData?.AssignedToId?.filter((c) => c != businessuserManager?.ID);
          taskData.ApproverName = taskData?.ApproverName?.filter((c) => c != businessuserManager?.Title);
        } else if (value == "EmpManagersManager") {
          taskData.AssignedToEmail = taskData.AssignedToEmail.filter((c) => c != businessuserManagerManger?.EMail);
          taskData.AssignedToId = taskData?.AssignedToId?.filter((c) => c != businessuserManagerManger?.ID);
          taskData.ApproverName = taskData?.ApproverName?.filter((c) => c != businessuserManagerManger?.Title);
        }
      }
      taskData.TaskName == "Legal Review" ? (taskData.LegalUserId = taskData.AssignedToId) : null;
      approvalInfo[id].TaskData = JSON.stringify(taskData);
    });
  };
  const onchangerole = (item, id): void => {
    let _selectedValue = item.key as string;
    setApprovalInfo((approvalInfo) => {
      approvalInfo[id]["TaskAssignedToRole"] = _selectedValue;
      const taskData = JSON.parse(approvalInfo[id].TaskData || "{}");
      if (_selectedValue) {
        let userwithrole = Users?.filter((item) => {
          return item.Role === _selectedValue;
        });
        userwithrole?.forEach((ele) => {
          taskData?.AssignedToId.push(ele.Id);
          taskData?.AssignedToEmail.push(ele?.email);
          taskData?.ApproverName.push(ele?.text);
        });
        taskData.TaskName == "Legal Review" ? (taskData.LegalUserId = taskData.AssignedToId) : null;
      }
    });
  };
  const onchangeMandatorylevel = (item, id) => {
    approvalInfoTemp = approvalInfo;

    setApprovalInfo((approvalInfo) => {
      const taskData = JSON.parse(approvalInfo[id].TaskData);
      taskData.Mandatory = item;
      approvalInfo[id].TaskData = JSON.stringify(taskData);
    });
  };
  function showremarkdiabox() {
    let hasAssignedEmail = true;
    approvalInfo.forEach((item) => {
      const taskData = JSON.parse(item.TaskData);
      if (!taskData.AssignedToEmail.length) {
        hasAssignedEmail = false;
      }
    });
    if (hasAssignedEmail) {
      // showremarkDialog();
      PostContractformdata("Publish", approvalInfo);
    } else {
      Sweetalertsoptional("error", "Please select owner");
    }
  }

  const onFormatDate = (date?: Date): string => {
    return !date ? "" : moment(new Date(date)).format("MM/DD/YYYY");
  };

  const onChangeAutoComplete = (event): void => {
    setTextValue(event.target.value);
    const updatedValue = event.target.value;
    setdataText((c) => ({
      ...dataText,
      ["Title"]: updatedValue,
    }));
  };

  const [drag, SetDrag] = React.useState(false);
  let heightValue = "";
  const handleDrag = (event) => {
    event.preventDefault();
    SetDrag(true);
    drag ? heightValue == "7rem" : heightValue == "0rem";
    setTimeout(() => {
      SetDrag(false);
    }, 1000);
  };
  const handleDragLeave = (event) => {
    event.preventDefault();
    setTimeout(() => {
      SetDrag(false);
    }, 1000);
    // SetDrag(false);
    //console.log("+++-", drag, "===");
  };

  const onChangeDepartmentDetails = (item) => {
    setDepartmentDetails((prev)=>({...prev,SelectedDepartment:item}))
  }

  const onchangebusinessunit = (
    // event: React.FormEvent<HTMLDivElement>,
    item
    // : IDropdownOption
  ): void => {
    if (item) {
      setisCustomFieldsOpen(true)
      setComponent12(true);
      busClicked = true;
      // timoutReturn && clearTimeout(timoutReturn)
      setvalidatestate({});
      setBusinessunitdropvalue(item["guid"] as string);
      setfiltercbusinessName(item.key as string);
      getContractOptionDetails(item["guid"]);
      setBusinessNameValue(item.text as string);
      businessunitoptions.map((e) => {
        if (e.text == item.text) {
          setBusinessCode(e.code);
        }
      });
    }

  };

  const onAttachmentChangeremark = (ev) => {
    if (ev.target.files.length > 0) {
      let varlnth1 = attachremarkFile2.length;
      let existingFileNames = attachremarkFile2.map((file) => file.name); // Store existing file names

      for (var i = 0; i < ev.target.files.length; i++) {
        if (!existingFileNames.includes(ev.target.files[i].name)) {
          // Check if the file already exists
          let id = varlnth1++;
          remarksetatt.push(ev.target.files[i]);
          addattachmentNames.push(ev.target.files[i].name);
          remarksetatt1.push([
            <div
              className={"Attatchemntdiv"}
              title={ev.target.files[i].name}
              // style={{width:"10.8rem"}}
            >
              <span className={"Attatcmenticons"}>
                <Icon
                  styles={{
                    root: {
                      marginTop: "3px",
                      marginRight: "5px",
                      marginLeft: "5px",
                      
                    },
                  }}
                  iconName="TextDocument"
                ></Icon>
              </span>
              <span className={"Attatchmentext1"}>{ev.target.files[i].name}</span>
              <Link
                onClick={() => {
                  deleteattachremark(id);
                }}
                style={{ paddingRight: "5px" }}
              >
                {/* <span className="ms-Icon ms-Icon--Cancel" aria-hidden="true">
                  X
                </span> */}
           <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>
              </Link>
            </div>,
          ]);
        }
      }

      setattachremarkFile1([...remarksetatt1]);
      setattachremarkFile2([...remarksetatt]);
    } else {
      setattachremarkFile2(null);
    }
  };
  function deleteattachremark(id) {
    remarksetatt1 = [];
    addattachmentNames = [];
    remarksetatt.splice(id, 1);
    for (var i = 0; i < remarksetatt.length; i++) {
      let id = i;
      addattachmentNames.push(remarksetatt[i].name);
      remarksetatt1.push([
        <div
          className={"Attatchemntdiv"}
          title={remarksetatt[i].name}
          // style={{width:"10.8rem"}}
        >
          <span className={"Attatcmenticons"}>
            <Icon
              styles={{
                root: {
                  marginTop: "3px",
                  marginRight: "5px",
                  marginLeft: "5px",
                },
              }}
              iconName="TextDocument"
            ></Icon>
          </span>
          <span className={"Attatchmentext1"}>{remarksetatt[i].name}</span>
          <Link
            onClick={() => {
              deleteattachremark(id);
            }}
            style={{paddingRight:'5px' }}
          >
            {/* <span className="ms-Icon ms-Icon--Cancel" aria-hidden="true">
              X
            </span> */}
          <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>
          </Link>
        </div>,
      ]);
    }
    setattachremarkFile1([...remarksetatt1]);
    setattachremarkFile2([...remarksetatt]);
  }

  function handleInputChange(newValue) {
    setTextValue(newValue);

    if (newValue.trim().length > 0 && isFocused) {
      setMenuIsOpen(true);
    } else {
      setMenuIsOpen(false);
    }
  }

  async function getbusinessunitnameByCurrentUser(
    TempcurrentbusUnitName1 = currentbusUnitName,
    tempcontracttype = currentContractName
  ) {
console.log(ContextService.GetCurentUserId())
    
    try {
      const token = localStorage.getItem("CurrentToken");
      const response = await axios.get(
        `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365Contract_Type')/items`,
        {
          headers: {
            Accept: "application/json;odata=nometadata",
            "odata-version": "",
            Authorization: `Bearer ${token}`, // Include the token here
          },
          params: {
            $select: "ID,UserGroup,ContractCode,Guid_ID,ContractName,BusinessUnit,BusinessUser/Id,BusinessUser/Title",
            $expand: "BusinessUser",
            $filter: `(BusinessUser/Id eq '` + props.currentUserID +`') or (BusinessUser/Id eq null)`,
          },
        }
      );

      const data = response.data?.value || [];
      let AllSelectedId: any[] = [];
      let finaltemp: any[] = [];
      let optionConName: any[] = [];
      let _arrBu: any[];

      data.forEach((Items) => {
        AllSelectedId.push(Items.ID);

        // Parse BusinessUnit JSON
        _arrBu = JSON.parse(Items.BusinessUnit);
        _arrBu.forEach((item) => {
          finaltemp.push({
            text: TempcurrentbusUnitName1[item.guid],
            key: item.guid,
            guid: item.guid,
            label: TempcurrentbusUnitName1[item.guid],
            value: item.guid,
            code: item.code,
            UserGroup: JSON.parse(Items?.UserGroup),
          });
        });

        // Prepare contract name options
        optionConName.push({
          key: Items.ID,
          text: tempcontracttype[Items.Guid_ID],
          label: tempcontracttype[Items.Guid_ID],
          value: Items.ID,
          guid: Items.Guid_ID,
          code: Items.ContractCode,
          UserGroup: JSON.parse(Items?.UserGroup),
        });
      });

      const finaltempoptions = Object.values(
        finaltemp.reduce((acc, cur) => Object.assign(acc, { [cur.key]: cur }), {})
      );

      const finaltempContracttype = Object.values(
        optionConName.reduce((acc, cur) => Object.assign(acc, { [cur.key]: cur }), {})
      );

      setcontracttypename(finaltempContracttype);
      setbusinessunitoptions(finaltempoptions);

      const finalbusname = _arrBu[0]?.guid;
      setfiltercontractName(optionConName[0]?.guid);

      // Optionally return the business unit name and contract ID for further use
      const _businessUnitName = finalbusname;
      const _contractid = finaltempContracttype[0]?.["key"];

      // Call getContractOptionDetails
      await getContractOptionDetails(_businessUnitName);
    } catch (error) {
      const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(() => getbusinessunitnameByCurrentUser( TempcurrentbusUnitName1 = currentbusUnitName,
    tempcontracttype = currentContractName
  ));
    } else{
      setLoader(false)
      console.error("Error fetching business unit data:", error);
      throw error;
    }
   }
  }

  // function getContractOptionDetails(busname) {
  //   let finaltempContracttype;
  //   ContextService.GetSPContext()
  //     .get(
  //       `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365Contract_Type')/items?$select=ID,UserGroup,ContractCode,Guid_ID,ContractName,BusinessUnit,BusinessUser/Id,BusinessUser/Title&$expand=BusinessUser&$filter=(BusinessUser/Id eq '` +
  //         ContextService.GetCurentUserId() +
  //         `') or (BusinessUser/Id eq null)`,
  //       SPHttpClient.configurations.v1,
  //       {
  //         headers: {
  //           Accept: "application/json;odata=nometadata",
  //           "odata-version": "",
  //         },
  //       }
  //     )
  //     .then((response: SPHttpClientResponse) => {
  //       return response.json();
  //     })
  //     .then(async function (data) {
  //       //console.log(data, "data");
  //       let AllSelectedId = [];
  //       let finaltemp = [];
  //       let optionConName = [];
  //       data?.value?.map((Items) => {
  //         AllSelectedId.push(Items.ID);
  //         //console.log(AllSelectedId, "AllSelectedId");
  //         optionBU = [];
  //  if(businessUnit=='No')
  //   {

  //     optionConName.push({
  //       key: Items.ID,
  //       text: Items.ContractName,
  //       label: Items.ContractName,
  //       value: Items.ID,
  //       code: Items.ContractCode,
  //       guid: Items.Guid_ID,
  //       UserGroup: JSON.parse(Items?.UserGroup),
  //     });
  //   }
  //   else
  //   {
  //     let _arrBu = JSON.parse(Items.BusinessUnit).map((e) => e.guid);
  //     //console.log(_arrBu, "_arrBu");
  //     if (_arrBu.includes(busname)) {
  //       //console.log("Found");
  //       optionConName.push({
  //         key: Items.ID,
  //         text: Items.ContractName,
  //         label: Items.ContractName,
  //         value: Items.ID,
  //         code: Items.ContractCode,
  //         guid: Items.Guid_ID,
  //         UserGroup: JSON.parse(Items?.UserGroup),
  //       });
  //     }
  //   }

  //       });
  //       finaltempContracttype = Object.values(
  //         optionConName.reduce(
  //           (acc, cur) => Object.assign(acc, { [cur.key]: cur }),
  //           {}
  //         )
  //       );
  //       sortArrayAscendingorder(finaltempContracttype,"text")
  //       setcontracttypename(finaltempContracttype);
  //       if(busClicked){
  //         setcontracttypeKey(finaltempContracttype[0]["key"]);
  //       }
  //       // setfiltercontractName(finaltempContracttype[0]?.["guid"]);
  //       setfiltercontractName(finaltempContracttype[0]?.text);
  //       // _businessUnitName=finalbusname,
  //       //  _contractid=finaltempContracttype[0]['key'];
  //       //  setBusinessunitdropvalue(finalbusname);
  //       //console.log(AllSelectedId, "AllSelectedId");
  //       //console.log(finaltemp, "finaltemp");
  //     })
  //     .then(() => {
  //       let arr1 = [];
  //       arr1.push(finaltempContracttype[0]["key"]);
  //       arr1.push(finaltempContracttype[0]["guid"]);
  //       let _contractdata = arr1.join("|");
  //       setcontracttypeId(_contractdata as string);
  //       busClicked? getContractDetails(finaltempContracttype[0]["key"]):"";
  //     });
  // }

  const onChangeDrafttype = (item: IDropdownOption): void => {
    if (item) {
      let ServerRelativeUrl = draftTypeOptions?.filter((u) => u.key == item.key)[0].ServerRelativeUrl;
      setselectedStandfile(ServerRelativeUrl);
      setDrafttypelist(item.key as string);
      setRequestdraft(null);
      // setComponent14(true)
    }
  };

  const onChangeOutlookFile= (item: any): void => {
    if (item) {
      // let varlnth = 0;
      setatt1 = [];
      setatt = [];
      if(AzureAI?.AzureOpenAIToggle){
      fetchAzureOpenAI(item?.file,AzureAI)
      } else if(Copilot?.CopilotToggle === 'Yes'){
        fetchCopilotContractData(item?.file)
      }
      setselecteddocfile(item?.file);
      setselectedStandfile(item?.file)
      draftfiledata.push(item?.file);
      // for (var i = 0; i < ev.target.files.length; i++) {
        let id = 1;
        setatt.push(item?.file);
        setatt1.push([
          <div className={"Attatchemntdiv"} title={item?.file.name} style={{ marginTop: "6px",width:'100%' }}>
            <span className={"Attatcmenticons"}>
              <Icon
                styles={{
                  root: {
                    marginTop: "3px",
                    marginRight: "5px",
                    marginLeft: "5px",
                  },
                }}
                iconName="TextDocument"
              ></Icon>
            </span>
            <span className={"Attatchmentext1"}>{item?.file.name}</span>
            <Link
              onClick={() => {
                deleteattach(id);
              }}
              style={{ marginLeft: "auto",paddingRight:'5px' }}
            >

           <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>
            </Link>
          </div>,
        ]);
      // }
      setAIAttachment(item?.key)
      setattachFile1(setatt1);
      setattachFile2(item?.file)
      setFileImported(true);
      // let ServerRelativeUrl = draftTypeOptions?.filter((u) => u.key == item.key)[0].ServerRelativeUrl;
      // setselectedStandfile(ServerRelativeUrl);
      // setDrafttypelist(item.key as string);
      // setRequestdraft(null);
      // setComponent14(true)
    }else{
      setattachFile2(null);
      setFileImported(false);
    }
  };
  const onChangeRequesttype = (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption): void => {
    if (item) {
      if (businessUnit == "No") {
        setComponent12(true);
        busClicked = true;
        getContractOptionDetails("");
      } else {
        setComponent12(false);
        setComponent20(true);
      }
      setrequesttypevalue(item.key as string);
      setcontracttypeId("");
      setcontracttypeKey("");
      setDrafttypelist("");
      setfiltercontractName("");
      setBusinessunitdropvalue("");
      setComponent13(false);

      onChangeContractname(undefined);
      setattachFile1(null);
      setfinalconditionNumber([]);
      setfinalconditional([]);
      GJsonFormFields = [];
      setdataText({});
      setdateDatepicker({});
      setformfieldjson("");
      setTextValue("");
      setcounterpartyname([]);
    }
  };
  const handleTermCallback = (count, term) => {
    const validTerms = ["Day", "Week", "Month", "Year"];
    // if (!validTerms.includes(term)) {
    //   // console.log("Term is invalid");
    //   return null;
    // }
    if(selectedTerm == "Indefinite"){
      setselectedChoiceKey("Indefinite")
      setIsDisabled(true)
      setIsTermDialogvisible(false)
    }else{
      let res: any = moment(dateDatepicker["Contract_Start_Date"]).add(count,term.toLowerCase())
    setTermPeriodObj({count,term})
    setIsTermDialogvisible(false)
    setdateDatepicker((c) => ({...c, ...{"Contract_End_Date":new Date(res)}}))
    // setdateDatepicker()
    //const dateString = new Date(res).toLocaleDateString();  
    // setTermTextFieldValue(dateString)
    setShowDurationTextField(false)
    }
    // setdateDatepicker()
  };

  async function getContractOptionDetails(busname) {
    try {
      const token = localStorage.getItem("CurrentToken");
      // Fetch contract data using axios
      const response = await axios.get(
        `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365Contract_Type')/items`,
        {

          headers: {
            Accept: "application/json;odata=nometadata",
            "odata-version": "",
            Authorization: `Bearer ${token}`, // Include the token for authentication
          },
          params: {
            $select: "ID,UserGroup,ContractCode,Guid_ID,ContractName,BusinessUnit,BusinessUser/Id,BusinessUser/Title",
            $expand: "BusinessUser",
            $filter: `(BusinessUser/Id eq '${props?.currentUserID}') or (BusinessUser/Id eq null)`,
          },
        }
      );

      const data = response.data?.value || [];
      let optionConName: any[] = [];

      // Process each contract item
      data.forEach((Items) => {
        const displayBusinessUnit = businessUnit || "Yes";
        if (displayBusinessUnit === "No") {
          // If no business unit filter is needed
          optionConName.push({
            key: Items.ID,
            text: Items.ContractName,
            label: Items.ContractName,
            value: Items.ID,
            code: Items.ContractCode,
            guid: Items.Guid_ID,
            UserGroup: JSON.parse(Items?.UserGroup),
          });
        } else {
          // Filter based on the provided business unit
          const businessUnits = JSON.parse(Items.BusinessUnit).map((e) => e.guid);
          if (businessUnits.includes(busname)) {
            optionConName.push({
              key: Items.ID,
              text: Items.ContractName,
              label: Items.ContractName,
              value: Items.ID,
              code: Items.ContractCode,
              guid: Items.Guid_ID,
              UserGroup: JSON.parse(Items?.UserGroup),
            });
          }
        }
      });

      // Deduplicate contract options
      let finaltempContracttype = Object.values(
        optionConName.reduce((acc, cur) => Object.assign(acc, { [cur.key]: cur }), {})
      );

      // Sort contract options and set state
      sortArrayAscendingorder(finaltempContracttype, "text");
      setcontracttypename(finaltempContracttype);

      if (busClicked) {
        setcontracttypeKey(finaltempContracttype[0]?.["key"]);
        getShareWithOptions();
      }

      setfiltercontractName(finaltempContracttype[0]?.["text"]);

      // Prepare contract data
      const arr1 = [finaltempContracttype[0]?.["key"], finaltempContracttype[0]?.["guid"]];
      const _contractdata = arr1.join("|");
      setcontracttypeId(_contractdata);

      if (busClicked) {
        await getContractDetails(finaltempContracttype[0]?.["key"]);
      }
      setLoader(false)
      
    } catch (error) {
      const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(() => getContractOptionDetails(busname));
    }
      setLoader(false)
      console.error("Error fetching contract options:", error);
      throw error;
  
    }
  }

  // function getBusinessUnits() {
  //   let allBusinessUnits = [];
  //   let finaltemp = [];
  //   let allContactTypeOptions = [];
  //   props.allContracts?.map((Items) => {
  //     let _arrBu = JSON.parse(Items.BusinessUnit);

  //     _arrBu.map((item) => {
  //       finaltemp.push({
  //         text: item.name,
  //         key: item.guid,
  //         guid: item.guid,
  //         label: item.name,
  //         value: item.guid,
  //         // code: data.value[0].BusinessunitCode,
  //         code: item.code, //_bUnitCode[index],
  //         UserGroup: JSON.parse(Items?.UserGroup),
  //       });
  //     });

  //     allContactTypeOptions.push({
  //       key: Items.ID,
  //       text: Items.ContractName,
  //       label: Items.ContractName,
  //       value: Items.ID,
  //       code: Items.ContractCode,
  //       guid: Items.Guid_ID,
  //       UserGroup: JSON.parse(Items?.UserGroup),
  //       FormFields: JSON.parse(Items?.FormFields),
  //     });
  //   });
  //   allBusinessUnits = finaltemp;
  //   console.log(allBusinessUnits);
  //   let finalBuisnessUnits = Object.values(
  //     allBusinessUnits.reduce((acc, cur) => Object.assign(acc, { [cur.guid]: cur }), {})
  //   );
  //   let finalContractTypes = Object.values(
  //     allContactTypeOptions.reduce((acc, cur) => Object.assign(acc, { [cur.guid]: cur }), {})
  //   );
  //   setBusinessUnitOptions(finalBuisnessUnits);
  //   setContractTypeOptions(finalContractTypes);
  // }

  const onDocumentTypeChange = (ev, internalname) => {
    console.log(ev, "ev");
    console.log(internalname, "internalname");
    console.log(ev.target.files[0], "ev.target.files[0]");
    if (ev.target.files.length > 0) {
      setatt1 = [];
      setatt = [];
      for (var i = 0; i < ev.target.files.length; i++) {
        const file = ev.target.files[i];
        setatt.push({ IntName: internalname, FileName: ev.target.files[i]?.name, FileContent: ev.target.files[i] });
        setatt1.push([
          <div className={"CustomAttatchemntdiv"} title={ev.target.files[i].name}>
            <span className={"Attatcmenticons"}>
              <Icon
                styles={{
                  root: {
                    marginTop: "3px",
                    marginRight: "5px",
                    marginLeft: "5px",
                  },
                }}
                iconName="TextDocument"
              ></Icon>
            </span>
            <span className={"Attatchmentext1"}>
              <a
                style={{ textDecoration: "none", color: "black" }}
                href={URL.createObjectURL(file)}
                target="_blank"
                download={file.name}
              >
                {file.name}
              </a>
            </span>
            <Link
              onClick={() => {
                deleteDocumentTypes(internalname);
              }}
              style={{ marginLeft: "auto",paddingRight:'5px' }}
            >
          <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>
            </Link>
          </div>,
        ]);
      }
      documentTypesData[internalname] = [setatt1];
      setDocumentTypesData({ ...documentTypesData });
      setDocumentTypeFiles([...documentTypeFiles, ...setatt]);
    }
  };

  function deleteDocumentTypes(internalname) {
    setDocumentTypesData((prevAttachmentData) => {
      let updatedAttachmentData = { ...prevAttachmentData };
      delete updatedAttachmentData[internalname];
      return updatedAttachmentData;
    });
    setatt1 = setatt1.filter((attachment) => attachment.key !== internalname);
    setDocumentTypeFiles((c) => c?.filter((obj) => !obj.IntName || obj.IntName !== internalname));
  }

  function onChangeCParty(selected, intname) {
    if (intname === "Share_With_Others") {
    setShareWith((pre)=> ({...pre, shareWithSelected: selected || []}))
  } else {
    counterPartyItems = [];
    if (selected) {
      selected?.map((items) => {
        let arr = {
          key: items.key,
          Counterpartyname: items.text,
          OrgName: items.value,
          Country: items.value1,
          Guid_ID: items.Guid_ID,
          State: items.State,
        };
        counterPartyItems.push(arr);
      });
    }
    setcounterpartyname(counterPartyItems);
  }
}

  const onChangeContractname = (
    // event: React.FormEvent<HTMLDivElement>,
    item
  ): void => {
    if (item) {
      // setcustomFormFields(item.FormFields);
      // getFormFields(item.FormFields);
      let con_details = [];
      con_details.push(item.key);
      con_details.push(item["guid"]);
      setfiltercontractName(item.text);
      let _contractdata = con_details.join("|");
      ////console.log(item.key, item.text);
      setcontracttypeId(_contractdata as string);
      setvalidatestate({});
      getContractDetails(item.key);
      //   getbusinessunitname(item.text, item.key);
      //console.log("item drop", item);
      setcontracttypeKey(item.key);
      // contracttypename.map((e) => {
      //   if (e.text == item.text) {
          setContractCode(item.code);
      //   }
      // });
    }
    setfinalconditional([]);

    setdataText([]);
    // setselectedChoiceKey('')
    // setcounterpartyname('')
    setdateDatepicker([]);
    setdataNote([]);
    setdataNumber([]);
    setdataChoice2([]);
    setTitleOptions([]);
    setTextValue("");
    getShareWithOptions();
    // getRequestNumberSequence();
  };

  React.useEffect(() => {
    getRequestNumberSequence();
    if(requesttypevalue == "Contract" && currentContractName[contracttypeId?.split('|')[1]] == "Statement of Work")
    {
      const findKeyByValue = () => {
        for (const key in currentContractName) {
          if (currentContractName[key] === "Master Services Agreement") {
            return key;
          }
        }
        return null; // Return null if value not found
      };
    
      const key = findKeyByValue();
      MSAGuid =key
    }
  }, [businessunitdropvalue, contracttypeId]);


const getRequestNumberSequence = async () => {
  try {
    const token = localStorage.getItem("CurrentToken");
    RequestSequenceValue = [];
    const baseUrl = ContextService.GetUrl();
    const endpoint = `${baseUrl}/_api/web/lists/getbytitle('CLM365General')/items?$select=ID,RequestSequence,LastRequestSequence&$filter=Title eq 'GeneralData'`;

    const response = await axios.get(endpoint, {
      headers: {
        Accept: "application/json;odata=nometadata",
        "odata-version": "",
        Authorization: `Bearer ${token}`, // Include the token
      },
    });

    if (response.status === 200) {
      const items = response.data;

      if (items.value.length > 0) {
        generalListId = items.value[0].ID;
        const requestSequenceArray = JSON.parse(items.value[0]?.RequestSequence);
        RequestSequenceValue = [];
        requestnumbertemp = [];
        requestSequenceArray.forEach(item => {
            if (!("Department" in item)) item.Department = "All|All";
            if (!("DepartmentType" in item)) item.DepartmentType = "Department Code";
            if (!("DepartmentField" in item)) item.DepartmentField = "-";
          });
        requestSequenceArray?.forEach((curr, index) => {
          if (
              (curr?.BusinessUnitType.split("|")[0] == businessunitdropvalue || curr?.BusinessUnitType.split("|")[0] == "All") &&
              (curr?.ContractType?.split("|")[0] == contracttypeId?.split("|")[1] || curr?.ContractType?.split("|")[0] == "All") && 
              (curr.Department.split("|")[0] == DepartmentDetails.SelectedDepartment["key"] || curr.Department.split("|")[0] == "All")
            ) {
            let finaltemp = {
              BusinessUnitType: curr?.BusinessUnitType?.split("|")[1],
              ContractTypeVal: curr?.ContractType?.split("|")[1],
              ContractType: curr?.ContractType,
              RequestNumber:
                curr?.DepartmentType == "Department Free Text" ? curr?.DepartmentFreetext : curr?.DepartmentType + curr?.DepartmentField + 
                curr?.Businessunit +
                curr?.Field1 +
                curr?.Contract +
                curr?.Field2 +
                curr?.Year +
                curr?.Field3 +
                curr?.Sequential,
              editindex: index,
              Businessunit:
                curr?.Businessunit === "N/A" ? "" : curr?.Businessunit,
              Contract: curr?.Contract === "N/A" ? "" : curr?.Contract,
              Year: curr?.Year === "N/A" ? "" : curr?.Year,
              Sequential: curr?.Sequential === "" ? "" : curr?.Sequential,
              Field1: curr?.Field1,
              Field2: curr?.Field2,
              Field3: curr?.Field3,
              Department: curr.Department.split("|")[1],
              DepartmentType: curr.DepartmentType == "N/A" ? "" : curr.DepartmentType,
              DepartmentFreeText: curr?.DepartmentFreetext || "",
              DepartmentField: curr.DepartmentField
            };
            requestsequencenum = curr?.CurrentSequence;
            requestnumbertemp = finaltemp;
          }

          let finaldatasync = {
            GUID: curr?.GUID,
            BusinessUnitType: curr?.BusinessUnitType,
            ContractType: curr?.ContractType,
            Businessunit:
              curr?.Businessunit === "N/A" ? "" : curr?.Businessunit,
            Contract: curr?.Contract === "N/A" ? "" : curr?.Contract,
            Year: curr?.Year === "N/A" ? "" : curr?.Year,
            Sequential: curr?.Sequential === "" ? "" : curr?.Sequential,
            Field1: curr?.Field1,
            Field2: curr?.Field2,
            Field3: curr?.Field3,
            RequestSequence: curr?.RequestSequence,
            CurrentSequence: curr?.CurrentSequence,
            Department: curr.Department,
            DepartmentType: curr.DepartmentType == "N/A" ? "" : curr.DepartmentType,
            DepartmentFreeText: curr?.DepartmentFreetext || "",
            DepartmentField: curr.DepartmentField
          };
          RequestSequenceValue.push(finaldatasync);
        });

        if (
          requestnumbertemp == null ||
          requestnumbertemp === undefined ||
          requestnumbertemp === ""||requestnumbertemp?.length==0
        ) {
          RequestSequenceValue = [];
          requestnumbertemp = [];
          requestSequenceArray.forEach(item => {
              if (!("Department" in item)) item.Department = "All|All";
              if (!("DepartmentType" in item)) item.DepartmentType = "Department Code";
              if (!("DepartmentField" in item)) item.DepartmentField = "-";
            });

          requestSequenceArray?.forEach((curr, index) => {
            if (
              curr?.BusinessUnitType?.split("|")[1] === "All" &&
              curr?.ContractType?.split("|")[1] === "All"  && curr.Department.split("|")[0] == "All"
            ) {
              let finaltemp = {
                BusinessUnitType: curr?.ContractType?.split("|")[1],
                ContractTypeVal: curr?.ContractType?.split("|")[1],
                ContractType: curr?.ContractType,
                RequestNumber:
                  curr?.Businessunit +
                  curr?.Field1 +
                  curr?.Contract +
                  curr?.Field2 +
                  curr?.Year +
                  curr?.Field3 +
                  curr?.Sequential,
                editindex: index,
                Businessunit:
                  curr?.Businessunit === "N/A" ? "" : curr?.Businessunit,
                Contract: curr?.Contract === "N/A" ? "" : curr?.Contract,
                Year: curr?.Year === "N/A" ? "" : curr?.Year,
                Sequential: curr?.Sequential === "" ? "" : curr?.Sequential,
                Field1: curr?.Field1,
                Field2: curr?.Field2,
                Field3: curr?.Field3,
                Department: curr.Department,
                  DepartmentType: curr.DepartmentType == "N/A" ? "" : curr.DepartmentType,
                  DepartmentFreeText: curr.DepartmentFreetext || "",
                  DepartmentField: curr.DepartmentField
              };
              requestsequencenum = curr?.CurrentSequence;
              requestnumbertemp = finaltemp;
            }

            let finaldatasync = {
              GUID: curr?.GUID,
              BusinessUnitType: curr?.BusinessUnitType,
              ContractType: curr?.ContractType,
              Businessunit:
                curr?.Businessunit === "N/A" ? "" : curr?.Businessunit,
              Contract: curr?.Contract === "N/A" ? "" : curr?.Contract,
              Year: curr?.Year === "N/A" ? "" : curr?.Year,
              Sequential: curr?.Sequential === "" ? "" : curr?.Sequential,
              Field1: curr?.Field1,
              Field2: curr?.Field2,
              Field3: curr?.Field3,
              RequestSequence: curr?.RequestSequence,
              CurrentSequence: curr?.CurrentSequence,
              Department: curr.Department,
                DepartmentType: curr.DepartmentType == "N/A" ? "" : curr.DepartmentType,
                DepartmentFreeText: curr.DepartmentFreetext || "",
                DepartmentField: curr.DepartmentField
            };
            RequestSequenceValue.push(finaldatasync);
          });
        }
      }
    }
  } catch (error) {
    const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(getRequestNumberSequence());
    }
    console.error("Error fetching request sequence:", error);
  }
};


  async function getCustomColumns(listGUID) {
    setDocumentTypes([]);
    const url = `${props.siteURL}/api/web/lists/getbytitle('CLM365Document_Type')/Items?$select=DocFormFields,SectionName&$filter=Guid_ID eq '${listGUID}'`;
    const token = localStorage.getItem("CurrentToken");
    try {
      const response = await axios.get(url, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`, // Include token if needed
        },
      });

      const items = response.data;

      if (items?.value[0]?.DocFormFields) {
        setDocumenttitle(items.value[0].SectionName);
        setDocumentTypes(JSON.parse(items.value[0].DocFormFields));

        JSON.parse(items.value[0].DocFormFields).forEach((item) => {
          if (item.Type === "Attachments" && item.Required === "Yes") {
            const reqmsg = `Please upload ${CurrentdisplayDocfields[item.IntName]} attachment`;
            const _reqfiled = yup.array().required(reqmsg);

            setvalidatestate((prevState) => ({
              ...prevState,
              [item.IntName]: _reqfiled,
            }));
          }
        });
      }
    } catch (error) {
      console.error("Error fetching custom columns:", error);
    }
  }

  const onCustomAttachmentChange = (ev, internalname) => {
    console.log(ev, "ev");
    console.log(internalname, "internalname");
    console.log(ev.target.files[0], "ev.target.files[0]");
    // let setatt=[];
    // for (var i = 0; i < ev.target.files.length; i++) {
    //   setatt.push(ev.target.files[i]);
    // }
    // attachmentFileData[internalname] = [...setatt];
    // setAttachmentFileData({...attachmentFileData})

    if (ev.target.files.length > 0) {
      setatt1 = [];
      setatt = [];
      for (var i = 0; i < ev.target.files.length; i++) {
        const file = ev.target.files[i];
        setatt.push({ IntName: internalname, FileName: ev.target.files[i]?.name, FileContent: ev.target.files[i] });
        setatt1.push([
          <div
            className={"CustomAttatchemntdiv"}
            title={ev.target.files[i].name}
            // style={{ width:'400px'}}
          >
            <span className={"Attatcmenticons"}>
              <Icon
                styles={{
                  root: {
                    marginTop: "3px",
                    marginRight: "5px",
                    marginLeft: "5px",
                  },
                }}
                iconName="TextDocument"
              ></Icon>
            </span>
            <span className={"Attatchmentext1"}>
              <a
                style={{ textDecoration: "none", color: "black" }}
                href={URL.createObjectURL(file)}
                target="_blank"
                download={file.name}
              >
                {file.name}
              </a>
            </span>
            <Link
              onClick={() => {
                deleteCustomattach(internalname);
              }}
              style={{ marginLeft: "auto" ,paddingRight:'5px'}}
            >
              {/* <span
                className="ms-Icon ms-Icon--Cancel"
                aria-hidden="true"
                // className={"Attachmentdelete"}
                style={{ marginRight: "10px" }}
              >
                X
              </span> */}
             <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>
            </Link>
          </div>,
        ]);
      }
      //setattachFile1(setatt1);
      attachmentFileData[internalname] = [setatt1];
      setAttachmentFileData({ ...attachmentFileData });
      //  attachmentFile[internalname]=[setatt];
      // attachmentFile.push(...setatt)
      setAttachmentFile([...attachmentFile, ...setatt]);
    }
  };
  function deleteCustomattach(internalname) {
    setFileImported(false);
    setAttachmentFileData((prevAttachmentData) => {
      let updatedAttachmentData = { ...prevAttachmentData };
      delete updatedAttachmentData[internalname];
      return updatedAttachmentData;
    });
    setatt1 = setatt1.filter((attachment) => attachment.key !== internalname);
    // setatt = setatt?.filter(obj => !obj.IntName || obj.IntName !== internalname);
    // attachmentFile?.filter(obj => !obj.IntName || obj.IntName !== internalname);
    setAttachmentFile((c) => c?.filter((obj) => !obj.IntName || obj.IntName !== internalname));
  }

  async function getContractDetails(contractId: string) {

    try {
      setComponent13(true);
      setDraftTypeOptions([]);
      const token = localStorage.getItem("CurrentToken");
      // Fetch contract details using axios
      const response = await axios.get(
        `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365Contract_Type')/items`,
        {
          headers: {
            Accept: "application/json;odata=nometadata",
            "odata-version": "",
            Authorization: `Bearer ${token}`, // Include token for authentication
          },
          params: {
            $select:
              "FormFields,ID,ConditionalField,DocumentTypeField,BusinessUnit,Attachments,AttachmentFiles,BusinessUser/Id,BusinessUser/Title",
            $expand: "BusinessUser,AttachmentFiles",
            $filter: `(ID eq '${contractId}')`,
          },
        }
      );

      const data = response.data?.value[0] || [];

      if (data?.DocumentTypeField) {
        getCustomColumns(data?.DocumentTypeField);
      } else {
        setDocumentTypes([]);
      }
      setStandardTemplate(data?.AttachmentFiles[0]?.FileName?.replaceAll("_", " "));
      let FileNames = [];
      FileNames.push(
        { key: "Blank", text: "Blank",value: "Blank", label: "Blank", ServerRelativeUrl: "", },
        { key: attachyourFile, text: attachyourFile,value: attachyourFile, label: attachyourFile, ServerRelativeUrl: "" }
      );
      data?.AttachmentFiles?.map((item) => {
        FileNames?.push({
          key: item?.FileName?.split(".")[0]?.replaceAll("_", " ") + ".docx",
          text: item?.FileName?.split(".")[0]?.replaceAll("_", " ") + ".docx",
          value: item?.FileName?.split(".")[0]?.replaceAll("_", " ") + ".docx",
          label: item?.FileName?.split(".")[0]?.replaceAll("_", " ") + ".docx",
          ServerRelativeUrl: item?.ServerRelativeUrl,
          Attachment:item,
        });
      });
      FileNames = FileNames?.filter((obj, index) => {
        return index === FileNames?.findIndex((o) => obj.text === o.text);
      });
      setDraftTypeOptions(FileNames);

      if(props?.isFromAI){
        setDrafttypelist(attachyourFile)
      }else{
        setselectedStandfile(FileNames[2]?.ServerRelativeUrl);
        setDrafttypelist(FileNames[2]?.key);
      }
     
      attachment = data?.AttachmentFiles[0];
      //console.log(attachment, "attachment");
      // console.log(
      //   data.value[0]?.AttachmentFiles[0].ServerRelativeUrl,
      //   " data.value[0]?.AttachmentFiles[0]"
      // );
      filepath = data?.AttachmentFiles[0]?.ServerRelativePath?.DecodedUrl;
      //data.value[0].AttachmentFiles[0].ServerRelativePath.DecodedUrl
      // setselectedStandfile(
      //   data.value[0]?.AttachmentFiles[0].ServerRelativeUrl
      // );
      // let responsefiles = await fetch(data?.AttachmentFiles[0]?.ServerRelativeUrl);

      const serverRelativeUrl = data?.AttachmentFiles[0]?.ServerRelativeUrl || "";  // The full ServerRelativeUrl (example: '/sites/clm365test/CLM365RequestDraft/fe3a605d-7b79-4a1d-b628-75b2fda56c71.docx')
      const filePath = encodeURIComponent(serverRelativeUrl); 
                const curl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${filePath}')/$value`; 
      
                try{
                  const token = localStorage.getItem("CurrentToken");
                  const responseBlob:any= await axios({
                    method: 'get',
                    url: curl,
                    headers: {
                      'Authorization': `Bearer ${token}`,
                      // 'Accept': 'application/json;odata=verbose'
                    },
                    responseType: 'blob' // Specify that you expect a blob response
                  })
                
                
                  // console.log(responseBlob)
                  if(responseBlob?.data){
        
                    const file = new File([responseBlob?.data], "template.docx", {
                      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    });
            
                    const reader = new FileReader();
                    reader.onload = function (event) {
                      const fileContent = event.target.result;
                      //   console.log("File Content:", fileContent);
                    };
                    reader.readAsText(responseBlob?.data);
                    // selectedStandFile = file;
        
      let docname = data?.AttachmentFiles[0]?.FileName?.replaceAll("_", " ");
      standardfileData = new File([file], docname);
      standardfileName = docname;
        
                  }
                }catch(error){
                  console.log(error)
                }


      //console.log(data.value[0].Attachments, "Attachments");
      let _JsonFormFields = JSON.parse(data?.FormFields);
      GJsonFormFields = JSON.parse(data?.FormFields);
      ////console.log(GJsonFormFields, "GJsonField");
      let _ConditionalField = JSON.parse(data?.ConditionalField);
      // _ConditionalField f
      for (let sectionKey in _JsonFormFields) {
        const section = _JsonFormFields[sectionKey];

        section.items.forEach((item) => {
          const matchingItem = newColumn?.find((col) => col.intName === item.IntName && col.type === "Choice");

          if (matchingItem && matchingItem.Choices) {
            item.Choices = matchingItem.Choices;
          }
        });
      }

      let _conditiondata = [];

      if (_JsonFormFields) {
        Object.entries(_JsonFormFields).forEach(([sectionKey, section]: any) => {
          section.items.forEach((item) => {
            if (item.Type === "Choice" && item.Choices && item.Choices.length > 0) {
              let _choiceoptions = item.Choices.map((choice) => ({
                key: choice,
                text: choice,
              }));

              let finalvalueuniq = Object.values(
                _choiceoptions.reduce((acc, cur) => Object.assign(acc, { [cur.key]: cur }), {})
              );

              _conditiondata.push({
                internalname: item.IntName,
                value: finalvalueuniq,
              });
            }
          });
        });
      }
      ////console.log(_conditiondata, "_conditiondata");
      setconditionaldata(_conditiondata);
      setformfieldjson(_JsonFormFields);
      setconditionaljson(_ConditionalField);
       setdataChoice2((prev) => ({
          ...prev,
          Payment_Term: "One Time",
        }));
      _JsonFormFields
        ? Object.entries(_JsonFormFields).map(([key1, column]: any, index: any) => {
            column.items.map((item: any, ind: any) => {
              if (item.Type == "Text" && item.Required == "Yes") {
                let reqmsg = "Please enter " + item.text.toLowerCase();
                let _reqfiled = yup.string().required(reqmsg);
                setvalidatestate((c) => ({
                  [item.IntName]: _reqfiled,
                  ...c,
                }));
              }
              if (item.IntName == "Counterparty_Name" && item.Required == "Yes") {
                let reqmsg = "Please enter " + item.text.toLowerCase();
                let _reqfiled = yup.string().required(reqmsg);
                setvalidatestate((c) => ({
                  [item.IntName]: _reqfiled,
                  ...c,
                }));
              }
              if (item.Type == "Note" && item.Required == "Yes") {
                let reqmsg = "Please enter " + item.text.toLowerCase();
                let _reqfiled = yup.string().required(reqmsg);
                setvalidatestate((c) => ({
                  [item.IntName]: _reqfiled,
                  ...c,
                }));
              }
              if (item.Type == "DateTime" && item.Required == "Yes" && item.IntName !== "Contract_Date") {
                // let reqmsg = "Please enter " + item.text.toLowerCase();
                let reqmsg = "Please select " + CurrentdisplayfieldsName[item.IntName]?.toLowerCase();;
                let _reqfiled = yup.date().required(reqmsg);
                setvalidatestate((c) => ({
                  [item.IntName]: _reqfiled,
                  ...c,
                }));
              }
              if (item.Type == "Choice" && item.Required == "Yes") {
                let reqmsg = "Please select " + item.text.toLowerCase();
                let _reqfiled = yup.string().required(reqmsg);
                setvalidatestate((c) => ({
                  [item.IntName]: _reqfiled,
                  ...c,
                }));
              }
              if (item.Type == "Number" && item.Required == "Yes") {
                let reqmsg = "Please enter " + item.text.toLowerCase();
                let _reqfiled = yup.string().required(reqmsg);
                setvalidatestate((c) => ({
                  [item.IntName]: _reqfiled,
                  ...c,
                }));
              }
              if (item.Type == "Attachments" && item.Required == "Yes") {
                let reqmsg = "Please upload " + CurrentdisplayfieldsName[item.IntName] + " attachment"; //item.text.toLowerCase();
                let _reqfiled = yup.array().required(reqmsg);
                setvalidatestate((c) => ({
                  [item.IntName]: _reqfiled,
                  ...c,
                }));
              }
            });
          })
        : "";
        setLoader(false)
    } catch (error) {
      const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(() => getContractDetails(contractId ));
    } else {
      setLoader(false)
      console.error("Error fetching contract details:", error);
      throw error;
    }
    }
  }

  function isValidDate(dateStr: string): boolean {
    // Define multiple date formats to check against
    const formats = ["YYYY-MM-DD", "MM/DD/YYYY", "DD/MM/YYYY"];
    
    // Iterate over each format and attempt to parse the date string
    for (let format of formats) {
        if (isValidDateFormat(dateStr, format)) {
            return true; // Return true if any format matches
        }
    }
    
    return false; // Return false if no format matches
}
function isValidDateFormat(dateStr: string, format: string): boolean {
  // Split the format into its components
  const formatParts = format?.split(/[^YMMD]/);
  
  // Split the date string into its components
  const dateParts = dateStr?.split(/[^0-9]/);
  
  // Check if both have the same number of components
  if (formatParts?.length !== dateParts?.length) {
      return false;
  }
  
  // Check each component against the format
  for (let i = 0; i < formatParts?.length; i++) {
      // Check if format part is not a constant part
      if (formatParts[i] !== "YYYY" && formatParts[i] !== "MM" && formatParts[i] !== "DD") {
          return false;
      }
      
      // Check if date part is a number
      if (isNaN(parseInt(dateParts[i]))) {
          return false;
      }
  }
  
  // Check if date parts can be parsed into a valid date
  const yearIndex = formatParts.indexOf("YYYY");
  const monthIndex = formatParts.indexOf("MM");
  const dayIndex = formatParts.indexOf("DD");
  
  const year = parseInt(dateParts[yearIndex]);
  const month = parseInt(dateParts[monthIndex]);
  const day = parseInt(dateParts[dayIndex]);
  
  // Create a new Date object and check validity
  const date = new Date(year, month - 1, day); // month is zero-indexed in Date
  
  return (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
  );
}
const fetchCopilotContractData = async (file) => {
  setLoader(true);
    try {
      const ContractData = await CopilotExtractText(file, GJsonFormFields, "Copilot contract data fetch")
      if (ContractData) {
        const isUpdated = await setContractKeysValues(GJsonFormFields, ContractData, dataText, setdataText, setcounterpartyname, optionsCounterparty, dateDatepicker, setdateDatepicker, dataNote, setdataNote, dataNumber, setdataNumber, getnumbervalue, isValidDate, setShowDurationTextField)
        if (isUpdated) {
          setTimeout(() => {
            setLoader(false)
            SweetalertsApproved("success", "Data fetched successfully");
          }, 3000);
        }
 
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setTimeout(() => {
        setLoader(false)
        SweetalertsApproved("error", "Something went wrong");
      }, 3000);
    }
  }

  const fetchAzureOpenAI= async(file,AzureOpenAIData)=>{
    setLoader(true);
    // openloader();
    try{
      const keyValuePairs = await fetchAzureOpenAIData(file,AzureOpenAIData,GJsonFormFields);
      if (keyValuePairs) {
        const isUpdated= await setContractKeysValues(GJsonFormFields,keyValuePairs,dataText,setdataText,setcounterpartyname,optionsCounterparty,dateDatepicker,setdateDatepicker,dataNote,setdataNote,dataNumber,setdataNumber,getnumbervalue,isValidDate, setShowDurationTextField)
          if(isUpdated){
            setTimeout(() => {
              setLoader(false)
            //   setRotation(false);
            //   Closeloader();
              SweetalertsRequest("success", "Data fetched successfully");
            }, 5000);
          }else{
            setTimeout(() => {
              setLoader(false)
              SweetalertsRequest("success", "Data fetched successfully");
            }, 5000);
          }
  
        }
    }catch(error){
      setLoader(false)
      console.error('Error fetching data:', error);
    //   setTimeout(() => {
    //     setRotation(false);
    //     Closeloader();
    //   }, 5000);
    }
  }

  async function getCounterpartyDetails() {
    const finaltemp = [];
    const endpoint = `${props.siteURL}/_api/web/lists/getbytitle('CLM365CounterParty')/items`;
    const token = localStorage.getItem("CurrentToken");
    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`, // Include token here
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
        },
      });

      if (response.status === 200) {
        // Handle response if necessary (e.g., setEnableShimmer(false));
      }

      const items = response.data.value;
      items.forEach((item) => {
        finaltemp.push({
          key: item.ID,
          text: item?.CounterPartyType,
          value: item?.OrganizationName,
          label: item?.OrganizationName,
          value1: item?.Country,
          Guid_ID: item?.Guid_ID,
          State: item?.State,
        });
      });

      setoptionsCounterparty(finaltemp?.sort((a, b) => a?.label?.localeCompare(b?.label)));
    } catch (error) {
      const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration( getCounterpartyDetails);
    }
      console.error("Error fetching counterparty details:", error);
    }
  }

  function validateApproval(datatype, actualdata, condition, fieldValue) {
    var regExp = /[a-zA-Z]/g;
    let returnflag = false;
    if (datatype == "Text") {
      if (!regExp.test(fieldValue) && !regExp.test(actualdata)) {
        actualdata = parseInt(actualdata) ? parseInt(actualdata) : actualdata;
        fieldValue = parseInt(fieldValue);
      }
    } else if (datatype == "Date") {
      actualdata = moment(actualdata).format("YYYYMMDD") ? moment(actualdata).format("YYYYMMDD") : actualdata;
      fieldValue = moment(fieldValue).format("YYYYMMDD") ? moment(fieldValue).format("YYYYMMDD") : fieldValue;
    } else if (datatype == "Number") {
      actualdata = parseInt(actualdata) ? parseInt(actualdata) : actualdata;
      fieldValue = parseInt(fieldValue);
    }
    switch (condition) {
      case "Equal to":
        actualdata == fieldValue ? (returnflag = true) : returnflag;
        break;
      case "Less than":
        actualdata < fieldValue ? (returnflag = true) : returnflag;
        break;
      case "Greater than":
        actualdata > fieldValue ? (returnflag = true) : returnflag;
        break;
      case "Less than equal":
        actualdata <= fieldValue ? (returnflag = true) : returnflag;
        break;
      case "Greater than equal":
        actualdata >= fieldValue ? (returnflag = true) : returnflag;
        break;
    }
    return returnflag;
  }

  // function PostContractformdata(id) {
  //   var ID = id;
  //   // let guidid = uniqueGUID.toString();
  //   let validationdata = { ...validatestate };
  //   if (selectedChoiceKey == "Indefinite") {
  //     delete validationdata["Contract_End_Date"];
  //   }
  //   if (counterpartyname.length) {
  //     delete validationdata["Counterparty_Name"];
  //   }
  //   let validationSchema = yup.object(validationdata);

  //   // let guidid = uniqueGUID.toString();
  //   let guidid = "insert your GUID";

  //   let fileName;
  //   let requesterdraft;

  //   try {
  //     var itemInfo = {
  //       Contract_Type: contracttypeId,
  //       Business_Unit: businessunitdropvalue,
  //       Contract_Term: selectedChoiceKey,
  //       Draft_Type: drafttypelist,
  //       Status: id == "Draft" ? "Draft" : "Pending",
  //       Counterparty_Name: JSON.stringify(counterpartyname),
  //       Approval_Infos: JSON.stringify(approvalInfo),
  //       AllTaskApproversId: approvalAccess?.length > 0 ? approvalAccess?.flat(2) : "[]",
  //       Legal_UserId: legalAccessUsers?.length > 0 ? legalAccessUsers : "[]",
  //       Guid_ID: guidid,
  //       File_Name: fileName ? fileName : "",
  //       //Activity_Log: JSON.stringify(allActivityLogs),
  //       Request_Type: requesttypevalue,
  //       ActualFileName: requesterdraft,
  //       Remarks: remark,
  //       // Request_Number: RequestNumberSeq,
  //       Contract: contractGUID ? contractGUID : "",
  //       // RequestApproval: RequestApproval,
  //       // DraftApproval: DraftApproval,
  //       RequestApproval:
  //         AutoBusinessApproval && AutoLegalReviewApproval
  //           ? "Completed"
  //           : AutoBusinessApproval
  //             ? "Completed"
  //             : RequestApproval,
  //       DraftApproval:
  //         AutoBusinessApproval && AutoLegalReviewApproval
  //           ? "Completed"
  //           : AutoBusinessApproval
  //             ? "Pending"
  //             : DraftApproval,
  //       ExecutionApproval: "Not Started",
  //       Negotiation: "Not Started",
  //       SOW_Details: MSAGuid != "" ? sowGuid_ListName : "",
  //       Term: JSON.stringify(termPeriodObj),
  //       ...dataText,
  //       ...dataNote,
  //       ...dataNumber,
  //       ...dataChoice2,
  //       __metadata: {
  //         type: "SP.Data.CLM365RequestListItem",
  //       },
  //     };
  //     // Replace with your actual access token
  //     var accessToken = props.tokenvalue;
  //     var header = {
  //       Accept: "application/json;odata=verbose",
  //       "content-type": "application/json;odata=verbose",
  //       // "X-RequestDigest": $("#__REQUESTDIGEST").val(),
  //       Authorization: "Bearer " + accessToken,
  //     };
  //     var apiUrl = `${props.siteURL}` + "/_api/web/lists/getbytitle('CLM365Request')/items";

  //     $.ajax({
  //       url: apiUrl,
  //       type: "POST",
  //       contentType: "application/json;odata=verbose",
  //       data: JSON.stringify(itemInfo),
  //       headers: header,
  //       success: function (data) {
  //         console.log(data);
  //         setLoader(false);
  //       },
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  function PostContractformdata(id, approvalInfo) {
    let ID = id;
    draftid = false;
    setSubmitDisabled(true);
    setspinnerLoading(true)
    let ExecutionApproval="Not Started"
    // setdisableButton(true);
    // getRequestNumberSequence();
    if (![null, undefined, ""].includes(remark) || id == "Draft") {
      hideremarkDialog();
      hideDialogOptional();
      let guidid = uniqueGUID.toString();
      let validationdata = { ...validatestate };
      // if (selectedChoiceKey == "Indefinite") {
      if (selectedTerm == "Indefinite") {
        delete validationdata["Contract_End_Date"];
      }
      if (counterpartyname.length) {
        delete validationdata["Counterparty_Name"];
      }
      if(!DepartmentDetails.SelectedDepartment && (department || "No") === "Yes" &&  id !== "Draft"){
      SweetalertsRequest("error",'Please select department')
      return;
    }

      let validationSchema = yup.object(validationdata);
      validationSchema
        .validate({
          ...dataText,
          ...dataNumber,
          ...dataNote,
          ...dateDatepicker,
          ...dataChoice2,
          ...attachmentFileData,
          ...documentTypesData,
           Contract_Cost: ContractCostData?.selectedAmount
        })
        .then(async () => {
          let flag = false;
          // if (licence_Key == "trial" && activeContractsCount >= 10 && id == "Publish") {
          //   flag = true;
          //   SweetalertsRequest(
          //     "error",
          //     "Contracts count exceeded. You are using the trial version. You can create up to 10 contracts. Consider upgrading to the Standard version for more."
          //   );
          //   setspinnerLoading(false)
          // } else if (licence_Key.toLowerCase() == "p1a" && activeContractsCount >= 30 && id == "Publish") {
          //   flag = true;
          //   // SweetalertsApproved("error", "You are using the Standard version. You can create up to 30 contracts. If you want to create more, try the Plus version.");
          //   SweetalertsRequest(
          //     "error",
          //     "Contracts count exceeded. You are using the Standard version. You can create up to 30 contracts. Consider upgrading to the Plus version for more."
          //   );
          //   setspinnerLoading(false)
          // } else if (licence_Key.toLowerCase() == "p2a" && activeContractsCount >= 60 && id == "Publish") {
          //   flag = true;
          //   // SweetalertsApproved("error", "You are using the Plus version. You can create up to 60 contracts. If you want to create more, try the Premium version.");
          //   SweetalertsRequest(
          //     "error",
          //     "Contracts count exceeded. You are using the Plus version. You can create up to 60 contracts. Consider upgrading to the Premium version for more."
          //   );
          //   setspinnerLoading(false)
          // } else if (licence_Key.toLowerCase() == "p3a" && activeContractsCount >= 120 && id == "Publish") {
          //   flag = true;
          //   // SweetalertsApproved("error", "You are using the Premium version. You can create up to 120 contracts. If you want to create more, try the Enterprise version.");
          //   SweetalertsRequest(
          //     "error",
          //     "Contracts count exceeded. You are using the Premium version. You can create up to 120 contracts. Consider upgrading to the Enterprise version for more."
          //   );
          //   setspinnerLoading(false)
          // } else if (licence_Key.toLowerCase() == "p4a" && activeContractsCount >= 240 && id == "Publish") {
          //   flag = true;
          //   SweetalertsRequest(
          //     "error",
          //     "Contracts count exceeded. You are using the Enterprise version. You can create up to 240 contracts."
          //   );
          //   setspinnerLoading(false)
          // }
          if (!flag) {
            setspinnerLoading(true)
            if (id == "Publish") {
              id = "Pending";
              setLoading(true);
              setButtonSaveText1("");
            } else if (id == "Draft") {
              draftid = true;
              if (drafttypelist == attachyourFile) {
                if (attachFile1?.length > 0) {
                  setLoading1(true);
                  setButtonSaveText("");
                } else {
                  SweetalertsRequest("error", `Please attach file`);
                }
              } else {
                setLoading1(true);
                setButtonSaveText("");
              }
            }

            let guidid = uniqueGUID.toString();

            let fileName;
            let requesterdraft;
            if (drafttypelist != attachyourFile && drafttypelist != "Blank") {
              //"standard template"
              requesterdraft = drafttypelist; // standardTemplate;
            } else if (drafttypelist == attachyourFile) {
              // requesterdraft=attachFile1; //
              if (attachFile1.length > 0) {
                requesterdraft = attachFile1[0][0].props.children[1].props.children;
              }
            }
            if (requesterdraft) {
              fileName = guidid.concat(".", requesterdraft.split(".")[requesterdraft.split(".").length - 1]);
            }
            //console.log(approvalAccess);
            //console.log(legalAccessUsers);
            const d = new Date();

            let taskcreated = true;
            taskJSON =[]; //because of this all tasks are auto approving if one task is auto approve
            approvalInfo.map((ele) => {
              let currentTask = JSON.parse(ele?.TaskData);
              if (taskcreated) {
                if (
                  (currentTask?.Status == "Approved" || currentTask?.Status == "Completed") &&
                  currentTask?.Mandatory
                ) {
                  currentTask?.AssignedToId != null
                    ? currentTask?.AssignedToId.forEach((v) => {
                        approvalAccess.push(v);
                      })
                    : (approvalAccess = []);
                  currentTask?.LegalUserId != null
                    ? currentTask?.LegalUserId.forEach((v) => {
                        legalAccessUsers.push(v);
                      })
                    : (legalAccessUsers = []);
                  if ((approvalAccess?.length > 0 || legalAccessUsers?.length > 0) && currentTask?.Mandatory) {
                    taskJSON.push(currentTask);
                  }
                } else {
                  currentTask?.AssignedToId != null
                    ? currentTask?.AssignedToId.forEach((v) => {
                        approvalAccess.push(v);
                      })
                    : (approvalAccess = []);
                  currentTask?.LegalUserId != null
                    ? currentTask?.LegalUserId.forEach((v) => {
                        legalAccessUsers.push(v);
                      })
                    : (legalAccessUsers = []);
                  if ((approvalAccess?.length > 0 || legalAccessUsers?.length > 0) && currentTask?.Mandatory) {
                    taskJSON.push(currentTask);
                    taskcreated = false;
                  }
                }
              }
            });
            // if (taskJSON[taskJSON?.length - 1]?.TaskName == "Draft Approval") {
            //   RequestApproval = "Completed";
            //   DraftApproval = "Pending";
            // }
            // if (
            //   taskJSON[taskJSON?.length - 1]?.TaskName == "Draft Approval" &&
            //   taskJSON[taskJSON?.length - 1]?.Status == "Completed" &&
            //   draftData?.length != 0
            // ) {
            //   RequestApproval = "Completed";
            //   DraftApproval = "Completed";
            // }
            // if (contracttypename?.filter((i) => i?.guid == contracttypeId?.split("|")[1])?.[0]?.UserGroup?.length) {
            //   //  let groupName= JSON.parse(contracttypename?.filter(i=>i?.guid==contracttypeId?.split("|")[1])?.[0]?.UserGroup)?.key||""
            //   let groupNames = contracttypename
            //     ?.filter((i) => i?.guid == contracttypeId?.split("|")[1])?.[0]
            //     ?.UserGroup.map((i) => i.text);
            //   //  if(groupName&&groupName!=""){
            //   //   let groupID= await getGroupIdByName(groupName);
            //   //   if(groupID){
            //   //     approvalAccess?.push(groupID);
            //   //   }
            //   //  }
            //   if (groupNames && groupNames != "") {
            //     for (let u = 0; u < groupNames.length; u++) {
            //       let groupID = await getGroupIdByName(groupNames[u]);
            //       if (groupID) {
            //         approvalAccess?.push(groupID);
            //       }
            //     }
            //   }
            // }
            const convertedObj=await convertCurrency(ContractCostData?.selectedAmount,ContractCostData?.selectedCurrency,ContractCostData?.settingsCurrency)
         const contractCost={
          ...ContractCostData,
          settingsAmount:convertedObj
         }

            // approvalAccess?.push(...JSON.parse(contracttypename?.filter(i=>i.guid==contracttypeId.split("|")[1])?.[0]?.UserGroup).data.map(i=>i.id))//key
            const Share_With_Others = ShareWith.shareWithSelected?.map(i=> i?.id)
            let finalTemplate = {
              Contract_Type: contracttypeId,
              Business_Unit: businessunitdropvalue,
              Contract_Term: selectedChoiceKey,
              Draft_Type: drafttypelist === 'Select file from Outlook' ? 'Attach your own file' : drafttypelist,
              Status: id == "Draft" ? "Draft" : "Pending",
              Counterparty_Name: JSON.stringify(counterpartyname),
              Approval_Infos: JSON.stringify(approvalInfo),
              AllTaskApproversId: approvalAccess?.length > 0 ? approvalAccess?.flat(2) : [],
              Legal_UserId: legalAccessUsers?.length > 0 ? legalAccessUsers : [],
              Guid_ID: guidid,
              File_Name: fileName ? fileName : "",
              //Activity_Log: JSON.stringify(allActivityLogs),
              Request_Type: requesttypevalue,
              ActualFileName: requesterdraft,
              Remarks: remark,
              // Request_Number: RequestNumberSeq,
              Contract: contractGUID ? contractGUID : "",
              // RequestApproval: RequestApproval,
              // DraftApproval: DraftApproval,
              RequestApproval:
                AutoBusinessApproval && AutoLegalReviewApproval
                  ? "Completed"
                  : AutoBusinessApproval
                    ? "Completed"
                    : RequestApproval,
              DraftApproval:
                AutoBusinessApproval && AutoLegalReviewApproval
                  ? "Completed"
                  : AutoBusinessApproval
                    ? "Pending"
                    : DraftApproval,
              ExecutionApproval: "Not Started",
              Negotiation: "Not Started",
              SOW_Details: MSAGuid != "" ? sowGuid_ListName : "",
              Term: JSON.stringify(termPeriodObj),
              Contract_Cost:JSON.stringify(contractCost||{}),
              Department: DepartmentDetails.SelectedDepartment["key"],
              Share_With_OthersId: Share_With_Others,
              Active:"Yes"
            };
            // console.log(finalTemplate);
            let finalTemplatelib = {
              File_Name: requesterdraft ? requesterdraft : "",
            };
            if (dataText != null) {
              var key;
              for (let value of Object.entries(dataText)) {
                finalTemplate[value[0]] = value[1];
              }
            }
            if (dataNote != null) {
              var key;
              for (let value of Object.entries(dataNote)) {
                finalTemplate[value[0]] = value[1];
              }
            }
            if (dataNumber != null) {
              var key;
              for (let value of Object.entries(dataNumber)) {
                finalTemplate[value[0]] = value[1];
              }
            }
            if (dataChoice2 != null) {
              var key;
              for (let value of Object.entries(dataChoice2)) {
                finalTemplate[value[0]] = value[1];
              }
            }
            if (dateDatepicker != null) {
              var key;
              for (let value of Object.entries(dateDatepicker)) {
                if (
                  // selectedChoiceKey == "Indefinite" &&
                  selectedTerm == "Indefinite" &&
                  value[0] == "Contract_End_Date"
                ) {
                  finalTemplate[value[0]] = "";
                } else {
                  ["Contract_Date", "Contract_End_Date", "Contract_Start_Date"].includes(value[0])
                    ? (finalTemplate[value[0]] = moment(value[1]).format("MM/DD/YYYY"))
                    : (finalTemplate[value[0]] = value[1]);
                }
              }
            }
            // console.log("2033");
            if (attachmentFile != null && attachmentFile?.length) {
              for (let l = 0; l < attachmentFile.length; l++) {
                if (attachmentFile[l]) {
                  let fileGuid = uuid()?.toString();
                  // let finalTemplatelibrary = {
                  //   TaskID: finalTemplate["Guid_ID"],
                  //   File_Name: attachmentFile[l].FileName,
                  //   File_Guid:fileGuid,
                  //   AttachmentIntName:attachmentFile[l]?.IntName,
                  // };
                  // let finalTemp2 = {
                  //   TaskID: finalTemplate["Guid_ID"],
                  //   File_Name: attachremarkFile2[i].name,
                  //   File_Guid:fileGuid,
                  //   File_Content:attachremarkFile2[i],
                  // };
                  // allAttachementFiles.push(finalTemp2);
                  let filename =
                    fileGuid +
                    "." +
                    attachmentFile[l]?.FileName?.split(".")[attachmentFile[l]?.FileName?.split(".")?.length - 1];
                  // addattachmentNameGuids.push(fileGuid);
                  finalTemplate[attachmentFile[l]?.IntName] = filename;
                  attachmentFile[l]["GUID"] = filename;
                  // uploadFileToFolder(
                  //   finalTemplate["Guid_ID"],
                  //   filename,
                  //   attachmentFile[l].FileContent,
                  //   finalTemplatelibrary
                  // );
                }
              }
              // uploadFilesInBatch(attachmentFile, finalTemplate["Guid_ID"])
            }
            if (documentTypeFiles != null && documentTypeFiles?.length > 0) {
              let finalTemplateTemp = {};
              for (let l = 0; l < documentTypeFiles.length; l++) {
                if (documentTypeFiles[l]) {
                  let fileGuid = uuid()?.toString();
                  let filename =
                    fileGuid +
                    "." +
                    documentTypeFiles[l]?.FileName?.split(".")[documentTypeFiles[l]?.FileName?.split(".")?.length - 1];
                  finalTemplateTemp[documentTypeFiles[l]?.IntName] = filename;
                  documentTypeFiles[l]["GUID"] = filename;
                }
              }
              finalTemplateTemp["RequestContract_GuidID"] = finalTemplate["Guid_ID"];
              postDocumentAttachments(finalTemplateTemp);
              // uploadFilesInBatch(documentTypeFiles, finalTemplate["Guid_ID"])
            }

            // console.log("2085");

            // if((attachmentFile&&attachmentFile!=null)||(documentTypeFiles!=null&&documentTypeFiles?.length>0)){
            //   uploadFilesInBatch([...attachmentFile,...documentTypeFiles], finalTemplate["Guid_ID"])
            // }
            let requiredFieldvalidate = [];
            var Errmessage = "A";

            let year = d.getFullYear().toString();
            let month = (d.getMonth() + 1).toString().padStart(2, "0");
            let day = d.getDate().toString().padStart(2, "0");
            let temp = {
              "Business Unit": businessNameValue,
              "Business Unit Code": businessCode,
              "Contract Type": filtercontractName, //contractCode
              "Contract Type Code": contractCode,
              "Department Name": DepartmentDetails.SelectedDepartment["text"],
              "Department Code": DepartmentDetails.SelectedDepartment["code"],
              Year: year,
              "N/A": "",
              DD: day,
              MM: month,
              YYYY: year,
              DDMM: month + day,
              YYYMM: year.slice(2) + month,
              MMDD: month + day,
              DDMMYYYY: day + month + year,
              MMDDYYYY: month + day + year,
              YYYYMMDD: year + month + day,
              Sequence: requestsequencenum,
            };
            //console.log("temp rn", temp);
            //console.log(temp[requestnumbertemp.Businessunit]);
            // console.log(`${temp[requestnumbertemp.Businessunit]}${
            //   temp[requestnumbertemp.Filed1]
            // }
            // ${temp[requestnumbertemp.Contract]}${temp[requestnumbertemp.Filed2]}${
            //   temp[requestnumbertemp.Year]
            // }${temp[requestnumbertemp.Filed3]}${
            //   temp[requestnumbertemp.Sequential]
            // }`);

            // console.log("2126");
            //Request_Number
            RequestNumberSeq = `${
              temp[requestnumbertemp.Businessunit]
                ? temp[requestnumbertemp.Businessunit] + requestnumbertemp.Filed1
                : ""
            }${temp[requestnumbertemp.Contract] ? temp[requestnumbertemp.Contract] + requestnumbertemp.Filed2 : ""}${
              temp[requestnumbertemp.Year] ? temp[requestnumbertemp.Year] + requestnumbertemp.Filed3 : ""
            }${temp[requestnumbertemp.Sequential] || ""}`;
            // finalTemplate["Request_Number"] = RequestNumberSeq;
            
            // console.log(placeholders, "placeholders");
            placeholders = placeholders.map((c) => {
              const temp = { ...c };
              if (c.key == "Contract_Start_Date" || c.key == "Contract_End_Date" || c.key == "Contract_Date") {
                temp.Value = moment(new Date(finalTemplate[c.key])).format("MM/DD/YYYY");
              }
              // else if (c.key == "Contract_Type") {
              //   temp.Value = finalTemplate[c.key]?.split("|")[1];
              // }
              else if (c.key == "Counterparty_Name") {
                let counterParty = JSON.parse(finalTemplate[c.key]);
                let arr = [];
                counterParty?.map((items) => {
                  arr.push(items.OrgName);
                });
                let _fieldvalue = arr?.join(", ");
                temp.Value = _fieldvalue; //finalTemplate[c.key]?.split('|')[0]
              } else {
                temp.Value = finalTemplate[c.key];
              }
              return temp;
            });
            
            let Organization_Name = new Set();
            let Counterparty_Type = new Set();
            let Country = new Set();
            let State = new Set();
            let City = new Set();
            let Zip_Code = new Set();
            let Address_Line_1 = new Set();
            let Address_Line_2 = new Set();
            let Contact_Number = new Set();
            let Email = new Set();
            let Counterparty_Jurisdiction = new Set();

            counterpartyname.forEach((c) => {
              Organization_Name.add(c.OrgName);
              Counterparty_Type.add(c.Counterpartyname);
              Country.add(c.Country);
              State.add(c.State);
              City.add(c.City);
              Zip_Code.add(c.ZipCode);
              Address_Line_1.add(c.Address_Line_1);
              Address_Line_2.add(c.Address_Line_2);
              Contact_Number.add(c.Contact_Number);
              Email.add(c.email);
              Counterparty_Jurisdiction.add(c.OrganizationJurisdiction);
            });
            let finalcounter: any = {};
            //console.log(Organization_Name,"Organization_Name")
            finalcounter.Organization_Name = Array.from(Organization_Name).join(", ");
            finalcounter.Counterparty_Type = Array.from(Counterparty_Type).join(", ");
            finalcounter.Country = Array.from(Country).join(", ");
            finalcounter.State = Array.from(State).join(", ");
            finalcounter.City = Array.from(City).join(", ");
            finalcounter.Zip_Code = Array.from(Zip_Code).join(", ");
            finalcounter.Address_Line_1 = Array.from(Address_Line_1).join(", ");
            finalcounter.Address_Line_2 = Array.from(Address_Line_2).join(", ");
            finalcounter.Contact_Number = Array.from(Contact_Number).join(", ");
            finalcounter.Email = Array.from(Email).join(", ");
            finalcounter.Counterparty_Jurisdiction = Array.from(Counterparty_Jurisdiction).join(", ");
            
            if (finalTemplate.hasOwnProperty("TitleValue")) {
              delete finalTemplate["TitleValue"];
            }
            let _finalorgdetails = {
              Organization_Title: orgDetailsfinal[0]?.Organization_Title ? orgDetailsfinal[0]?.Organization_Title : "",
              Organization_URL: orgDetailsfinal[0]?.Organization_URL ? orgDetailsfinal[0]?.Organization_URL : "",
              Organization_Country: orgDetailsfinal[0]?.Organization_Country
                ? orgDetailsfinal[0]?.Organization_Country
                : "",
              Organization_Address_Line_1: orgDetailsfinal[0]?.Organization_Address_Line_1
                ? orgDetailsfinal[0]?.Organization_Address_Line_1
                : "",
              Organization_Address_Line_2: orgDetailsfinal[0]?.Organization_Address_Line_2
                ? orgDetailsfinal[0]?.Organization_Address_Line_2
                : "",
              Organization_City: orgDetailsfinal[0]?.Organization_City ? orgDetailsfinal[0]?.Organization_City : "",
              Organization_State: orgDetailsfinal[0]?.Organization_State ? orgDetailsfinal[0]?.Organization_State : "",
              Organization_ZipCode: orgDetailsfinal[0]?.Organization_ZipCode
                ? orgDetailsfinal[0]?.Organization_ZipCode
                : "",
              Organization_Website: orgDetailsfinal[0]?.Organization_Website
                ? orgDetailsfinal[0]?.Organization_Website
                : "",
              Organization_Currency: orgDetailsfinal[0]?.Organization_Currency
                ? orgDetailsfinal[0]?.Organization_Currency
                : "",
              Organization_Contact_Number: orgDetailsfinal[0]?.Organization_Contact_Number
                ? orgDetailsfinal[0]?.Organization_Contact_Number
                : "",
              Organization_Jurisdiction: orgDetailsfinal[0]?.Organization_Jurisdiction
                ? orgDetailsfinal[0]?.Organization_Jurisdiction
                : "",
            };
            AllfieldValues = { ...finalTemplate, ...finalcounter, ..._finalorgdetails };
            let lastRequestApproval
            let taskTitle = ""
            if(requestApprovalData?.length>0){
                lastRequestApproval = requestApprovalData[requestApprovalData.length-1]
                taskTitle = Object.values(lastRequestApproval.ApprovalLevel as Record<string, { Title?: string }>)[0]?.Title
              }
            //  console.log(AllfieldValues,"AllfieldValues");
            if ((fileName != null && fileName != undefined) || drafttypelist == "Blank") {
              //  console.log(finalTemplate, "finalTemplate");
              try {
                const token = localStorage.getItem("CurrentToken");
                const updateurl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365Request')/items`;

                const response = await axios.post(updateurl, finalTemplate, {
                  headers: {
                    Accept: "application/json;odata=nometadata",
                    "Content-Type": "application/json;odata=nometadata",
                    "odata-version": "",
                    Authorization: `Bearer ${token}`, // Include the token here
                  },
                });

                const item = response.data;
                // console.log(item);
                // console.log(finalTemplate);

                Contract_Request_Title = finalTemplate["Title"];
                let attachremarkFiles = [];
                if (attachremarkFile2.length > 0 && attachremarkFile2 != undefined) {
                  // let attachremarkFiles=[]
                  for (let i = 0; i < attachremarkFile2.length; i++) {
                    let fileGuid = uuid()?.toString();
                    let finalTemplatelibrary = {
                      TaskID: finalTemplate["Guid_ID"],
                      File_Name: attachremarkFile2[i].name,
                      File_Guid: fileGuid,
                    };
                    let finalTemp2 = {
                      TaskID: finalTemplate["Guid_ID"],
                      File_Name: attachremarkFile2[i].name,
                      File_Guid: fileGuid,
                      File_Content: attachremarkFile2[i],
                    };
                    allAttachementFiles.push(finalTemp2);
                    let filename = fileGuid + "." + attachremarkFile2[i].name.split(".")[1];
                    addattachmentNameGuids.push(fileGuid);

                    let finalTemp3 = {
                      GUID: filename,
                      FileName: attachremarkFile2[i].name,
                      FileContent: attachremarkFile2[i],
                      IntName: "Additional",
                    };
                    attachremarkFiles.push(finalTemp3);
                  }
                }
          
                if((attachremarkFiles&&attachremarkFiles.length>0)||(attachmentFile&&attachmentFile.length>0)||(documentTypeFiles!=null&&documentTypeFiles?.length>0)){
                  await uploadFilesInBatch([...attachremarkFiles,...attachmentFile,...documentTypeFiles], finalTemplate["Guid_ID"])
                }
                if (drafttypelist != attachyourFile && drafttypelist != "Blank") {
                  await getfilebinarydata(
                    AllfieldValues,
                    selectedStandfile, //selectedStandfile,
                    fileName,
                    finalTemplatelib
                  );
                  // saverequesterlistFile(fileName, finalTemplatelib)
                } else if (drafttypelist == attachyourFile) {
                  let finalTemp3 = {
                    TaskID: "",
                    File_Name: draftfiledata[0].name,
                    File_Guid: "",
                    File_Content: draftfiledata[0],
                  };
                  allAttachementFiles.push(finalTemp3);
                  await Updateformfieldvalues(AllfieldValues, selecteddocfile, fileName, finalTemplatelib);
                  // saveFiles(fileName, finalTemplatelib, ID);
                }
                if (id != "Draft") {
                  await updateCurrentSequence();
                }
                RequestNumberSeq2 = `${
                  temp[requestnumbertemp.DepartmentType]
                    ? temp[requestnumbertemp.DepartmentType] +
                      requestnumbertemp.DepartmentField
                    : ""
                }${
                  temp[requestnumbertemp.Businessunit]
                    ? temp[requestnumbertemp.Businessunit] + requestnumbertemp.Field1
                    : ""
                }${
                  temp[requestnumbertemp.Contract] ? temp[requestnumbertemp.Contract] + requestnumbertemp.Field2 : ""
                }${
                  temp[requestnumbertemp.Year] ? temp[requestnumbertemp.Year] + requestnumbertemp.Field3 : ""
                }${requestsequencenum || ""}`;
                const modifiedURL = `${window.location.href.split("#")[0].split(".aspx")[0]}.aspx?TaskID=${finalTemplate["Guid_ID"]}&PanelName=${"RequestActivity"}#/`;
                const placeholders1 = [
                  { key: "Business_Unit", Value: businessNameValue },
                  { key: "Contract_Type", Value: filtercontractName },
                  { key: "Request_Number", Value: RequestNumberSeq2 },
                  // { key: "Title", value: '' },
                  {
                    key: "Originator",
                    Value: props?.currentUser.currentUserName,
                  },
                  {
                    key: "Date",
                    Value: moment(new Date()).format("MM/DD/YYYY"),
                  },
                  {
                    key: "Request_URL",
                    Value: `<a href="${modifiedURL}" onclick="window.open(this.href, 'Snopzer',
                    'left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" >Click here</a>`,
                  },
                  {
                    key: "CLMRequestID",
                    Value: item.Id,
                  },
                ];
                placeholders.push(...placeholders1);
                let sendtoEmail = [props?.currentUser.currentUserEmail];
                // For allActivityLogs
                allActivityLogs = [];
                allMails = {
                  To: sendtoEmail,
                  Cc: [],
                };
                if (id === "Draft") {
                  let activityTemp = await ActivityService.getActivity(
                    "Request Created",
                    placeholders,
                    " ",
                    "",
                    allMails, // sendtoEmail,
                    "Yes" // Email sendingflag. If Yes mail will send else it will not
                  );
                  allActivityLogs.push(activityTemp);
                } else {
                  let activityTemp =await ActivityService.getActivity(
                    "Request Created",
                    placeholders,
                    " ",
                    "",
                    allMails, //sendtoEmail,
                    "Yes"
                  );
                  let activityTempSubmitted =await ActivityService.getActivity(
                    "Request Submitted",
                    placeholders,
                    remark || " ",
                    allAttachementFiles, //addattachmentNameGuids.toString(),
                    allMails, //sendtoEmail,
                    "Yes"
                  );
                  allActivityLogs.push(activityTemp, activityTempSubmitted);
                }
                let updatetemp = {
                  Activity_Log: JSON.stringify(allActivityLogs),
                  Request_Number: id == "Draft" ? " " : RequestNumberSeq2,
                  // Activity_Log: JSON.stringify(allActivityLogs)
                };
                if (taskJSON.length > 0 && id != "Draft") {
                 await createTasksinbatch(taskJSON, placeholders, guidid, item.Id, RequestNumberSeq2);
                } else {
                  //console.log(updatetemp, "updatetemp", "line number 1975");
                  // let web = new Web(ContextService.GetUrl());
                  // const list = web.lists.getByTitle("CLM365Request");
                  // const itemid = list.items.getById(item.Id);
                  // itemid.update(updatetemp).then((result) => {
                  //   //console.log(`Item has been updated`);
                  // });
                  const updateUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365Request')/items(${item.Id})`;
                  
                  const response = await axios.patch(updateUrl, updatetemp, {
                    headers: {
                      Accept: "application/json;odata=nometadata",
                      "Content-Type": "application/json;odata=nometadata",
                      "odata-version": "",
                      Authorization: `Bearer ${token}`,
                      "If-Match": "*", // Used for optimistic concurrency control, "*"
                    },
                  }).then((c)=>{
                    console.log("Item successfully updated", response);
                  }).catch((c)=>{
                    console.log(c)
                  })
                }
                // if (id != "Draft") {
                //   updateCurrentSequence();
                // }

                if (ID == "Draft") {
                  // SweetalertsRequest(
                  //   "success",
                  //   `${strings.SuccessmessagePostdata}`
                  // );
                  // setSaved(true);
                  if (drafttypelist == "Blank") {
                    SweetalertsRequest("success", "Draft saved successfully!");
                  }
                  setTimeout(() => {
                    setLoading1(false);
                    setButtonSaveText(strings.SaveasDraft);
                    // props.setRefetch((c) => c + 1);
                    // props.getdata('0');
                    // setSaved(false);
                    props.setisNewContract(false)
                    props?.setCreateRequestAI(false)
                    props.setisOpenRequest(true)
                  }, 2000);
                  // setTimeout(() => {
                  //   props.closepanel();
                  // }, 3000);
                }

                if (
                  (id == "Publish" || id == "Pending" || ID == "Publish") &&
                  ((drafttypelist != "Standard Template" && drafttypelist == attachyourFile) ||
                    drafttypelist == "Blank")
                ) {
                  if (drafttypelist == "Blank") {
                    SweetalertsRequest("success", 'Request Submitted Successfully');
                  }
                  setTimeout(() => {
                    setLoading(false);
                    setButtonSaveText1(strings.Submit);
                    // setSaved(false);
                    // props.setRefetch((c) => c + 1);
                    // props.getdata('0');
                    props.setisNewContract(false)
                    props?.setCreateRequestAI(false)
                    props.setisOpenRequest(true)
                  }, 2000);
                  // setTimeout(() => {
                  //   props.closepanel();
                  // }, 3000);
                  // setSaved(true);
                }
                // .then(()=>{
                //      //console.log(item.Id,"(item.Id)","2131")
                // });
                setspinnerLoading(false)
              } catch (error) {
                setspinnerLoading(false)
                console.error("Error posting data:", error);
              }
            } else {
            
              SweetalertsRequest("error", `${strings.Pleaseattachfile}`);

              // seterrormsgAttach(true);
              // setTimeout(() => {
              //   seterrormsgAttach(false);
              // }, 3000);
              if (id == "Draft") {
                setTimeout(() => {
                  setLoading1(false);
                  setButtonSaveText(strings.SaveasDraft);
                }, 2000);
              }

              if (id == "Publish" || id == "Pending") {
                setTimeout(() => {
                  setLoading(false);
                  setButtonSaveText1(strings.Submit);
                }, 2000);
              }
              setspinnerLoading(false)
            }
          }
        })
        .catch((err) => {
        
          seterrormsgStatus(true);
          // !FileImported ? seterrormsgValue("attachment of the file is mandatory for Attach your own file"):SuccessMsg();
          // seterrormsgValue(err.errors[0]);
          SweetalertsRequest("error", err.errors[0]);
          setTimeout(() => {
            seterrormsgStatus(false);
          }, 3000);
          setspinnerLoading(false)
          ////console.log("error", err);
        });
    } else {
   
      Sweetalertremarksdailoge("error", `${strings.Enterremark}`);
      setspinnerLoading(false)
      // seterrormsgRemark(true);
      // setTimeout(() => {
      //   seterrormsgRemark(false);
      // }, 3000);
    }
  }



  function openDialogRemark() {
    let requesterdraft1;
    approvalAccess = [];
    legalAccessUsers = [];
    if (drafttypelist != attachyourFile && drafttypelist != "Blank") {
      requesterdraft1 = drafttypelist; //standardTemplate;
    } else if (drafttypelist == attachyourFile) {
      // requesterdraft=attachFile1; //
      if (attachFile1?.length > 0) {
        requesterdraft1 = attachFile1[0][0].props.children[1].props.children;
      }
    }
    if ((requesterdraft1 != null && requesterdraft1 != undefined) || drafttypelist == "Blank") {
      let validationdata = { ...validatestate };
      if (!DepartmentDetails.SelectedDepartment && (department || "No") === "Yes") {
        SweetalertsRequest("error", 'Please select department')
        return
      } 
      if (selectedChoiceKey == "Indefinite") {
        delete validationdata["Contract_End_Date"];
      }
      if (counterpartyname.length) {
        delete validationdata["Counterparty_Name"];
      }
      // console.log(validationdata, "validationdata");
      // console.log(validatestate, "validatestate");
      //console.log(dataText,"dataText");
      let validationSchema = yup.object(validationdata);
      validationSchema
        .validate({
          ...dataText,
          ...dataNumber,
          ...dataNote,
          ...dateDatepicker,
          ...dataChoice2,
          ...attachmentFileData,
          ...documentTypesData,
          Contract_Cost: ContractCostData?.selectedAmount
        })
        .then(async () => {
          // setLoading(true);
          setButtonSaveText1("");
          let approvalStage = "Business Approval";
          let approvaldataontype = [];
          businessData = allApprovalData.filter((ele) => {
            if (ele.ApprovalStage === "Business Approval") {
              const matchingContractType = ele.Contracttype?.filter((item) => {
                return item.guid === contracttypeId?.split("|")[1] || item.key == "All";
              });

              const matchingBusinessUnit = ele.BusinessUnit?.filter((item) => {
                return item.guid === businessunitdropvalue || item.key == "All";
              });
               const selectedCounterParty=counterpartyname?.map(e=>e?.key)||[]

              const matchingCounterparty = ele?.Counterparty?.filter(item => 

                selectedCounterParty?.includes(item?.key) || item.key === "All"

              );

              return (
                matchingContractType.length > 0 && matchingCounterparty?.length&&
                (matchingBusinessUnit.length > 0 ||
                  (businessUnit == "No" && matchingBusinessUnit.length == 0))
              );
            }
            return false;
          });

          draftData = allApprovalData.filter((ele) => {
            if (ele.ApprovalStage === "Draft Approval") {
              const matchingContractType = ele.Contracttype?.filter((item) => {
                return item.guid === contracttypeId?.split("|")[1] || item.key == "All";
              });

              const matchingBusinessUnit = ele.BusinessUnit?.filter((item) => {
                return item.guid === businessunitdropvalue || item.key == "All";
              });

              return (
                matchingContractType.length > 0 &&
                (matchingBusinessUnit.length > 0 ||
                  (businessUnit == "No" && matchingBusinessUnit.length == 0))
              );
            }
            return false;
          });
          executionData=allApprovalData.filter((ele) => {
             if (ele.ApprovalStage !== "Execution Approval") return false;
             const triggerAutomatically= ele?.ApprovalLevel?.[1]?.TriggerAutomatically || "No";
             if (triggerAutomatically !== "Yes") return false;

             const matchingContractType = ele.Contracttype?.filter((item) => {
                return item.guid === contracttypeId?.split("|")[1]|| item.key == "All";
              });

              const matchingBusinessUnit = ele.BusinessUnit?.filter((item) => {
                return item.guid === businessunitdropvalue|| item.key == "All";
              });
              const selectedCounterParty=counterpartyname?.map(e=>e?.key)||[]
              const matchingCounterparty = ele?.Counterparty?.filter(item => 
                selectedCounterParty?.includes(item?.key) || item.key === "All"
              );

              return (
                matchingContractType.length > 0 &&matchingCounterparty?.length&&
                (matchingBusinessUnit.length > 0 ||(businessUnit=='No'&&matchingBusinessUnit.length==0))
              );
          });
          requestApprovalData = allApprovalData.filter((ele) => {
            if (ele.ApprovalStage === "Request Approval") {
              const matchingContractType = ele.Contracttype?.filter((item) => {
                return item.guid === contracttypeId?.split("|")[1] || item.key == "All";
              });

              const matchingBusinessUnit = ele.BusinessUnit?.filter((item) => {
                return item.guid === businessunitdropvalue || item.key == "All";
              });

              const selectedCounterParty=counterpartyname?.map(e=>e?.key)||[]
              const matchingCounterparty = ele?.Counterparty?.filter(item => 
                selectedCounterParty?.includes(item?.key) || item.key === "All"
              );

              const matchingDepartment = ele.Department?.filter((item) => {
                return item.code === DepartmentDetails.SelectedDepartment["code"] || item.key == "All";
              });

              return (
                matchingContractType.length > 0 && matchingCounterparty?.length&&
                (matchingBusinessUnit.length > 0 ||(businessUnit=='No'&&matchingBusinessUnit.length==0)) &&
                (matchingDepartment.length > 0 || (department !== "Yes" && matchingDepartment.length==0))
              );
            }
            return false;
          });
          let ActualFieldValue = "";
          let condtionsReturns = [];
          let SkipLevel2Stage = ""
          let SkipLevel2Index = 1
          let AutoApproveStatus = false;
          let skiplevel1 = false;
          let skiplevel2andmore = false;
          let approverData = "";
          taskJSON = [];
          DraftTaskData=[]
          let previousStepApproved = false;
          let legalUserId = [];
          var id = "Publish";
          let approval_Info = [];
          let approvalInfo = [];
          setApprovalInfo([]);
          isOptional = false;
          RequestApproval = "Pending";
          DraftApproval = "Not Started";
          // approvaldataontype = businessData;
          let lastbusinessData
          if(requestApprovalData?.length>0){
            lastbusinessData = requestApprovalData[requestApprovalData.length-1]
          }
          else if(!requestApprovalData?.length){
                const DefaultData = allApprovalData?.filter((ele)=> ele?.DefaultFlow == "Yes")
                lastbusinessData = DefaultData.length ? DefaultData[0] : {}
            }
            approvaldataontype = lastbusinessData ? [lastbusinessData] : [];
          let draftCheck = true;
          let executionCheck=true;
          if (approvaldataontype.length != 0) {
            approvaldataontype = approvaldataontype.map((item: any) => {
  if (!item?.ApprovalLevel) return item;

  const filteredApprovalLevel = ContractApprovalEnabled
    ? Object.fromEntries(
        Object.entries(item.ApprovalLevel).filter(
          ([_, level]) => (level as any)?.Title !== "Contract Approval"
        )
      )
    : item.ApprovalLevel;

  return {
    ...item,
    ApprovalLevel: filteredApprovalLevel,
  };
});
            // await Promise.all(approvaldataontype.map(async (item, index) => {
            for (let index = 0; index < approvaldataontype.length; index++) {
              const item = approvaldataontype[index];

              if (!AutoApproveStatus) {
                AutoBusinessApproval = false;
                AutoLegalReviewApproval = false;
                condtionsReturns = [];
                // approvalInfo = [];
                setApprovalInfo([]);
                if (draftCheck == true) {
                  taskJSON = [];
                }
                for (var i = 1; i <= Object.keys(item.ApprovalLevel).length; i++) {
                  approverData = item.ApprovalLevel[i]["Approvers"];
                  let DocumentTypeFields = item?.ApprovalLevel[i]["DocumentTypeFields"];
                  AutoApproveStatus = false;
                  skiplevel1 = false;
                   if(SkipLevel2Stage !== item.ApprovalLevel[i].Title){
                    skiplevel2andmore = false
                  }
                  // skiplevel2andmore = false;
                  legalUserId = [];
                   item.ApprovalLevel[i]?.["Conditions"]?.length && item.ApprovalLevel[i]?.["Conditions"]?.map((ele)=>{
                  if (ele?.["type"] =="Auto Approve" && !skiplevel2andmore) {
                    ele?.["ContractField"]?.forEach((currentCond) => {
                      let MainOperator = currentCond.Condition ? currentCond.Condition : "";
                      let currentType = "Text";
                      if (dataText[currentCond.FieldInternalName]) {
                        ActualFieldValue = dataText[currentCond.FieldInternalName];
                        currentType = "Text";
                      } else if (dateDatepicker[currentCond.FieldInternalName]) {
                        ActualFieldValue = dateDatepicker[currentCond.FieldInternalName];
                        currentType = "Date";
                      }
                       ActualFieldValue=currentCond.FieldInternalName=="Contract_Cost"?ContractCostData?.selectedAmount:ActualFieldValue
                      const counterPartyNames = counterpartyname.length ? counterpartyname.map(item=>item.OrgName) : []
                      ActualFieldValue=currentCond.FieldInternalName=="Counterparty_Name"? counterPartyNames.includes(currentCond?.FieldValue) ? currentCond?.FieldValue : ActualFieldValue : ActualFieldValue
                      //ActualFieldValue = dataText[currentCond.FieldInternalName] ? dataText[currentCond.FieldInternalName] : (dateDatepicker[currentCond.FieldInternalName] ? dateDatepicker[currentCond.FieldInternalName] : "" )
                      condtionsReturns = []
                      condtionsReturns.push(
                        validateApproval(currentType, ActualFieldValue, currentCond.Operator, currentCond.FieldValue)
                      );
                      if (MainOperator != "") {
                        switch (MainOperator) {
                          case "and":
                            if (
                              // condtionsReturns[condtionsReturns.length - 2] &&
                              // condtionsReturns[condtionsReturns.length - 1]
                              AutoApproveStatus && condtionsReturns?.length && condtionsReturns[condtionsReturns.length - 1]
                            ) {
                              condtionsReturns = [];
                              AutoApproveStatus = true;
                            } else {
                              condtionsReturns = [];
                              AutoApproveStatus = false;
                            }
                            break;
                          case "or":
                            if (
                              // condtionsReturns[condtionsReturns.length - 2] ||
                              // condtionsReturns[condtionsReturns.length - 1]
                               AutoApproveStatus || (condtionsReturns?.length && condtionsReturns[condtionsReturns.length - 1])
                            ) {
                              condtionsReturns = [];
                              AutoApproveStatus = true;
                            } else {
                              condtionsReturns = [];
                              AutoApproveStatus = false;
                            }
                            break;
                        }
                      } else {
                        AutoApproveStatus = condtionsReturns.every((item) => item === true) ? true : false;
                        if (AutoApproveStatus) {
                          if (
                            item.ApprovalLevel[i]?.["Conditions"]?.[0]?.["type"] == "Auto Approve" &&
                            item.ApprovalLevel[i]?.["Title"] === "Business Approval"
                          ) {
                            AutoBusinessApproval = true;
                          }
                          if (
                            item.ApprovalLevel[i]?.["Conditions"]?.[0]?.["type"] == "Auto Approve" &&
                            item.ApprovalLevel[i]?.["Title"] === "Legal Review"
                          ) {
                            AutoLegalReviewApproval = true;
                          }
                            if (item.ApprovalLevel[i]?.["Conditions"]?.[0]?.["type"] ==
                              "Auto Approve" && item.ApprovalLevel[i]?.["Title"] === "Legal Review") {
                              AutoLegalReviewApproval = true;
                            }
                        }
                      }
                    }); 
                  } else if (ele?.["type"] =="Skip L1" &&!AutoApproveStatus && !skiplevel2andmore) {
                    ele?.[ "ContractField"].forEach((currentCond) => {
                      if (!skiplevel1) {
                        let MainOperator = currentCond.Condition ? currentCond.Condition : "";
                        let currentType = "Text";
                        if (dataText[currentCond.FieldInternalName]) {
                          ActualFieldValue = dataText[currentCond.FieldInternalName];
                          currentType = "Text";
                        } else if (dateDatepicker[currentCond.FieldInternalName]) { 
                          ActualFieldValue = dateDatepicker[currentCond.FieldInternalName];
                          currentType = "Date";
                        }
                        //ActualFieldValue = dataText[currentCond.FieldInternalName] ? dataText[currentCond.FieldInternalName] : (dateDatepicker[currentCond.FieldInternalName] ? dateDatepicker[currentCond.FieldInternalName] : "" )
                        ActualFieldValue=currentCond.FieldInternalName=="Contract_Cost"?ContractCostData?.selectedAmount:ActualFieldValue
                        const counterPartyNames = counterpartyname.length ? counterpartyname.map(item=>item.OrgName) : []
                        ActualFieldValue=currentCond.FieldInternalName=="Counterparty_Name"? counterPartyNames.includes(currentCond?.FieldValue) ? currentCond?.FieldValue : ActualFieldValue : ActualFieldValue
                        condtionsReturns = []
                        condtionsReturns.push(
                          validateApproval(currentType, ActualFieldValue, currentCond.Operator, currentCond.FieldValue)
                        );
                        if (MainOperator != "") {
                          switch (MainOperator) {
                            case "and":
                              if (
                                // condtionsReturns[condtionsReturns.length - 2] &&
                                // condtionsReturns[condtionsReturns.length - 1]
                                skiplevel1 && condtionsReturns?.length && condtionsReturns[condtionsReturns.length - 1]
                              ) {
                                condtionsReturns = [];
                                skiplevel1 = true;
                              } else {
                                condtionsReturns = [];
                                skiplevel1 = false;
                              }

                              break;
                            case "or":
                              if (
                                // condtionsReturns[condtionsReturns.length - 2] ||
                                // condtionsReturns[condtionsReturns.length - 1]
                                skiplevel1 || (condtionsReturns?.length && condtionsReturns[condtionsReturns.length - 1])
                              ) {
                                condtionsReturns = [];
                                skiplevel1 = true;
                              } else {
                                condtionsReturns = [];
                                skiplevel1 = false;
                              }
                              break;
                          }
                        } else {
                          skiplevel1 = condtionsReturns.every((item) => item === true) ? true : false;
                        }
                      }
                    });
                    if (ele?.["type"] =="Skip L2 & more" && !skiplevel2andmore) {
                     ele?.["ContractField"].forEach((currentCond) => {
                      if (!skiplevel2andmore) {
                        let MainOperator = currentCond.Condition ? currentCond.Condition : "";
                        let currentType = "Text";
                        if (dataText[currentCond.FieldInternalName]) {
                          ActualFieldValue = dataText[currentCond.FieldInternalName];
                          currentType = "Text";
                        } else if (dateDatepicker[currentCond.FieldInternalName]) {
                          ActualFieldValue = dateDatepicker[currentCond.FieldInternalName];
                          currentType = "Date";
                        }
                        //ActualFieldValue = dataText[currentCond.FieldInternalName] ? dataText[currentCond.FieldInternalName] : (dateDatepicker[currentCond.FieldInternalName] ? dateDatepicker[currentCond.FieldInternalName] : "" )
                        ActualFieldValue=currentCond.FieldInternalName=="Contract_Cost"?ContractCostData?.selectedAmount:ActualFieldValue
                        const counterPartyNames = counterpartyname.length ? counterpartyname.map(item=>item.OrgName) : []
                        ActualFieldValue=currentCond.FieldInternalName=="Counterparty_Name"? counterPartyNames.includes(currentCond?.FieldValue) ? currentCond?.FieldValue : ActualFieldValue : ActualFieldValue                        //ActualFieldValue = dataText[currentCond.FieldInternalName] ? dataText[currentCond.FieldInternalName] : (dateDatepicker[currentCond.FieldInternalName] ? dateDatepicker[currentCond.FieldInternalName] : "" )
                        condtionsReturns = []
                        condtionsReturns.push(
                          validateApproval(currentType, ActualFieldValue, currentCond.Operator, currentCond.FieldValue)
                        );
                        if (MainOperator != "") {
                          switch (MainOperator) {
                            case "and":
                              if (
                              //   condtionsReturns[condtionsReturns.length - 2] &&
                              //   condtionsReturns[condtionsReturns.length - 1]
                              skiplevel2andmore && condtionsReturns?.length && condtionsReturns[condtionsReturns.length - 1]
                              ) {
                                condtionsReturns = [];
                                skiplevel2andmore = true;
                                SkipLevel2Stage = item.ApprovalLevel[i]?.TaskTitle
                                SkipLevel2Index = i
                              } else {
                                condtionsReturns = [];
                                skiplevel2andmore = false;
                              }

                              break;
                            case "or":
                              if (
                                // condtionsReturns[condtionsReturns.length - 2] ||
                                // condtionsReturns[condtionsReturns.length - 1]
                                skiplevel2andmore || (condtionsReturns?.length && condtionsReturns[condtionsReturns.length - 1])
                              ) {
                                condtionsReturns = [];
                                skiplevel2andmore = true;
                                SkipLevel2Stage = item.ApprovalLevel[i]?.TaskTitle
                                SkipLevel2Index = i
                              } else {
                                condtionsReturns = [];
                                skiplevel2andmore = false;
                              }
                              break;
                          }
                        } else {
                          skiplevel2andmore = condtionsReturns.every((item) => item === true) ? true : false;
                          if(skiplevel2andmore) {
                            SkipLevel2Stage = item.ApprovalLevel[i]?.TaskTitle
                            SkipLevel2Index = i
                          }
                        }
                      }
                    });
                  }
                }})
                  let approvedByEmail = [];
                  let approvedByIds = [];
                  let approvedByName = [];

                  let userswithselectedrole;
                  //console.log(ContextService.GetCurrentUser());
                  let currentUserInfo = Users?.filter((item) => {
                    return item.Id === props.currentUserID
                  });
                  if (currentUserInfo?.[0]?.Manager?.EMail) {
                    let checkuserexists = Users?.filter((item) => {
                      return item.Id === currentUserInfo?.[0]?.Manager?.ID;
                    });
                    if (checkuserexists.length > 0) {
                      businessuserManager = currentUserInfo?.[0]?.Manager;
                      let currentManagerInfo = Users?.filter((item) => {
                        return item.Id === businessuserManager?.ID;
                      });
                      if (currentManagerInfo?.[0]?.Manager?.EMail) {
                        let checkexists = Users?.filter((item) => {
                          return item.Id === currentManagerInfo?.[0]?.Manager?.ID;
                        });
                        if (checkexists.length > 0) {
                          businessuserManagerManger = currentManagerInfo?.[0]?.Manager;
                        }
                      }
                    }
                  }
                  let jobTitleval = approverData?.[0]?.["role"] ? approverData?.[0]?.["role"] : "";
                  if (jobTitleval) {
                    userswithselectedrole = Users?.filter((item) => {
                      return item.Role === jobTitleval;
                    });
                  }

                  let approvedbyAll = "No";
                  let checkedApprovers = [];
                  if (item.ApprovalLevel[i]?.["Title"] == "Legal Review") {
                    if (approverData?.[0]?.["checkEmpName"]) {
                      approvedByEmail = approverData?.[0]?.["approveremail"]
                        ? approverData?.[0]?.["approveremail"]
                        : [];

                      approvedByIds = approverData?.[0]?.["approverid"] ? approverData?.[0]?.["approverid"] : [];

                      approvedByName = approverData?.[0]?.["approverName"] ? approverData?.[0]?.["approverName"] : [];
                      workflowempapproversemail = approvedByEmail;
                      workflowempapproversids = approvedByIds;
                      workflowempapproversname = approvedByName;
                      checkedApprovers.push("EmployeeName");
                      approvedByIds?.forEach((useriD) => {
                        legalUserId.push(useriD);
                      });
                    }
                    if (approverData?.[0]?.["checkEmpManager"] && businessuserManager?.EMail) {
                      legalUserId.push(businessuserManager?.ID);
                      approvedByEmail.push(businessuserManager?.EMail);
                      approvedByName.push(businessuserManager?.Title);
                      checkedApprovers.push("EmployeeManager");
                    }
                    if (approverData?.[0]?.["checkEmpManagersManager"] && businessuserManagerManger?.EMail) {
                      legalUserId.push(businessuserManagerManger?.ID);
                      approvedByEmail.push(businessuserManagerManger?.EMail);
                      approvedByName.push(businessuserManagerManger?.Title);
                      checkedApprovers.push("EmployeeManagersManager");
                    }
                    if (approverData?.[0]?.["checkJobTitle"]) {
                      userswithselectedrole?.forEach((ele) => {
                        legalUserId.push(ele.Id);
                        approvedByEmail.push(ele?.email);
                        approvedByName.push(ele?.text);
                      });
                      checkedApprovers.push("Role");
                    }
                    approvedByIds = legalUserId;
                  } else {
                    if (approverData?.[0]?.["checkEmpName"]) {
                      approvedByEmail = approverData?.[0]?.["approveremail"]
                        ? approverData?.[0]?.["approveremail"]
                        : [];

                      approvedByIds = approverData?.[0]?.["approverid"] ? approverData?.[0]?.["approverid"] : [];

                      approvedByName = approverData?.[0]?.["approverName"] ? approverData?.[0]?.["approverName"] : [];
                      checkedApprovers.push("EmployeeName");
                    }
                    if (approverData?.[0]?.["checkEmpManager"] && businessuserManager?.EMail) {
                      approvedByIds.push(businessuserManager?.ID);
                      approvedByEmail.push(businessuserManager?.EMail);
                      approvedByName.push(businessuserManager?.Title);
                      checkedApprovers.push("EmployeeManager");
                    }
                    if (approverData?.[0]?.["checkEmpManagersManager"] && businessuserManagerManger?.EMail) {
                      approvedByIds.push(businessuserManagerManger.ID);
                      approvedByEmail.push(businessuserManagerManger.EMail);
                      approvedByName.push(businessuserManagerManger.Title);
                      checkedApprovers.push("EmployeeManagersManager");
                    }
                    if (approverData?.[0]?.["checkJobTitle"]) {
                      userswithselectedrole?.forEach((ele) => {
                        approvedByIds.push(ele.Id);
                        approvedByEmail.push(ele?.email);
                        approvedByName.push(ele?.text);
                      });
                      checkedApprovers.push("Role");
                    }
                  }

                  if (item.ApprovalLevel[i]?.["AllorAny"] == "All") {
                    approvedbyAll = "Yes";
                  }
                  approvedByIds = approvedByIds?.length > 0 ? approvedByIds : null;
                  // taskDueDate.setDate(
                  //   taskDueDate.getDate() +
                  //   parseInt(item.ApprovalLevel[i]?.["DueDays"])
                  // );
                  // if(workingdays)
                  //let taskDueDate = addBusinessDays(new Date(), parseInt(item.ApprovalLevel[i]?.["DueDays"]), workingdays);
                  let taskDueDate = new Date();
                  if (item.ApprovalLevel[i].DaysType === 'Business days'){
                    taskDueDate = CalcuateBusinessDays(item.ApprovalLevel[i].DueDays,item.ApprovalLevel[i].Days);
                  } else{
                  taskDueDate.setDate(
                    taskDueDate.getDate() +
                      parseInt(item.ApprovalLevel[i]?.["DueDays"])
                  );
                  }
                  if (AutoApproveStatus) {
                    let taskCreated = false;
                    let taskguidid = uuid()?.toString();
                    id = id == "Pending" ? id : (id = "Approved");
                    if (i == 1 || previousStepApproved) {
                      taskJSON.push({
                        TaskName: item.ApprovalLevel[i]?.["Title"],
                        TaskTitle: item.ApprovalLevel[i]?.["TaskTitle"]
                          ? item.ApprovalLevel[i]?.["TaskTitle"]
                          : item.ApprovalLevel[i]?.["Title"],
                        RequestType: requesttypevalue,
                        BusinessUnit: businessunitdropvalue,
                        ContractType: contracttypeId,
                        Status: "Completed",
                        TaskGudId: taskguidid,
                        LegalUserId: legalUserId?.length > 0 ? legalUserId : [],
                        AssignedToId: approvedByIds?.length > 0 ? approvedByIds : [],
                        AssignedToEmail: approvedByEmail?.length > 0 ? approvedByEmail : [],
                        DueDate: taskDueDate,
                        OnRejection: item.ApprovalLevel[i]?.["OnRejection"],
                        DueDays: item.ApprovalLevel[i]?.["DueDays"],
                        EditCheck: item.ApprovalLevel[i]?.["EditCheck"],
                        HoldCheck: item.ApprovalLevel[i]?.["HoldCheck"],
                        DraftUpload: item.ApprovalLevel[i]?.["DraftUpload"],
                        Optional: item.ApprovalLevel[i]?.["Optional"],
                        ApproverName: approvedByName ? approvedByName : [],
                        Mandatory: true,
                        ApprovedByAll: approvedbyAll,
                        AutoApproved:true,
                        Conditions: item.ApprovalLevel[i]?.["Conditions"]
                      });
                      // taskCreated = true;
                      previousStepApproved = true;
                    }
                    approvalInfo.push({
                      Level: "Level" + i,
                      ApprovedByAll: approvedbyAll,
                      DocumentTypeFields: DocumentTypeFields,
                      AutoApprove: "Yes",
                      Skipped: "No",
                      ApprovalFlow: item.WorkflowId,
                      EmpName: approverData?.[0]?.["checkEmpName"],
                      EmpManager: approverData?.[0]?.["checkEmpManager"],
                      EmpManagersManager: approverData?.[0]?.["checkEmpManagersManager"],
                      JobTitle: approverData?.[0]?.["checkJobTitle"],
                      ManualApproveReq: previousStepApproved ? "No" : "Yes",
                      TaskApprovedDate: previousStepApproved ? new Date() : "",
                      TaskAssignedToRole: jobTitleval,
                      TaskGudId: taskguidid,
                      taskCreated: taskCreated,
                      TaskData: JSON.stringify({
                        TaskName: item.ApprovalLevel[i]?.["Title"],
                        TaskTitle: item.ApprovalLevel[i]?.["TaskTitle"]
                          ? item.ApprovalLevel[i]?.["TaskTitle"]
                          : item.ApprovalLevel[i]?.["Title"],
                        RequestType: requesttypevalue,
                        BusinessUnit: businessunitdropvalue,
                        ContractType: contracttypeId,
                        TaskGudId: taskguidid,
                        // OnPreviousLvLApproval: previousStepApproved ? "Approved" : "AutoAppprove", //Auto Approved for the if the task step get manual approved then this task should get approved immediately as its autoapproved
                        OnPreviousLvLApproval: "AutoAppprove",
                        LegalUserId: legalUserId?.length > 0 ? legalUserId : [],
                        AssignedToId: approvedByIds?.length > 0 ? approvedByIds : [],
                        AssignedToEmail: approvedByEmail?.length > 0 ? approvedByEmail : [],
                        DueDate: taskDueDate,
                        // Status: previousStepApproved ? "Completed" : "Not Started",
                        Status: "Completed",
                        OnRejection: item.ApprovalLevel[i]?.["OnRejection"],
                        DueDays: item.ApprovalLevel[i]?.["DueDays"],
                        EditCheck: item.ApprovalLevel[i]?.["EditCheck"],
                        HoldCheck: item.ApprovalLevel[i]?.["HoldCheck"],
                        DraftUpload: item.ApprovalLevel[i]?.["DraftUpload"],
                        Optional: item.ApprovalLevel[i]?.["Optional"],
                        ApproverName: approvedByName ? approvedByName : [],
                        Mandatory: true,
                        ApprovedByAll: approvedbyAll,
                      }),
                      Conditions: item.ApprovalLevel[i]?.["Conditions"]
                    });
                  } else if (skiplevel1) {
                    id = id == "Pending" ? id : (id = "Approved");
                    if (i == 1) {
                      previousStepApproved = true;
                    }
                    let taskguidid = uuid()?.toString();
                    approvalInfo.push({
                      Level: "Level" + i,
                      ApprovedByAll: approvedbyAll,
                      DocumentTypeFields: DocumentTypeFields,
                      AutoApprove: "No",
                      Skipped: "Yes",
                      ApprovalFlow: item.WorkflowId,
                      EmpName: approverData?.[0]?.["checkEmpName"],
                      EmpManager: approverData?.[0]?.["checkEmpManager"],
                      EmpManagersManager: approverData?.[0]?.["checkEmpManagersManager"],
                      JobTitle: approverData?.[0]?.["checkJobTitle"],
                      ManualApproveReq: "No",
                      TaskApprovedDate: new Date(),
                      TaskAssignedToRole: jobTitleval,
                      TaskGudId: taskguidid,
                      taskCreated: false,
                      TaskData: JSON.stringify({
                        TaskName: item.ApprovalLevel[i]?.["Title"],
                        TaskTitle: item.ApprovalLevel[i]?.["TaskTitle"]
                          ? item.ApprovalLevel[i]?.["TaskTitle"]
                          : item.ApprovalLevel[i]?.["Title"],
                        RequestType: requesttypevalue,
                        BusinessUnit: businessunitdropvalue,
                        ContractType: contracttypeId,
                        TaskGudId: taskguidid,
                        OnPreviousLvLApproval: previousStepApproved ? "Approved" : "AutoSkipped", //Auto Approved for the if the task step get manual approved then this task should get approved immediately as its autoSkipped
                        LegalUserId: legalUserId?.length > 0 ? legalUserId : [],
                        AssignedToId: approvedByIds?.length > 0 ? approvedByIds : [],
                        AssignedToEmail: approvedByEmail?.length > 0 ? approvedByEmail : [],
                        DueDate: taskDueDate,
                        Status: previousStepApproved ? "Completed" : "Not Started",
                        OnRejection: item.ApprovalLevel[i]?.["OnRejection"],
                        DueDays: item.ApprovalLevel[i]?.["DueDays"],
                        EditCheck: item.ApprovalLevel[i]?.["EditCheck"],
                        HoldCheck: item.ApprovalLevel[i]?.["HoldCheck"],
                        DraftUpload: item.ApprovalLevel[i]?.["DraftUpload"],
                        Optional: item.ApprovalLevel[i]?.["Optional"],
                        Mandatory: false,
                        ApprovedByAll: approvedbyAll,
                        AutoApprove: false,
                        skiplevel1: true,
                        skiplevel2andmore: false,
                      }),
                      Conditions: item.ApprovalLevel[i]?.["Conditions"],
                    });
                  } else if (skiplevel2andmore && SkipLevel2Stage == item.ApprovalLevel[i].Title && i>SkipLevel2Index) {
                    id = id == "Pending" ? id : (id = "Approved");

                    if (i >= 2) {
                      previousStepApproved = true;
                    }
                    let taskguidid = uuid().toString();
                    approval_Info.push({
                      Level: "Level" + i,
                      ApprovedByAll: approvedbyAll,
                      DocumentTypeFields: DocumentTypeFields,
                      AutoApprove: "No",
                      Skipped: "Yes",
                      ApprovalFlow: item.WorkflowId,
                      EmpName: approverData?.[0]?.["checkEmpName"],
                      EmpManager: approverData?.[0]?.["checkEmpManager"],
                      EmpManagersManager: approverData?.[0]?.["checkEmpManagersManager"],
                      JobTitle: approverData?.[0]?.["checkJobTitle"],
                      ManualApproveReq: "No",
                      TaskApprovedDate: new Date(),
                      TaskAssignedToRole: jobTitleval,
                      TaskGudId: taskguidid,
                      taskCreated: false,
                      TaskData: JSON.stringify({
                        TaskName: item.ApprovalLevel[i]?.["Title"],
                        TaskTitle: item.ApprovalLevel[i]?.["TaskTitle"]
                          ? item.ApprovalLevel[i]?.["TaskTitle"]
                          : item.ApprovalLevel[i]?.["Title"],
                        RequestType: requesttypevalue,
                        BusinessUnit: businessunitdropvalue,
                        ContractType: contracttypeId,
                        TaskGudId: taskguidid,
                        OnPreviousLvLApproval: previousStepApproved ? "Approved" : "AutoSkipped", //Auto Approved for the if the task step get manual approved then this task should get approved immediately as its autoSkipped
                        LegalUserId: legalUserId?.length > 0 ? legalUserId : [],
                        AssignedToId: approvedByIds?.length > 0 ? approvedByIds : [],
                        AssignedToEmail: approvedByEmail?.length > 0 ? approvedByEmail : [],
                        DueDate: taskDueDate,
                        Status: previousStepApproved ? "Completed" : "Not Started",
                        OnRejection: item.ApprovalLevel[i]?.["OnRejection"],
                        DueDays: item.ApprovalLevel[i]?.["DueDays"],
                        EditCheck: item.ApprovalLevel[i]?.["EditCheck"],
                        HoldCheck: item.ApprovalLevel[i]?.["HoldCheck"],
                        DraftUpload: item.ApprovalLevel[i]?.["DraftUpload"],
                        Optional: item.ApprovalLevel[i]?.["Optional"],
                        ApproverName: approvedByName ? approvedByName : "",
                        Mandatory: true,
                        ApprovedByAll: approvedbyAll,
                      }),
                     Conditions: item.ApprovalLevel[i]?.["Conditions"]
                    });
                  } else {
                    id = "Pending";
                    let skippedflag = "No";
                    if (i >= 2 && skiplevel2andmore) {
                      id = "Approved";
                      skippedflag = "Yes";
                    }
                    let taskCreated = false;
                    let taskguidid = uuid().toString();
                    if (i == 1 && !skiplevel1) {
                      // taskJSON.push({
                      //   TaskName: item.ApprovalLevel[i]?.["Title"],
                      //   TaskTitle: item.ApprovalLevel[i]?.["TaskTitle"]
                      //     ? item.ApprovalLevel[i]?.["TaskTitle"]
                      //     : item.ApprovalLevel[i]?.["Title"],
                      //   RequestType: requesttypevalue,
                      //   BusinessUnit: businessunitdropvalue,
                      //   ContractType: contracttypeId,
                      //   TaskGudId: taskguidid,
                      //   Status: "Not Started",
                      //   LegalUserId: legalUserId?.length > 0 ? legalUserId : [],
                      //   AssignedToId: approvedByIds?.length > 0 ? approvedByIds : [],
                      //   AssignedToEmail: approvedByEmail?.length > 0 ? approvedByEmail : [],
                      //   DueDate: taskDueDate,
                      //   OnRejection: item.ApprovalLevel[i]?.["OnRejection"],
                      //   DueDays: item.ApprovalLevel[i]?.["DueDays"],
                      //   EditCheck: item.ApprovalLevel[i]?.["EditCheck"],
                      //   HoldCheck: item.ApprovalLevel[i]?.["HoldCheck"],
                      //   DraftUpload: item.ApprovalLevel[i]?.["DraftUpload"],
                      //   Optional: item.ApprovalLevel[i]?.["Optional"],
                      //   ApproverName: approvedByName ? approvedByName : "",
                      //   Mandatory: false,
                      //   ApprovedByAll: approvedbyAll,
                      // });
                      taskCreated = true;
                    } else if (previousStepApproved && skippedflag != "Yes") {
                      // taskJSON.push({
                      //   TaskName: item.ApprovalLevel[i]?.["Title"],
                      //   TaskTitle: item.ApprovalLevel[i]?.["TaskTitle"]
                      //     ? item.ApprovalLevel[i]?.["TaskTitle"]
                      //     : item.ApprovalLevel[i]?.["Title"],
                      //   RequestType: requesttypevalue,
                      //   BusinessUnit: businessunitdropvalue,
                      //   ContractType: contracttypeId,
                      //   TaskGudId: taskguidid,
                      //   Status: "Not Started",
                      //   LegalUserId: legalUserId?.length > 0 ? legalUserId : [],
                      //   AssignedToId: approvedByIds?.length > 0 ? approvedByIds : [],
                      //   AssignedToEmail: approvedByEmail?.length > 0 ? approvedByEmail : [],
                      //   DueDate: taskDueDate,
                      //   OnRejection: item.ApprovalLevel[i]?.["OnRejection"],
                      //   DueDays: item.ApprovalLevel[i]?.["DueDays"],
                      //   EditCheck: item.ApprovalLevel[i]?.["EditCheck"],
                      //   HoldCheck: item.ApprovalLevel[i]?.["HoldCheck"],
                      //   DraftUpload: item.ApprovalLevel[i]?.["DraftUpload"],
                      //   Optional: item.ApprovalLevel[i]?.["Optional"],
                      //   ApproverName: approvedByName ? approvedByName : "",
                      //   Mandatory: true,
                      //   ApprovedByAll: approvedbyAll,
                      // });
                      taskCreated = true;
                    }
                    if (item.ApprovalLevel[i]?.["Optional"]) {
                      isOptional = true;
                    }
                    approvalInfo.push({
                      Level: "Level" + i,
                      ApprovedByAll: approvedbyAll,
                      DocumentTypeFields: DocumentTypeFields,
                      AutoApprove: "No",
                      Skipped: "No",
                      ApprovalFlow: item.WorkflowId,
                      EmpName: approverData?.[0]?.["checkEmpName"],
                      EmpManager: approverData?.[0]?.["checkEmpManager"],
                      EmpManagersManager: approverData?.[0]?.["checkEmpManagersManager"],
                      JobTitle: approverData?.[0]?.["checkJobTitle"],
                      ManualApproveReq: "Yes",
                      TaskApprovedDate: previousStepApproved ? new Date() : "",
                      TaskAssignedToRole: jobTitleval,
                      TaskGudId: taskguidid,
                      taskCreated: taskCreated,
                      LegalUserId: legalUserId?.length > 0 ? legalUserId : null,
                      TaskData: JSON.stringify({
                        TaskName: item.ApprovalLevel[i]?.["Title"],
                        TaskTitle: item.ApprovalLevel[i]?.["TaskTitle"]
                          ? item.ApprovalLevel[i]?.["TaskTitle"]
                          : item.ApprovalLevel[i]?.["Title"],
                        RequestType: requesttypevalue,
                        BusinessUnit: businessunitdropvalue,
                        ContractType: contracttypeId,
                        TaskGudId: taskguidid,
                        OnPreviousLvLApproval: previousStepApproved ? "Approved" : "AutoAppprove", //Auto Approved for the if the task step get manual approved then this task should get approved immediately as its autoapproved
                        LegalUserId: legalUserId?.length > 0 ? legalUserId : [],
                        AssignedToId: approvedByIds?.length > 0 ? approvedByIds : [],
                        AssignedToEmail: approvedByEmail?.length > 0 ? approvedByEmail : [],
                        DueDate: taskDueDate,
                        Status: "Not Started",
                        OnRejection: item.ApprovalLevel[i]?.["OnRejection"],
                        DueDays: item.ApprovalLevel[i]?.["DueDays"],
                        EditCheck: item.ApprovalLevel[i]?.["EditCheck"],
                        HoldCheck: item.ApprovalLevel[i]?.["HoldCheck"],
                        DraftUpload: item.ApprovalLevel[i]?.["DraftUpload"],
                        Optional: item.ApprovalLevel[i]?.["Optional"],
                        Mandatory: true,
                        ApproverName: approvedByName ? approvedByName : "",
                        ApprovedByAll: approvedbyAll,
                      }),
                    });
                    previousStepApproved = false;
                  }
                }
              }
              // if (
              //   index == approvaldataontype.length - 1 &&
              //   taskJSON?.filter((i) => i?.Status != "Completed")?.length == 0 &&
              //   draftCheck == true
              // ) {
              //   draftCheck = false;
              //   AutoApproveStatus = false;
              //   approvaldataontype.push(...draftData);
              //   console.log("approvalInfo", approvalInfo);
              //   approvalInfo = [];
              // }
            }
                  
          } else {
            RequestApproval = "Completed";
          }

          setApprovalInfo(approvalInfo);
          if (isOptional) {
            // getroledata();
            setloadApprovalsInfos(true);
            showDialogOptional();
            setLoading(false);
            setButtonSaveText1("Submit");
          } else {
            // showremarkDialog();
            PostContractformdata("Publish", approvalInfo);
            setLoading(false);
            setButtonSaveText1("Submit");
          }
        })
        .catch((err) => {
          seterrormsgStatus(true);
          // !FileImported ? seterrormsgValue("attachment of the file is mandatory for Attach your own file"):SuccessMsg();
          // seterrormsgValue(err.errors[0]);
          SweetalertsRequest("error", err.errors[0]);
          setTimeout(() => {
            seterrormsgStatus(false);
            setspinnerLoading(false)
          }, 3000);
          ////console.log("error", err);
        });
    } else {
      if (drafttypelist == "") {
        SweetalertsRequest("error", "Select Draft Type");
       
      } else {
        SweetalertsRequest("error", `${strings.Pleaseattachfile}`);
      }
      setspinnerLoading(false)

      // seterrormsgAttach(true);
      // setTimeout(() => {
      //   seterrormsgAttach(false);
      // }, 3000);
    }
  }

  const onAttachmentChange1 = (ev) => {
    if (ev.target.files.length > 0) {
      setselecteddocfile(ev.target.files[0]);
      draftfiledata.push(ev.target.files[0]);
      //console.log(ev.target.files[0], "ev.target.files[0]");
      // let varlnth = attachFile2.length;
      let varlnth = 0;
      setatt1 = [];
      setatt = [];
      for (var i = 0; i < ev.target.files.length; i++) {
        let id = varlnth++;
        setatt.push(ev.target.files[i]);
        setatt1.push([
          <div className={"Attatchemntdiv"} title={ev.target.files[i].name} style={{ marginTop: "6px",width:'100%' }}>
            <span className={"Attatcmenticons"}>
              <Icon
                styles={{
                  root: {
                    marginTop: "3px",
                    marginRight: "5px",
                    marginLeft: "5px",
                  },
                }}
                iconName="TextDocument"
              ></Icon>
            </span>
            <span className={"Attatchmentext1"}>{ev.target.files[i].name}</span>
            <Link
              onClick={() => {
                deleteattach(id);
              }}
              style={{ marginLeft: "auto",paddingRight:'5px' }}
            >
              {/* <span
                className="ms-Icon ms-Icon--Cancel"
                aria-hidden="true"
                // className={"Attachmentdelete"}
                style={{ marginRight: "10px" }}
              >
                X
              </span> */}
           <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>
            </Link>
          </div>,
        ]);
      }
      setattachFile1(setatt1);
      setattachFile2(setatt);
      setFileImported(true);
      //setattachFile2(ev.target.files);
    } else {
      setattachFile2(null);
      setFileImported(false);
      //setattachFile2(null);
    }
  };
  function deleteattach(id) {
    setFileImported(false);
    setatt1 = [];
    setatt.splice(id, 1);
    ////console.log(setatt);
    for (var i = 0; i < setatt.length; i++) {
      let id = i;
      setatt1.push([
        <div>
          <Icon iconName="TextDocument"></Icon>
          <span>{setatt[i].name}</span>
          <Link
            onClick={() => {
              deleteattach(id);
            }}
            style={{paddingRight:'5px'}}
          >
            {/* <span
              className="ms-Icon ms-Icon--Cancel"
              aria-hidden="true"
              style={{ marginLeft: "10px", position: "relative", top: "5px" }}
            >
              X
            </span> */}
          <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>

            {/* <IconButton
            // className={"info"}
            iconProps={{ iconName: "Cancel" }}
          ></IconButton> */}
          </Link>
        </div>,
      ]);
    }
    // delete setatt[id];
    // ////console.log(setatt);
    // setattachFile(setatt);
    // setattachFilename(setatt1);
    setAttachYourOwnFile(false)
    setattachFile1(setatt1);
    setattachFile2(setatt);
  }

  function postDocumentAttachments(finalTemplate: any) {
    const url = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365DocumentAttachment')/items`;

    axios
      .post(url, finalTemplate, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "Content-type": "application/json;odata=nometadata",
          "odata-version": "",
        },
      })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          // Handle successful response
          console.log("Item posted successfully:", response.data);
          return response.data;
        } else {
          console.error("Unexpected response:", response.status);
        }
      })
      .catch((error) => {
        console.error("Error posting document attachment:", error);
      });
  }


//   import JSZip from "jszip";
// import { parseStringPromise } from "xml2js";
 

 
  async function Updateformfieldvalues(AllfieldValues, binary, fileName, finalTemplatelib) {

  
    if (fileName.split(".")[fileName.split(".").length - 1].toLowerCase() == "pdf") {
      saveFiles(fileName, finalTemplatelib, binary);
    } else {

      const zip = new JSZip();
      await zip
        .loadAsync(binary)
        .then(async (zip: any) => {
          //console.log("standdardtemp file loadAsync() then:Test 6");
          return zip
            .file("word/document.xml")
            .async("string")
            .then(async (documentXml) => {
              // console.log(documentXml, "documentXml");
              // xmlDoc.getElementsByTagName("w:body")[0].childNodes[0].getElementsByTagName("w:name")[0].parentNode.getElementsByTagName("w:textInput")[0].childNodes[0].setAttribute("w:val","11111")
              const pattern = /<w:fldChar w:fldCharType="begin"[^>]*>.*?<w:fldChar w:fldCharType="end"[^>]*\/>/g;
              let arr: any = documentXml.match(pattern);
              //   console.log(arr, "arr");
              arr?.map((element: any) => {
                // for (let index = 0; index < arr.length; index++) {
                //   const element = arr[index];
                // var fields: any = ["Field_4", "Field2", "Field3", "Field4"];
                const nameMatch = element.match(/name="(.*?)"/);
                //  console.log(nameMatch,"nameMatch")
                if (nameMatch) {
                  //‎
                  //console.log(nameMatch[1], "nameMatch[1]");
                  //let fieldIntName = nameMatch[1];
                  // let _internalField=(nameMatch[1]).split('_')[(nameMatch[1]).split('_').length -1];
                  let _internalField = nameMatch[1].split("_").slice(0, -1).join("_");
                  // console.log(_internalField, "_internalField");
                  //console.log(_internalField, "_internalField");
                  const filteredData = Object.keys(AllfieldValues)
                    .filter((key) => key === _internalField)
                    .reduce((obj, key) => {
                      obj[key] = AllfieldValues[key];
                      return obj;
                    }, {});
                  // console.log(filteredData, "filteredData");
                  // if (fields.includes(nameMatch[1])) {
                  if (Object.entries(filteredData).length) {
                    //  console.log(filteredData[_internalField], "nameMatch[1]");
                    // let textInputValue = element.match(
                    //   /<w:textInput><w:type w:val="text" \/><w:default w:val="(.*?)" \/><w:format w:val="None" \/><\/w:textInput>/g
                    // )[0];
                    let textInputValue = element.match(
                        /<w:textInput>(?:<w:type w:val="text"\s*\/?>)?<w:default w:val="(.*?)"\s*\/?><w:format w:val="None"\s*\/?><\/w:textInput>/g
                      )?.[0];
                    //  let textInputValue= await match.match(/<w:textInput><w:default w:val="(.*?)"\/><w:format w:val="None"\/><\/w:textInput>/g)[0]
                    // Update the value of the form field control
                    //   var xmlDoc:any = new DOMParser().parseFromString(textInputValue, 'application/xml');
                    // //console.log(xmlDoc)
                    // const regex = /<w:textInput><w:default w:val="(.+?)"\/><\/w:textInput>/;
                    // const regex =
                    //   /<w:textInput><w:type w:val="text" \/><w:default w:val="(.*?)" \/><w:format w:val="None" \/><\/w:textInput>/;
                    const regex = /<w:textInput>(?:<w:type w:val="text"\s*\/>)?<w:default w:val="(.*?)"\s*\/><w:format w:val="None"\s*\/><\/w:textInput>/;
                    const match1 = textInputValue.match(regex);
                    // console.log(match1,"match1");
                    // console.log(match1[1], "${match1[1]}");
                    let _fieldvalue = "";
                    let _fieldvalueTest =
                      /^(Sun|Mon|Tue|Wed|Thu|Fri|Sat)\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{2}\s\d{4}\s\d{2}:\d{2}:\d{2}\sGMT[+-]\d{4}\s\([\w\s]+\)$/.test(
                        filteredData[_internalField]
                      );
                    if (_internalField == "Counterparty_Name") {
                      // let _value = (filteredData[_internalField]).split('|');
                      // _fieldvalue = _value[0];
                      let counterParty = JSON.parse(filteredData[_internalField]);
                      let arr = [];
                      counterParty?.map((items) => {
                        arr.push(items.OrgName);
                      });
                      _fieldvalue = arr?.join(", ");
                      // console.log(_fieldvalue,"_fieldvalue")
                      // _fieldvalue = arr[0];
                    } else if (_internalField == "Contract_Type") {
                      // let _value = (filteredData[_internalField]).split('|');
                      // _fieldvalue = _value[0];
                      let Contracttype = filteredData[_internalField].split("|");
                      //console.log(Contracttype, "Contracttype");
                      _fieldvalue = currentContractName[Contracttype[1]];
                      //console.log(_fieldvalue, "_fieldvalue");
                    } else if (_internalField == "Business_Unit") {
                      // let _value = (filteredData[_internalField]).split('|');
                      // _fieldvalue = _value[0];
                      let BusinessUnitFinal = filteredData[_internalField];
                      _fieldvalue = currentbusUnitName[BusinessUnitFinal] || "";
                      //console.log(_fieldvalue, "_fieldvalue");
                    } else {
                      _fieldvalue = _fieldvalueTest
                        ? moment(new Date(filteredData[_internalField])).format("MM/DD/YYYY")
                        : filteredData[_internalField];
                      // _fieldvalueTest=false;
                    }
                    // documentXml = documentXml.replaceAll(
                    //   textInputValue.split(`<w:textInput><w:type w:val="text" /><w:default w:val=`)[1].split(` /><w:format w:val="None" /></w:textInput>`),
                    //   `<w:textInput><w:type w:val="text" /><w:default w:val="${_fieldvalue}" /><w:format w:val="None" /></w:textInput>`
                    // );
                    // 2
                    // documentXml = documentXml.replaceAll(
                    //   textInputValue.split(`<w:textInput><w:type w:val="text" /><w:default w:val=`)[1].split(` /><w:format w:val="None" /></w:textInput>`),
                    //   _fieldvalue
                    // );
                    //     console.log(match1[1]," ",_fieldvalue);
                    //     console.log(  "<w:default w:val=\""+match1[1], "      ",
                    //     "<w:default w:val=\""+ _fieldvalue
                    //  )
                    //  console.log(  ">"+match1[1],"       ",
                    //  ">"+ _fieldvalue )
                    documentXml = documentXml.replaceAll(
                      '<w:default w:val="' + match1[1],
                      '<w:default w:val="' + _fieldvalue
                    );
                    documentXml = documentXml.replaceAll(">" + match1[1], ">" + _fieldvalue);
                    // documentXml = documentXml.replaceAll(
                    //   textInputValue,
                    //   `<w:textInput><w:type w:val="text" /><w:default w:val="${_fieldvalue}" /><w:format w:val="None" /></w:textInput>`
                    // );
                    // documentXml = documentXml.replaceAll(
                    //   `<w:r><w:rPr \/><w:t xml:space="preserve">${match1[1]}</w:t></w:r><w:r>`,
                    //   `<w:r><w:rPr \/><w:t xml:space="preserve">${_fieldvalue}</w:t></w:r><w:r>`
                    // );
                    // Return the original match if the form field control is not found
                    //documentXml = documentXml.replace("FORMTEXT","");
                  }
                }
              });
              //  console.log(documentXml,  "return documentXml then:Test 7");
              return documentXml;
            });
        })
        .then((documentXml: any) => {
          // console.log(documentXml, "  then documentXml then:Test 8");
          var updatedContentBlob = new Blob([documentXml], {
            type: "text/xml",
          });
          zip.file("word/document.xml", updatedContentBlob);
          zip.generateAsync({ type: "blob" }).then(function (blob: any) {
            //console.log("   downloadDocx() then:Test 8");
            downloadDocx(blob, "updated_document.docx");
          });
        })
        .catch((err) => {
          console.error(err);
        });
    }
    function downloadDocx(blob: any, filename1: any) {
      const file = new File([blob], fileName, {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      // saveAs(file);
      //console.log("fileuploaded");
      //console.log("   saveFiles() then:Test 9");
      saveFiles(fileName, finalTemplatelib, file);
    }
  }
  async function saveFiles(fileName, finalTemplatelib, fileContent) {
    // let web = new Web(ContextService.GetUrl());
    //console.log(fileContent, "fileContent");
    //console.log("saveFiles(fileName) then:Test 10");
    let web = new Web(ContextService.GetUrl());
    // var url = this.context.pageContext.web.serverRelativeUrl;
    if (fileName == null && fileName == undefined) {
      console.log('props.getDatafromRequesterList')
      // props.getDatafromRequesterList();
    } else {

      try {
        const token = localStorage.getItem("CurrentToken");
        const rootFolderUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365RequestDraft')/rootfolder`;
        const response = await axios.get(rootFolderUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        const rootFolder = response.data;

 
        
      if(response.data.ServerRelativeUrl){

        const folderUrl = response.data.ServerRelativeUrl;
        
 
            const uploadFileUrl = `${ContextService.GetUrl()}/_api/web/getfolderbyserverrelativeurl('${folderUrl}')/files/add(overwrite=true, url='${fileName}')`;
          
            try {
              // Send the POST request to upload the file
              const uploadFileResponse = await axios.post(uploadFileUrl, fileContent, {
                headers: {
                  Authorization: `Bearer ${token}`,
                  Accept: "application/json",
                  "Content-Type": "application/octet-stream"  // Set content type to binary stream
                }
              });
              // console.log(`File ${fileName} uploaded successfully:`, uploadFileResponse.data);
          if(uploadFileResponse.data){
            if (draftid) {
              SweetalertsRequest("success", "Draft saved successfully!");
            } else {
              SweetalertsRequest("success", "Request submitted successfully");
            }
            setspinnerLoading(false)
            setTimeout(() => {
              setLoading(false);
              setButtonSaveText1("Submit");
              // setSaved(false);
              // props.setRefetch((c) => c + 1);
              // props.getdata('0');
              props.setisNewContract(false)
              props.setCreateRequestAI(false)
              props.setisOpenRequest(true)
            }, 2000);
            // setTimeout(() => {
            //   props.closepanel();
            // }, 3000);
          }
         
            } catch (error) {
              console.error(`Error uploading file ${fileName}:`, error);
            }
    }
        
      } catch (error) {
        console.log(error)
      }
      // web.lists
      //   .getByTitle("CLM365RequestDraft")
      //   .select("Title", "RootFolder/ServerRelativeUrl")
      //   .expand("RootFolder")
      //   .get()
      //   .then((response) => {
      //     //console.log("saveFiles(reponse ) then:Test 11");
      //     web
      //       .getFolderByServerRelativeUrl(response.RootFolder.ServerRelativeUrl)
      //       .files.add(fileName, fileContent, true)
      //       .then((f) => {
      //         f.file.getItem().then((item) => {
      //           //console.log("saveFiles(update lib ) then:Test 12");
      //           // item.update(finalTemplatelib);// Do not add any update code as this further. Please check with Bharath.k if any. It will cause to create multiple version history
      //           if (draftid) {
      //             SweetalertsRequest("success", "Draft saved successfully!");
      //           } else {
      //             SweetalertsRequest("success", "Request Submitted Message");
      //           }
      //           setTimeout(() => {
      //             setLoading(false);
      //             setButtonSaveText1("Submit");
      //             // setSaved(false);
      //             props.setRefetch((c) => c + 1);
      //             // props.getdata('0');
      //           }, 2000);
      //           setTimeout(() => {
      //             props.closepanel();
      //           }, 3000);
      //         });
      //       });
      //   })
      //   .catch((error) => {
      //     //console.log(error, "error");
      //     //setError(true);
      //     setTimeout(() => {
      //       messageDismiss();
      //     }, 5000);
      //   });
    }
  }

  //updateCurrentSequence
  function updateCurrentSequence() {
    let finalTemplate;
    if (requestnumbertemp.editindex != undefined && requestnumbertemp.editindex != null) {
      let incrementedValue = parseInt(requestsequencenum) + 1;
      let resultAsString = incrementedValue.toString();
      const tempArr = [...RequestSequenceValue];
      const currentData = {
        ...tempArr[requestnumbertemp.editindex],
        // BusinessUnitType: businessunitdropvalue,
        CurrentSequence: resultAsString,
      };
      tempArr[requestnumbertemp.editindex] = currentData;
      requestsequencenum = (parseInt(requestsequencenum) + 1).toString();
      finalTemplate = {
        RequestSequence: JSON.stringify(tempArr),
        LastRequestSequence: requestsequencenum,
      };
    } else {
      requestsequencenum = (parseInt(requestsequencenum) + 1).toString();
      finalTemplate = {
        LastRequestSequence: requestsequencenum,
      };
    }

    // function updateGeneralListItem(generalListId: string, finalTemplate: any) {
    const _url = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365General')/items('${generalListId}')`;
    const token = localStorage.getItem("CurrentToken");
    axios
      .post(_url, finalTemplate, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "Content-type": "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
          "IF-MATCH": "*", // Required for SharePoint to indicate updates
          "X-HTTP-Method": "MERGE", // Specifies that this is a MERGE operation
        },
      })
      .then((response) => {
        if (response.status === 204) {
          console.log("Successfully updated.");
        } else {
          console.warn("Unexpected response status:", response.status);
        }
      })
      .catch((error) => {
        console.error("Error updating the item:", error);
      });
    // }
  }


  async function createTasksinbatch( 
    data,
    dataplaceholder,
    requestId,
    itemid,
    reqNumber) {
      const sendtoEmail = [props?.currentUser.currentUserEmail];
      let batchlength = 0;

      let Reqstatus = ""
      let Request_Approval = ""
      let Draft_Approval = ""
      let Execution_Approval = ""
      let TaskIndex = 0
      for (const task of data) {
      dataplaceholder = [];
      dataplaceholder.push(...placeholders);
     
        for (let k = 0; k < task?.AssignedToId?.length; k++) {
          const assignedUser = Users?.find((user) => user?.Id == task?.AssignedToId[k]);
          if (assignedUser?.UserStatus === "Inactive") {
            const userIndex = task?.AssignedToId?.indexOf(task?.AssignedToId[k]);
            if (userIndex !== -1) {
              const newApprover = Users?.find((user) => user?.Id === assignedUser?.AssignTo);
              task.ApproverName[userIndex] = newApprover?.text || "";
              task.AssignedToId[userIndex] =  assignedUser?.AssignTo || "";
            }
          }
        }

        let  stage= "";
        if (businessData.length !== 0) {
          stage= "Business Approval";
        } else if (draftData.length !== 0) {
          stage= "Draft Approval";
        }else if(executionData?.length!==0){
          stage= "Execution Approval";
        }
      if(task[task?.length-1]?.TaskName == 'Draft Approval'&&draftData?.length != 0)
      {
        stage = "Draft Approval";
      }
      if(task[task?.length-1]?.TaskName == 'Execution Approval'&&executionData?.length != 0){
        stage = "Execution Approval";
      }
       
          const isAllUsersApproved = task?.AssignedToId?.map(id => ({ id, isApproved: false }));
      
          const taskTemplate={
            Title: task.TaskTitle,
            ContractType: task.ContractType,
            RequestType: task.RequestType,
            Task_Type: task.TaskName,
            TaskStage: stage,
            BusinessUnit: task.BusinessUnit,
            Status: task.Status,
            DueDate: task.DueDate,
            AssignedToId:task.AssignedToId||"[]",
            // AssignedToId: { results: task.AssignedToId?.flat(2) || [] },
            RequestGuid: requestId,
            Contract_Request_Title: Contract_Request_Title,
            TaskGuid: task.TaskGudId || "",
            Optional: task.Optional,
            Other_Actions: JSON.stringify({
              OnRejection: task.OnRejection,
              DueDays: task.DueDays,
              EditCheck: task.EditCheck,
              HoldCheck: task.HoldCheck,
              DraftUpload: task.DraftUpload,
            }),
            ApprovedByAll: task.ApprovedByAll === "Yes" ? JSON.stringify(isAllUsersApproved) : JSON.stringify([]),
            LevelStage : task.TaskName,
          };

     
        try {
           if(["Business Approval"].includes(task.TaskName)){
              Reqstatus = "Pending"
              Request_Approval = "Pending"
              Draft_Approval = "Not Started"
              Execution_Approval = "Not Started"
            }else if(["Legal Review"].includes(task.TaskName)){
              Reqstatus = "Legal Review"
              Request_Approval = "Completed"
              Draft_Approval = "Pending"
              Execution_Approval = "Not Started"
            }else if(["Draft Approval"].includes(task.TaskName)){
              Reqstatus = "Legal Review"
              Request_Approval = "Completed"
              Draft_Approval = "Pending"
              Execution_Approval = "Not Started"
            }else if(["Execution Approval", "eSign", "Publish"].includes(task.TaskName)){
              Reqstatus = "Pending"
              Request_Approval = "Completed"
              Draft_Approval = "Completed"
              Execution_Approval = "Pending"
            }else if(["Contract Approval"].includes(task.TaskName)){
              Reqstatus = "Pending"
              Request_Approval = "Completed"
              Draft_Approval = "Completed"
              Execution_Approval = "Not Started"
            }
             if(!["Contract Approval"].includes(task.TaskName)){
          const item = await postTaskInList(taskTemplate);
          batchlength++;
    

      const modifiedURL = `${window.location.href.split("#")[0].split(".aspx")[0]}.aspx?TaskID=${task?.TaskGudId}&PanelName=${"Comments"}#/`;
      const existingKeyIndex = dataplaceholder.findIndex((item) => item.key === "Request_URL");
      if (existingKeyIndex !== -1) {
        dataplaceholder[existingKeyIndex].Value = `<a href="${modifiedURL}" style="text-decoration: none;" onclick="window.open(this.href, 'Snopzer',
        'left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" >Click here</a>`;
      } else {
        dataplaceholder.push({
          key:"Request_URL",Value:`<a href="${modifiedURL}" style="text-decoration: none;" onclick="window.open(this.href, 'Snopzer',
          'left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" >Click here</a>`
        },);
      }
      // const joinedValues = task?.ApproverName.join(', ')
      const placeholders1 = [
        { key: "Assigned_To", Value: task?.ApproverName?.join(', ') },
        {key:"CLMTaskID",Value:item?.ID}
      ];
      dataplaceholder.push(...placeholders1);
      if (task.Status == "Completed") {
        const placeholders2 = [
          {
            key: "Originator",
            Value: task?.ApproverName,
          },
        ];
        TaskIndex++
        dataplaceholder.push(...placeholders2);
        allMails={
          To:sendtoEmail,
          Cc:[],
        }
      var activityTemp =await ActivityService.getActivity(
          task?.TaskName,
          dataplaceholder,
          " ",
          "",
          allMails,//sendtoEmail,
          "No"
        );
        allActivityLogs.push(activityTemp);
         const placeholders3 = [
          {
            key: "Originator",
            Value: task["OnPreviousLvLApproval"] == "AutoAppprove" ?  "System" : task?.ApproverName
          },
        ];
        dataplaceholder.push(...placeholders3);

        let activitylogKey;
        switch (task?.TaskName) {
          case "Business Approval":
            activitylogKey = "Business Approved";
            break;
          case "Additional Task":
            activitylogKey = "Additional Task Approved";
            break;
          case "Legal Review":
            activitylogKey = "Legal Review Approved";
            break;
          case "Draft Approval":
            activitylogKey = "Draft Approved"
            break;
          case "Execution Approval":
            activitylogKey = "Execution Approved"
            break;
          default:
            activitylogKey = "Request Approved";
            break;
        }

        const activityTemp1 =await ActivityService.getActivity(
          activitylogKey,
          dataplaceholder,
          remark||" ",
          "",
          allMails,//sendtoEmail,
          "No"
        );
        allActivityLogs.push(activityTemp1);
      } else {
        if (task.Mandatory == true) {
           const placeholders2 = [
          {
            key: "Originator",
            Value: task["OnPreviousLvLApproval"] !== "AutoAppprove" &&  TaskIndex !==0 ? "System":  ContextService.GetCurrentUser().displayName,
          },
        ];
         dataplaceholder.push(...placeholders2);
          allMails["To"]=task.AssignedToEmail
          const activityTemp = await ActivityService.getActivity(
            task?.TaskName,
            dataplaceholder,
            remark||" ",
            allAttachementFiles,//addattachmentNameGuids.toString(),
            allMails,// task.AssignedToEmail,
            "yes"
          );
          allActivityLogs.push(activityTemp);
        }
      }
      if(DraftTaskData[DraftTaskData?.length-1]?.TaskGudId == task.TaskGudId &&task?.Status == "Completed"&&draftData?.length != 0){
       let activityTemp3 = ActivityService.getActivity(
             "Legal Review Completed",
             dataplaceholder,
             remark||" ",
             "",
             allMails,
             "No"
           );
           allActivityLogs.push(activityTemp3);
      }

        }
      }


        catch (error) {
          console.error(`Failed to create task for TaskGudId: ${task.TaskGudId}`, error);
        }
      }
    
      // if (data.length === batchlength) {
      //  if(taskJSON[taskJSON?.length-1]?.TaskName == 'Draft Approval'&&taskJSON[taskJSON?.length-1]?.Status == "Completed"&&draftData?.length != 0){
      //     let activityTemp3 = await ActivityService.getActivity(
      //        "Legal Review Completed",
      //        dataplaceholder,
      //        remark||" ",
      //        "",
      //        allMails,
      //        "No"
      //      );
      //      allActivityLogs.push(activityTemp3);
      //    }
        let finaltaskTemplate = {
          Activity_Log: JSON.stringify(allActivityLogs),
          Request_Number: reqNumber,
          RequestApproval: Request_Approval,
          DraftApproval: Draft_Approval,
          ExecutionApproval: Execution_Approval,
          Status: Reqstatus,
        };
       await updateActivity(finaltaskTemplate, itemid);
      // }
  }

  async function postTaskInList(taskTemplate) {
    try{
      const token = localStorage.getItem("CurrentToken");
    const updateUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365ContractTasks')/items`;
    const response = await axios.post(updateUrl,taskTemplate, {
      headers: {
        Accept: "application/json;odata=nometadata",
        "Content-type": "application/json;odata=nometadata",
        "odata-version": "",
        Authorization: `Bearer ${token}`,
      },
    });

 

    return response.data ;
  }catch(error){
  console.log(error)
  }
  }

  async function updateActivity(finaltaskTemplate: any, requestId: string) {
    const updateUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365Request')/items('${requestId}')`;
    const token = localStorage.getItem("CurrentToken");
   await axios
      .post(updateUrl, finaltaskTemplate, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "Content-type": "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
          "IF-MATCH": "*", // For optimistic concurrency
          "X-HTTP-Method": "MERGE", // Indicates partial updates (MERGE operation)
        },
      })
      .then((response) => {
        if (response.status === 204) {
          console.log("Request Completed Successfully");
        } else {
          console.warn("Unexpected response status:", response.status);
        }
      })
      .catch((error) => {
        console.error("Error updating activity:", error);
      });
  }

  async function getfilebinarydata(AllfieldValues, selectedStandfile, fileName, finalTemplatelib) {

const accessToken = localStorage.getItem("CurrentToken") 


try {
  // const curl = "https://megazap.sharepoint.com/_api/web/lists/getbytitle('CLM365Contract_Type')/items(5)/AttachmentFiles('Attachments/5/Advisory_Agreement.docx')/$value";
  const listName = encodeURIComponent('CLM365Contract_Type');
const itemId =selectedStandfile?.split('Attachments/')[1]?.split("/")[0] ||"";// Make sure this is the correct item ID
const filename=selectedStandfile?.split('Attachments/')[1]?.split("/")[1] ||"";
const filePath = encodeURIComponent(`Attachments/${itemId}/${filename}`);
const curl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('${listName}')/items('${itemId}')/AttachmentFiles('${filePath}')/$value`;

 const responseBlob:any= await axios({
    method: 'get',
    url: curl,
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      // 'Accept': 'application/json;odata=verbose'
    },
    responseType: 'blob' // Specify that you expect a blob response
  })


  // console.log(responseBlob)
  if(responseBlob?.data){
       const file = new File([responseBlob?.data], fileName, {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        try {
          let finalTemp3 = {
            TaskID: "",
            File_Name: drafttypelist, // standardfileName,
            File_Guid: "",
            File_Content: file,
          };
          allAttachementFiles.push(finalTemp3);
          // postStaticAttachment(file)

          Updateformfieldvalues(AllfieldValues, file, fileName, finalTemplatelib).then((c) => {
            //  console.log(c);
          });
        } catch (err) {
          // console.error(err);
        }
  }


} catch (error) {
  console.log(error)
}
   
  }


  const postStaticAttachment= async(file)=>{


    const documentLibraryName = "StaticAttachmentLibrary"; // Replace with your document library name
    const fileName = file.name;
    const fileData = file; 
      const newFolderName = file.name; // The name of the new 
      const token=localStorage.getItem("CurrentToken");
      const createFolderUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('${documentLibraryName}')/rootfolder/folders`;
      
      // Payload to specify the folder details
      const folderPayload = {
        "ServerRelativeUrl": `/sites/clm365test/${documentLibraryName}/${newFolderName}` // Adjust path as necessary
      };
      try{
        const response = await axios.post(createFolderUrl, folderPayload, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        });

        if(response.data.ServerRelativeUrl){
          const folderUrl = `${response.data.ServerRelativeUrl}`;

          // for (let i = 0; i < filesDataArray.length; i++) {
              // const file = filesDataArray[i];
              // const fileName=filesDataArray[i]?.GUID;
              // const fileData = filesDataArray[i]?.FileContent;  // File object to send
            
              // let finalTemplatelibrary = {
              //     TaskID: folderName,
              //     File_Name: filesDataArray[i]?.FileName,
              //     File_Guid:filesDataArray[i]?.GUID?.split('.')[0],
              //     AttachmentIntName:filesDataArray[i]?.IntName,
              //   };

              // Define the URL to upload the file to SharePoint
              const uploadFileUrl = `${ContextService.GetUrl()}/_api/web/getfolderbyserverrelativeurl('${folderUrl}')/files/add(overwrite=true, url='${fileName}')`;
            
              try {
                // Send the POST request to upload the file
                const uploadFileResponse = await axios.post(uploadFileUrl, fileData, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    "Content-Type": "application/octet-stream"  // Set content type to binary stream
                  }
                });
              //   if (uploadFileResponse.data.ServerRelativeUrl) {
              //     const uploadedFileUrl = uploadFileResponse.data.ServerRelativeUrl;
              //     const updateMetadataUrl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${uploadedFileUrl}')/listitemallfields`;
              //     const getFileMetadataUrl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${uploadedFileUrl}')/listitemallfields`;

              //     const fileMetadataResponse = await axios.get(getFileMetadataUrl, {
              //       headers: {
              //         Authorization: `Bearer ${token}`,
              //         Accept: "application/json"
              //       }
              //     });

              //     const fileETag = fileMetadataResponse.headers['etag'];
              //     // Send the PATCH request to update metadata
              //     const updateMetadataResponse = await axios.patch(updateMetadataUrl, {
              //       TaskID: finalTemplatelibrary.TaskID,
              //       File_Name: finalTemplatelibrary.File_Name,
              //       File_Guid: finalTemplatelibrary.File_Guid,
              //       AttachmentIntName: finalTemplatelibrary.AttachmentIntName
              //     }, {
              //       headers: {
              //         Authorization: `Bearer ${token}`,
              //         Accept: "application/json",
              //         "Content-Type": "application/json",
              //         "If-Match": fileETag  
              //       }
              //     });

              //     if (updateMetadataResponse.status === 200) {
              //         console.log("File uploaded and metadata updated successfully.");
              //       } else {
              //         console.error("Failed to update metadata.");
              //       }
              // }
            
                console.log(`File ${fileName} uploaded successfully:`, uploadFileResponse.data);
              } catch (error) {
                console.error(`Error uploading file ${fileName}:`, error);
              }
            // }
      }
      
        console.log('Folder created successfully:', response.data);
      }catch  (error){
        console.error('Error creating folder:', error);
      }





}

  const getnumbervalue = (event): void => {
    let textfieldvalue = event.target.value;
    let _fieldInternalname = event.target.id;
    // let numberjson=JSON.parse(numbercondition["Order"]);
    ////console.log(conditionaljson, "numberjson");
    let _ChoiceArray = [];
    {
      conditionaljson
        ? Object.entries(conditionaljson).map(([key1, column]: any, index: any) => {
            if (key1 == _fieldInternalname) {
              column.Choices.length > 0
                ? column.Choices.map((data: any, ind: any) => {
                    if (data.Numbervalue == textfieldvalue) {
                      ////console.log(data.field);
                      ////console.log((data.field).length);
                      data.field.length
                        ? data.field.map((items) => {
                            _ChoiceArray.push({
                              FieldName: items.FieldName,
                              InternalName: items.InternalName,
                              Operator: data.Operator,
                              type: items.type,
                            });
                          })
                        : "";

                      // let ApproverDetailnew1 = Object.assign({
                      //   [data.value]: {
                      //       "Approvers": [],
                      //   }
                      //});
                    }
                  })
                : null;
            }
          })
        : null;
    }

    setfinalconditionNumber((prev) => ({
      ...prev,
      [_fieldInternalname]: {
        // ...prev[_fieldchoicename],
        // [textfieldvalue]: {
        Fields: _ChoiceArray,
        // }
      },
    }));
    //////console.log(GJsonFormFields, "GJsonFormFields");
    setformfieldjson(GJsonFormFields);
    ////console.log(textfieldvalue, _fieldInternalname, "textfieldvalue");
    dataNumber[event.target.id] = event.target.value;
    ////console.log(event.target.defaultValue)
    setdataNumber({ ...dataNumber });
    ////console.log({ ...dataNumber });
  };

  //console.log(dataText, "textdata");
  const getnotevalue = (event, value): void => {
    dataNote[event.target.id] = value;
    ////console.log(event.target.defaultValue, "vent.target.defaultValue");
    setdataNote({ ...dataNote });
    ////console.log({ ...dataNote });
  };
  const gettextvalue = (event, value): void => {
    dataText[event.target.id] = value;
    ////console.log(event.target.defaultValue, "vent.target.defaultValue")
    setdataText({ ...dataText });
    ////console.log({ ...dataText });
  };
  const datepickererror = () => {
    dateDatepicker["Contract_End_Date"] = undefined;
    seterrormsgStatus(true);
    // seterrormsgValue("End date can't be less than Start date")
    SweetalertsApproved("error", `${"End date can't be less than start date"}`);
    setTimeout(() => {
      ErrorMsgVlidate();
      messageDismiss();
      seterrormsgValue("");
      seterrormsgStatus(false);
    }, 3000);
  };

  const ondobChange = (date, id): void => {
    dateDatepicker[id] = date;
    if (id === "Contract_Start_Date") {
      dateDatepicker["Contract_End_Date"] = undefined;
      setdateDatepicker({ ...dateDatepicker });
      dateDatepicker["Contract_Start_Date"] = date;
      setformfieldjson(GJsonFormFields);
    } else {
      updateTermObjOnEndDateChange();
      let startD = dateDatepicker["Contract_Start_Date"];
      let endD = dateDatepicker["Contract_End_Date"];
      startD == null || startD == undefined
        ? (startD = date)
        : endD == null || endD == undefined
          ? (endD = date)
          : null;

      startD?.getFullYear() > endD?.getFullYear()
        ? datepickererror()
        : startD?.getFullYear() == endD?.getFullYear() && startD?.getMonth() > endD?.getMonth()
          ? datepickererror()
          : startD?.getFullYear() == endD?.getFullYear() &&
              startD?.getMonth() == endD?.getMonth() &&
              startD?.getDate() > endD?.getDate()
            ? datepickererror()
            : startD?.getFullYear() <= endD?.getFullYear() &&
                startD?.getMonth() <= endD?.getMonth() &&
                startD?.getDate() <= endD?.getDate()
              ? (setdateDatepicker({ ...dateDatepicker }),
                (dateDatepicker["Contract_End_Date"] = date),
                setformfieldjson(GJsonFormFields))
              : null;
    }
  };
  const ErrorMsgVlidate = () => (
    <MessageBar
      messageBarType={MessageBarType.error}
      isMultiline={false}
      onDismiss={messageDismiss}
      dismissButtonAriaLabel="Close"
    >
      {errormsgValue}
    </MessageBar>
  );

  const messageDismiss = () => {
    setselectfilemsg(false);
    setRequiredColumnMessage(false);
    seterrormsgStatus(false);
  };

  function updateTermObjOnEndDateChange() {
    let diff_days = moment(dateDatepicker["Contract_End_Date"]).diff(
      moment(dateDatepicker["Contract_Start_Date"]),
      "days"
    );
    setTermPeriodObj({ count: diff_days + 1, term: "Day" });
  }
  async function getdatafromcontractlibrary(id) {
    const finaltemp = [];
    const endpoint = `${props.siteURL}/_api/web/lists/getbytitle('CLM365Contract')/items(${id})?$select=*,Author/Title,File/ServerRelativeUrl,File/Name&$expand=Author,File`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
        },
      });

      const e = response.data;

      if (GJsonFormFields) {
        Object.entries(GJsonFormFields).forEach(([key1, column]) => {
          column?.["items"]?.forEach((itemvalue) => {
            if (itemvalue.Type === "Text") {
              dataText[itemvalue.IntName] = e[itemvalue.IntName];
              setdataText({ ...dataText });
            }
            if (itemvalue.IntName === "Contract_Term") {
              setselectedChoiceKey(e[itemvalue.IntName]);
            }
            if (itemvalue.Type === "Plus" && e[itemvalue.IntName]) {
              setcounterpartyname(JSON.parse(e[itemvalue.IntName]));
            }
            if (itemvalue.Type === "DateTime") {
              dateDatepicker[itemvalue.IntName] = e[itemvalue.IntName] ? new Date(e[itemvalue.IntName]) : null;
              setdateDatepicker({ ...dateDatepicker });
            }
            if (itemvalue.Type === "Note") {
              dataNote[itemvalue.IntName] = e[itemvalue.IntName];
              setdataNote({ ...dataNote });
            }
            if (itemvalue.Type === "Number") {
              dataNumber[itemvalue.IntName] = e[itemvalue.IntName];
              setdataNumber({ ...dataNumber });
              getnumbervalue({
                target: { value: e[itemvalue.IntName], id: itemvalue.IntName },
              });
            }
            if (itemvalue.Type === "Choice") {
              dataChoice2[itemvalue.IntName] = e[itemvalue.IntName];
              setdataChoice2({ ...dataChoice2 });
              getChoice({ key: e[itemvalue.IntName], text: e[itemvalue.IntName] }, itemvalue.IntName);
            }
          });
        });
      }

      Object.entries(conditionaljson)?.forEach(([key1, column]) => {
        if (column?.["FieldType"] === "Number") {
          column?.["Choices"]?.forEach((itemvalue) => {
            itemvalue.field?.forEach((choicefields) => {
              if (choicefields.type === "Text") {
                dataText[choicefields.InternalName] = e[choicefields.InternalName];
                setdataText({ ...dataText });
              }
              if (choicefields.type === "Note") {
                dataNote[choicefields.InternalName] = e[choicefields.InternalName];
                setdataNote({ ...dataNote });
              }
              if (choicefields.type === "Number") {
                dataNumber[choicefields.InternalName] = e[choicefields.InternalName];
                setdataNumber({ ...dataNumber });
              }
              if (choicefields.type === "Choice") {
                dataChoice2[choicefields.InternalName] = e[choicefields.InternalName];
                setdataChoice2({ ...dataChoice2 });
              }
              if (choicefields.type === "DateTime") {
                dateDatepicker[choicefields.InternalName] = e[choicefields.InternalName]
                  ? new Date(e[choicefields.InternalName])
                  : null;
                setdateDatepicker({ ...dateDatepicker });
              }
            });
          });
        }

        if (column?.["FieldType"] === "Choice") {
          column?.["Choices"]?.forEach((itemvalue) => {
            if (itemvalue.type === "Text") {
              dataText[itemvalue.InternalName] = e[itemvalue.InternalName];
              setdataText({ ...dataText });
            }
            if (itemvalue.InternalName === "Contract_Term") {
              setselectedChoiceKey(e[itemvalue.InternalName]);
            }
            if (itemvalue.type === "Plus" && e[itemvalue.InternalName]) {
              dataText[itemvalue.InternalName] = e[itemvalue.InternalName];
              setdataText({ ...dataText });
            }
            if (itemvalue.type === "DateTime") {
              dateDatepicker[itemvalue.InternalName] = e[itemvalue.InternalName]
                ? new Date(e[itemvalue.InternalName])
                : null;
              setdateDatepicker({ ...dateDatepicker });
            }
            if (itemvalue.type === "Note") {
              dataNote[itemvalue.InternalName] = e[itemvalue.InternalName];
              setdataNote({ ...dataNote });
            }
            if (itemvalue.type === "Number") {
              dataNumber[itemvalue.InternalName] = e[itemvalue.InternalName];
              setdataNumber({ ...dataNumber });
            }
            if (itemvalue.type === "Choice") {
              dataChoice2[itemvalue.InternalName] = e[itemvalue.InternalName];
              setdataChoice2({ ...dataChoice2 });
            }
          });
        }
      });

      const _conditiondata = [];
      if (conditionaljson) {
        Object.entries(conditionaljson).forEach(([key1, column]) => {
          const _choiceoptions = [];
          if (column?.["Choices"].length > 0) {
            column?.["Choices"].forEach((items) => {
              _choiceoptions.push({ key: items.value, text: items.value });
            });
          }

          const finalvalueuniq = Object.values(
            _choiceoptions.reduce((acc, cur) => Object.assign(acc, { [cur.key]: cur }), {})
          );

          _conditiondata.push({ internalname: key1, value: finalvalueuniq });
        });
      }

      setformfieldjson(GJsonFormFields);
      setconditionaldata(_conditiondata);
      setconditionaljson(conditionaljson);
    } catch (error) {
      console.error("Error fetching contract data:", error);
    }
  }

  const onSelectAutoComplete = (event): void => {
    setTextValue(event);
    TitleOptions.map((e) => {
      if (e.label == event) {
        getdatafromcontractlibrary(e.Id);
        setTextValue(e.text);
        setContractGUID(e.Guid_ID);
      }
    });
  };

  const getChoice = (item, id): void => {
    let _selectedValue = item.key;
    setselectedchoice(_selectedValue);
    let _fieldchoicename = id;
    let _ChoiceArray = [];
    {
      conditionaljson
        ? Object.entries(conditionaljson).map(([key1, column]: any, index: any) => {
            if (key1 == _fieldchoicename) {
              column.Choices.length > 0
                ? column.Choices.map((data: any, ind: any) => {
                    if (data.value == _selectedValue) {
                      _ChoiceArray.push({
                        FieldName: data.FieldName,
                        InternalName: data.InternalName,
                        Operator: data.Operator,
                        type: data.type,
                      });
                      // let ApproverDetailnew1 = Object.assign({
                      //   [data.value]: {
                      //       "Approvers": [],
                      //   }
                      //});
                    }
                  })
                : null;
            }
          })
        : null;
    }

    setfinalconditional((prev) => ({
      ...prev,
      [_fieldchoicename]: {
        // ...prev[_fieldchoicename],
        [_selectedValue]: {
          Fields: _ChoiceArray,
        },
      },
    }));
    //console.log(GJsonFormFields, "GJsonFormFields");
    setformfieldjson(GJsonFormFields);
    dataChoice2[id] = item.key;
    setdataChoice2({ ...dataChoice2 });
  };
  const choiceGroupStyles: IChoiceGroupStyles = {
    root: {
      flex: "0 1 25%",
      "label::after": {
        borderColor:
          SettingService.GetTheme() == "light"
            ? "var(--lightdarkColor) !important"
            : "var(--lightdarkBGGray) !important",
      },
      "label:hover::after": {
        borderColor:
          SettingService.GetTheme() == "light"
            ? "var(--lightdarkColor) !important"
            : "var(--lightdarkBGGray) !important",
      },
      "label::before": {
        borderColor:
          SettingService.GetTheme() == "light"
            ? "var(--lightdarkColor) !important"
            : "var(--lightdarkBGGray) !important",
      },
      "label:hover::before": {
        borderColor:
          SettingService.GetTheme() == "light"
            ? "var(--lightdarkColor) !important"
            : "var(--lightdarkBGGray) !important",
      },
    },
    flexContainer: {
      display: "flex",
      justifyContent: "initial",
      width: "100%",
      // columnGap: '50px',
    },
  };

  const onChangechoicegrp = React.useCallback((ev: React.SyntheticEvent<HTMLElement>, option: IChoiceGroupOption) => {
    setselectedChoiceKey(option.key);
    if (option.key == "Definite") {
      setselectedChoiceKey("Definite");
    } else {
      setselectedChoiceKey("Indefinite");
    }
  }, []);

  const onChangeRemark = (newVal) => {
    setRemark(newVal || "");
  };

  return (
    <div style={{position:'relative'}}>
      {/* <div className="BackButtonContainer">
        <ArrowCircleLeftRegular onClick={() => props.setisNewContract(false)} />
      </div> */}
  {(spinnerLoading||loader)&&  <div style={{position:'absolute',top: !formfieldjson ? '50%' : '25%' ,left:'30%'}}>
       
       <Spinner label="Please wait..." ariaLive="assertive" labelPosition="right" />
     </div>}
   
     <div className={"pageHeader newRequestHeader"}>
      <Label>Create a New Request</Label>
     
      <div className={"SendButtons"}>
      {isSelecRequestOpen? <Button icon={<ChevronUpRegular />}  onClick={() =>setisSelecRequestOpen(false)} /> :<Button icon={<ChevronDownRegular />}  onClick={() =>setisSelecRequestOpen(true)} />}
      {formfieldjson ? (<>
        <Button icon={<DraftsRegular />} disabled={loading} onClick={() => PostContractformdata("Draft", approvalInfo)} title="Save as Draft"/>
        <Button icon={<SendRegular />} disabled={loading} onClick={openDialogRemark} title="Submit"/>
      </>):null}

      </div>
      </div>
   
      <div className={"Reportmaidiv"} style={{opacity:(spinnerLoading||loader)?'0.2':'1',pointerEvents:(spinnerLoading||loader)? "none":"auto"}}>
    
       { isSelecRequestOpen?<div className={"addnewrequestersection"} style={{paddingBottom: !formfieldjson ? '46vh' : '10px'}}>
          {/* <div>
            <Label //style={{ marginRight: '5px' }}
              required
            >
              {strings.RequestType}
            </Label>
            <Dropdown
              placeholder={strings.SelectRequestType}
              options={requesttype}
              styles={dropdownStyles}
              onChange={onChangeRequesttype}
            />
          </div> */}

          {businessUnit=='Yes'? 
          <div>
            {/* <Label required>{strings.BusinessUnit}</Label> */}
            <Select
              placeholder={strings.SelectBusinessUnit}
              theme={SelectTheme}
              options={businessunitoptions?.sort(sortAlphaNum)}
              value={
                businessunitdropvalue != undefined &&
                businessunitdropvalue != null &&
                businessunitoptions.filter(({ key }) => key === businessunitdropvalue)
              }
              // isDisabled={!Component20}
              isSearchable={true}
              onChange={(select) => onchangebusinessunit(select)}
              styles={customStyles}
            />
          </div>
          :""}
          {department === 'Yes' && <div>
              <Select
                placeholder={strings.SelectDepartment}
                options={DepartmentDetails.DepartmentOptions.sort((a, b) => a?.label?.localeCompare(b?.label))}
                onChange={(select) => onChangeDepartmentDetails(select)}
                value={(DepartmentDetails.SelectedDepartment) && DepartmentDetails.DepartmentOptions.filter(({ key }) => key === DepartmentDetails.SelectedDepartment["key"])}
                isSearchable={true}
                styles={customStyles}
              />
            </div>}
          <div>
            {/* <Label required>{strings.contracttypename}</Label> */}
            <Select
              placeholder={strings.Selcttype}
              theme={SelectTheme}
              options={contracttypename?.sort((a, b) => a?.label?.localeCompare(b?.label))}
              value={
                contracttypeKey != undefined &&
                contracttypeKey != null &&
                contracttypename?.filter(({ key }) => key === contracttypeKey)
              }
              // isDisabled={!Component12}
              isSearchable={true}
              onChange={(select) => onChangeContractname(select)}
              styles={customStyles}
              // menuIsOpen
            />
          </div>

          <div>
            {/* <Label 
              required
            >
              {strings.DraftType}
            </Label> */}
            {/* <Dropdown
              // className={"labelstylemargin"}
              placeholder={strings.SelectDraftType}
              //options={contracttypename}
              options={draftTypeOptions} //drafttype
              styles={dropdownStyles}
              // selectedKey={monthlyday}
              selectedKey={drafttypelist}
              onChange={onChangeDrafttype}
              disabled={!Component13}
            /> */}
       <Select
              placeholder={strings.SelectDraftType}
              options={draftTypeOptions}
              value={
                drafttypelist != undefined &&
                drafttypelist != null &&
                draftTypeOptions.filter(({ key }) => key === drafttypelist)
              }
              // isDisabled={!Component12}
              isSearchable={true}
              theme={SelectTheme}
              onChange={(select) => onChangeDrafttype(select)}
              styles={customStyles}
              // menuIsOpen
            />


          </div>

          <div>
          {(isFromAI && drafttypelist === 'Select file from Outlook')?<Select
              placeholder={'Select a File'}
              options={props?.attachmentData}
              value={
                AIAttachment != undefined &&
                AIAttachment != null &&
                props?.attachmentData.filter(({ key }) => key === AIAttachment)
              }
              // isDisabled={!Component12}
              isSearchable={true}
              theme={SelectTheme}
              onChange={(select) => onChangeOutlookFile(select)}
              styles={customStyles}
              // menuIsOpen
            />:null}
          </div>

     
          <div className="atch" style={{marginTop: businessUnit=="Yes"?"0px":"-16px"}}>
          {formfieldjson && drafttypelist == attachyourFile && !attachFile1?.length&&!isFromAI ? (
            <>
            <div style={{display:'flex'}} onClick={()=>{setAttachYourOwnFile(true)}}>
            <Label htmlFor="file-input"  
                 onClick={()=>{setAttachYourOwnFile(true)}}
                 style={{ marginLeft: "6px", marginTop: "25px",display:'flex',cursor:'pointer' }}>
                 <Label htmlFor="file-input"  
                 onClick={()=>{setAttachYourOwnFile(true)}} required> Select a file</Label> 
                  {/* <div style={{display:'flex',gap:'5px',marginLeft:'-10px'}}> */}
                <Icon
                  iconName="Attach"
                  onClick={()=>{setAttachYourOwnFile(true)}}
                  style={{ paddingTop:'7px',marginLeft:'-10px' }}//top-8px
                  styles={{
                    root: {
                      color:"var(--layoutIconColor)"
                    },
                  }}
                ></Icon>
                {/* className={"imgload"} */}
            
                {/* </div> */}
                </Label>
                <div className={"imgload"} >
                  <TooltipHost
                    content={strings.attachment}
                    id="field2"
                    styles={hostStyles}
                  >
                    <IconButton
                      id="field2"
                      aria-describedby="field2"
                      style={{ marginTop: "25px" }}
                      iconProps={{ iconName: "Info" }}
                      styles={{
                        icon: {
                          color:"var(--layoutIconColor)",
                        },
                      }}
                    ></IconButton>
                  </TooltipHost>
                </div>
             
            </div>
                     
            </>
          ) :  drafttypelist == attachyourFile &&  attachFile1?.length&&!isFromAI   ?  <label
          htmlFor="file-input"
          style={{ display: "flex", width: "auto" }}>   {attachFile1}
              </label>: null}
        </div>
        </div>:null}
        <div >
        {formfieldjson && (drafttypelist == attachyourFile && !attachFile1?.length && AttachYourOwnFile&&!isFromAI ) ? (
          <>
            <DragAndDrop
              showLabel={false}
              onChangeAdd={onAttachmentChange1}
              accept=".docx,.pdf,.doc"
              selectedFile={attachFile1}
              key={JSON.stringify(attachFile1)}
            />
          </>
        ) : null}
      </div>
   {/* { isCustomFieldsOpen?  <> */}
        <div>

          {formfieldjson
            ? Object.entries(formfieldjson).map(([key1, column]: any, index: any) => {
                return (
                  <div key={index}>
                  <div style={{display:'flex',justifyContent:'space-between'}}>
                  <Label style={{ marginBottom: "8px", color: SettingService.GetTheme() == "dark" ? "#fff" : "#000" }}>
                      {key1}
                    </Label>
                    <div className={"SendButtons"}>
        {(column.isHide==true||column.isHide==undefined)? <Button icon={<ChevronUpRegular />}  onClick={() =>{
        
              setformfieldjson((prevFormfieldjson:any) => {
                console.log("Before Update (Up)", prevFormfieldjson[key1]);
                const updatedFormfieldjson = { ...prevFormfieldjson };
                if (updatedFormfieldjson[key1]) {
                  updatedFormfieldjson[key1].isHide = false;
                }
                return updatedFormfieldjson;
              });
        }} /> :<Button icon={<ChevronDownRegular />}  onClick={() =>{    setformfieldjson((prevFormfieldjson:any) => {
          const updatedFormfieldjson = { ...prevFormfieldjson };
          if (updatedFormfieldjson[key1]) {
            updatedFormfieldjson[key1].isHide = true;
          }
          return updatedFormfieldjson;
        });}} />}
        </div>
                  </div>
                
                    {/* <h3 style={SettingService.GetTheme() == "dark" ? {color:"#fff"} : {color:"#000"}}>{key1}</h3> */}
                    {key1 != "General" ? (
                      <div ></div>
                      // style={{ borderBottom: "1.5px solid var(--lightdarkBGTable)" }}
                    ) : (
                      <div  />
                      // style={{ borderBottom: "1.5px solid var(--lightdarkBGTable)" }}
                    )}
                  {  (column.isHide==true||(column.isHide==undefined))?<div className={"addnewrequestersection"}>
                      {column.items.map((item: any, ind: any) => {
                        // let displayvaluetext;
                        // props.currentfieldname?.map((o) => {
                        //   /////console.log(o.key, "-", item.IntName)
                        //   if (o.key == item.IntName) {
                        //     displayvaluetext = o.text.replaceAll("_", " ");
                        //   }
                        // });
                        // if (displayvaluetext) {
                        //   displayvaluetext = displayvaluetext;
                        // } else {
                        //   displayvaluetext = item.text;
                        // }
                        if (
                          item.Type == "Text" //&& item.Display == true
                        ) {
                          if ([ "Contract_End_Date", "Contract_Start_Date"].includes(item.IntName)) {
                            return (
                              <>
                                <div id={item.IntName}>
                                  {/* <Label required={item.Required == "Yes" ? true : false}>
                                    {CurrentdisplayfieldsName[item.IntName]}
                                  </Label> */}
                                  <DatePicker
                                      showWeekNumbers={true}
                                      showMonthPickerAsOverlay={true}
                                    id={item.IntName}
                                    placeholder={"Enter " + CurrentdisplayfieldsName[item.IntName] + (item.Required !== "Yes" ? " (optional)" : "")}
                                    onSelectDate={(date) => ondobChange(date, item.IntName)}
                                    value={dateDatepicker[item.IntName] ? new Date(dateDatepicker[item.IntName]) : null}
                                    formatDate={onFormatDate}
                                    disabled={
                                      item.IntName == "Contract_End_Date" && selectedChoiceKey == "Indefinite"
                                        ? true
                                        : false
                                    }
                                  />
                                </div>
                              </>
                            );
                          } else {
                            return (
                              <div id={item.IntName}>
                                {/* <Label required={item.Required == "Yes" ? true : false}>
                                  {CurrentdisplayfieldsName[item.IntName]}
                                </Label> */}
                                {(MSAGuid == ""||MSAGuid==undefined) && requesttypevalue == "Contract" ? (
                                  <TextField
                                    id={item.IntName}
                                    placeholder={"Enter " + CurrentdisplayfieldsName[item.IntName] + (item.Required !== "Yes" ? " (optional)" : "")}
                                    name={item.text}
                                    // options={TitleOptions}
                                    value={dataText[item.IntName] || ""}
                                    onBlur={() =>
                                      setdataText((c) => ({
                                        ...dataText,
                                        [item.IntName]: dataText[item.IntName]?.trim(),
                                      }))
                                    }
                                    onChange={gettextvalue}
                                  ></TextField>
                                )
                                 : (
                                  <TextField
                                    id={item.IntName}
                                    placeholder={"Enter " + CurrentdisplayfieldsName[item.IntName] + (item.Required !== "Yes" ? " (optional)" : "")}
                                    name={item.text}
                                    // options={TitleOptions}
                                    value={dataText[item.IntName] || ""}
                                    onBlur={() =>
                                      setdataText((c) => ({
                                        ...dataText,
                                        [item.IntName]: dataText[item.IntName]?.trim(),
                                      }))
                                    }
                                    onChange={gettextvalue}
                                  ></TextField>
                                )}

                                {/* {
                            textValue ?
                              filterSuggestions(textValue).map((suggestion) => (
                                <div key={suggestion}

                                  onClick={() => {
                                    setdataText((c) => ({
                                      ...dataText,
                                      [item.IntName]: suggestion?.Title,
                                      ['Counterparty_Name']: suggestion?.Counterparty_Name,
                                    }))
                                    setdataNote((c) => ({
                                      ...dataNote,  
                                      ['Counterparty_Name']: suggestion?.Counterparty_Name,
                                    }))
                                    dateDatepicker["Contract_Start_Date"] = moment(suggestion?.Contract_Start_Date).toDate() ;
                                    dateDatepicker["Contract_End_Date"] =  moment(suggestion?.Contract_End_Date).toDate() ; 
                                    dateDatepicker["Contract_Date"] =  moment(suggestion?.Contract_Date).toDate();
                                    setdateDatepicker({ ...dateDatepicker });
                                    // setdataText((c) => ({ 
                                    //   ...dataText,
                                    //   ['Counterparty_Name']: 
                                    //   suggestion?.Counterparty_Name.split('|')[0] as string,
                                    // }));
                                    setcounterpartyname(suggestion?.Counterparty_Name as string)
                                    //console.log("its suggestion")
                                  }
                                  }
                                >{suggestion?.Title}</div>
                              ))
                              : ''
                          } */}
                              </div>
                            );
                          }
                        }
                        if (
                          item.Type == "Note" //&& item.Display == true
                        ) {
                          return (
                            <>
                              <div id={item.IntName}>
                                {/* <Label required={item.Required == "Yes" ? true : false}>
                                  {CurrentdisplayfieldsName[item.IntName]}
                                </Label> */}
                                <TextField
                                  id={item.IntName}
                                  name={item.text}
                                  placeholder={"Enter " + CurrentdisplayfieldsName[item.IntName] + (item.Required !== "Yes" ? " (optional)" : "")}
                                  value={dataNote[item.IntName] || ""}
                                  onBlur={() =>
                                    setdataNote((c) => ({
                                      ...dataNote,
                                      [item.IntName]: dataNote[item.IntName]?.trim(),
                                    }))
                                  }
                                  onChange={getnotevalue}
                                  multiline
                                ></TextField>
                              </div>
                            </>
                          );
                        }
                        if (
                          item.Type == "Number" //&& item.Display == true
                        ) {
                          return (
                            <>
                              <div id={item.IntName}>
                                {/* <Label required={item.Required == "Yes" ? true : false}>
                                  {CurrentdisplayfieldsName[item.IntName]}
                                </Label> */}
                                <TextField
                                  id={item.IntName}
                                  placeholder={"Enter " + CurrentdisplayfieldsName[item.IntName] + (item.Required !== "Yes" ? " (optional)" : "")}
                                  value={dataNumber[item.IntName] || ""}
                                  name="value"
                                  type="Number"
                                  onChange={getnumbervalue}
                                ></TextField>
                              </div>

                              {finalconditionNumber
                                ? Object.entries(finalconditionNumber).map(([Outerkey, column]: any, index: any) => {
                                    if (item.IntName == Outerkey) {
                                      ////console.log(column, "column")

                                      // return Object.entries(column).map(([Innerkey, innerfields]: any, index: any) => {
                                      return column.Fields.length
                                        ? column.Fields.map((choicefields) => {
                                            let displayvaluetext1;
                                            props.currentfieldname?.map((o) => {
                                              ////console.log(o.key, "-", item.IntName)
                                              if (o.key == choicefields.InternalName) {
                                                displayvaluetext1 = o.text.replaceAll("_", " ");
                                              }
                                            });
                                            if (choicefields.type == "Text")
                                              return (
                                                <div id={choicefields.InternalName}>
                                                  <Label required={choicefields.Required == "Yes" ? true : false}>
                                                    {displayvaluetext1 ? displayvaluetext1 : choicefields.FieldName}
                                                  </Label>
                                                  <TextField
                                                    id={choicefields.InternalName}
                                                    name={choicefields.FieldName}
                                                    value={dataText[choicefields.InternalName] || ""}
                                                    onBlur={() =>
                                                      setdataText((c) => ({
                                                        ...dataText,
                                                        [choicefields.InternalName]:
                                                          dataText[choicefields.InternalName]?.trim(),
                                                      }))
                                                    }
                                                    onChange={gettextvalue}
                                                  ></TextField>
                                                </div>
                                              ); // ////console.log(choicefields,"choicefields")
                                            if (choicefields.type == "Note")
                                              return (
                                                <div id={choicefields.InternalName}>
                                                  {/* <Label required={choicefields.Required == "Yes" ? true : false}>
                                                    {displayvaluetext1 ? displayvaluetext1 : choicefields.FieldName}
                                                  </Label> */}
                                                  <TextField
                                                    id={choicefields.InternalName}
                                                    name={choicefields.FieldName}
                                                    value={dataNote[choicefields.InternalName] || ""}
                                                    onChange={getnotevalue}
                                                    multiline
                                                  ></TextField>
                                                </div>
                                              );
                                            if (choicefields.type == "Number")
                                              return (
                                                <div id={choicefields.InternalName}>
                                                  {/* <Label>
                                                    {displayvaluetext1 ? displayvaluetext1 : choicefields.FieldName}
                                                  </Label> */}
                                                  <TextField
                                                    id={choicefields.InternalName}
                                                    value={choicefields.FieldName}
                                                    name="value"
                                                    type="Number"
                                                    onChange={getnumbervalue}
                                                  ></TextField>
                                                </div>
                                              );
                                            if (choicefields.type == "DateTime")
                                              return (
                                                <div id={choicefields.InternalName}>
                                                  {/* <Label required={item.Required == "Yes" ? true : false}>
                                                    {displayvaluetext1 ? displayvaluetext1 : choicefields.FieldName}
                                                  </Label> */}
                                                  <DatePicker
                                                      showWeekNumbers={true}
                                                      showMonthPickerAsOverlay={true}
                                                    id={choicefields.InternalName}
                                                    onSelectDate={(date) =>
                                                      ondobChange(date, choicefields.InternalName)
                                                    }
                                                    // value={Dateofbirth == undefined || Dateofbirth == null ? null : new Date(Dateofbirth)}
                                                    value={
                                                      dateDatepicker[choicefields.InternalName]
                                                        ? new Date(dateDatepicker[choicefields.InternalName])
                                                        : null
                                                    }
                                                    formatDate={onFormatDate}
                                                  />
                                                </div>
                                              );
                                          })
                                        : null;
                                      // })
                                    }
                                  })
                                : null}
                            </>
                          );
                        }
                        // let datepickervalue;
                        // for (let value of Object.entries(dateDatepicker)) {

                        //   value[0]==item.IntName?  datepickervalue= value[1]:datepickervalue=null;
                        // }
                        //{////console.log(datepickervalue,"datepickervalue")}
                        if ( item.Type == "Plus" && key1 == Object.keys(formfieldjson)[0]) {
                          return (
                            <>
                              <div id={item.IntName} className={"pluseicondiv"}>
                                <div className={"counterdiv"}>
                                  {/* <Label required={item.Required == "Yes" ? true : false}>{item.text}</Label> */}
                                  {/* <DatePicker id={item.IntName} onSelectDate={(date) => ondobChange(date, item.IntName)} value={
                        dateDatepicker[item.IntName] ? dateDatepicker[item.IntName] : null
                      }
                        formatDate={onFormatDate}
                      /> */}
                                  {/* <ChoiceGroup selectedKey={selectedChoiceKey} options={counterpartyoption} onChange={onChangechoicegrp}/> */}
                                  {/* <div
                                    onClick={() => {
                                      showDialog();
                                      setcounterparty(true);
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <Icon
                                      //  title={strings.Add}
                                      onClick={
                                        () => {
                                          showDialog();
                                          //  openPanelDept()
                                        } //EditUser(templ.Id)
                                      }
                                      iconName="Add"
                                      styles={{
                                        root: {
                                          color: "var(--layoutIconColor)",
                                          cursor: "pointer",
                                          marginRight: "5px",
                                          marginTop: "8px",
                                        },
                                      }}
                                    ></Icon>
                           
                                    <Link>
                                      <Label
                                        styles={{
                                          root: {
                                            cursor: "pointer",
                                            color: "var(--layoutIconColor) !important",
                                          },
                                        }}
                        
                                      >
                                        {strings.Add}
                                      </Label>
                                    </Link>
                                  </div> */}
                                </div>
                                <div className={"counterdiv1"}>
                                  {/* <TextField id={item.IntName} name={item.text} value={dataText[item.IntName] || ""} 
                        onBlur={() =>
                        setdataText(c => ({ ...dataText, [item.IntName]: dataText[item.IntName]?.trim() }))}
                        onChange={gettextvalue}
                      >
                      </TextField> */}
                                  <Select
                                   theme={SelectTheme}
                                    maxMenuHeight={200}
                                    placeholder={`Select ${CurrentdisplayfieldsName[item.IntName]} ${item.Required !== "Yes" ? " (optional)" : ""}`}
                                    options={item.IntName ==="Share_With_Others" ? ShareWith.ShareWithOptions.sort((a, b) => a?.text.localeCompare(b?.text)) : optionsCounterparty}
                                    onChange={(select) => onChangeCParty(select, item.IntName)}
                                    isSearchable={true}
                                    value={item.IntName === "Share_With_Others"
                                            ? ShareWith.shareWithSelected : optionsCounterparty.filter((el) =>
                                      counterpartyname.some((f) => f.key === el.key)
                                    )}
                                    // tabSelectsValue={dataText[item.IntName]}
                                    //  value={optionsCounterparty.filter((key) => key.text === dataText[item.IntName]?.split('|')[0])}
                                    isMulti={true}
                                  />
                                </div>
                              </div>
                            </>
                          );
                        }

                        if (item.Type == "Datecheck"&& item.IntName !== 'Contract_Term') {
                          return (
                            <>
                              <div id={item.IntName}>
                                {/* <Label required={item.Required == "Yes" ? true : false}>{item.text}</Label> */}
                                <div className={iconHideMBNavClassnew}>
                                  <ChoiceGroup
                                    styles={choiceGroupStyles}
                                    selectedKey={selectedChoiceKey}
                                    options={counterpartyoption}
                                    onChange={onChangechoicegrp}
                                  />
                                </div>
                              </div>
                            </>
                          );
                        }
                        if (item.Type == "DateTime"  && item.IntName !== 'Contract_Date' ) {
                          return (
                            <>
                              <div id={item.IntName}>
                                <span style={{ display: "flex", justifyContent: "space-between" }}>
                                  {/* <Label
                                    required={
                                      item.IntName == "Contract_End_Date" && selectedChoiceKey == "Indefinite"
                                        ? false
                                        : item.Required == "Yes"
                                          ? true
                                          : false
                                    }
                                  >
                                    {CurrentdisplayfieldsName[item.IntName]}
                                  </Label> */}
                                  {/* {item.IntName == "Contract_End_Date" && (
                                    <div
                                      onClick={() => {
                                        if (selectedChoiceKey != "Indefinite") {
                                          if (!dateDatepicker["Contract_Start_Date"]) {
                                            SweetalertsRequest("error", `Please select start date`);
                                          } else {
                                            setIsTermDialogvisible(true);
                                          }
                                        }
                                      }}
                                      style={{ marginLeft: "auto", display: "flex" }}
                                    >
                                      <Icon
                                        iconName="Add"
                                        styles={{
                                          root: {
                                            color: "var(--layoutIconColor)",
                                            cursor: "pointer",
                                            marginRight: "5px",
                                            marginTop: "8px",
                                          },
                                        }}
                                      ></Icon>
                                     
                                      <Link>
                                        <Label
                                          id="addRequestTerm"
                                          styles={{
                                            root: {
                                              cursor: "pointer",
                                              color: "var(--layoutIconColor) !important",
                                            },
                                          }}
                                        >
                                          {strings.Term}
                                        </Label>
                                      </Link>
                                    </div>
                                  )} */}
                                </span>
                                {showDurationTextField && item.IntName == "Contract_End_Date" &&
                            <TextField
                            // id={item.IntName}
                            id = "addRequestTerm"
                            placeholder={"Select " + CurrentdisplayfieldsName[item.IntName] + (item.Required !== "Yes" ? " (optional)" : "")}
                            // placeholder={"Enter " + item.text}
                            name={item.text}
                            readOnly
                            onClick={() => {
                              // if(selectedChoiceKey != "Indefinite"){
                              // if (!selectedTerm.includes("Indefinite")) {
                                if(!dateDatepicker["Contract_Start_Date"]){
                                  SweetalertsRequest("error", `Please select start date`);
                                }else{
                                  setIsTermDialogvisible(true);
                                // }
                              }
                             }}
                             value={selectedChoiceKey=="Indefinite"?"Indefinite":""}
                            //  disabled={selectedTerm === "Indefinite"}
                             disabled={isDisabled}
                          ></TextField>
                            }
                               {(item.IntName !== "Contract_End_Date" || !showDurationTextField) && (
                                <DatePicker
                                showWeekNumbers={true}
                                showMonthPickerAsOverlay={true}
                                  id={item.IntName}
                                  placeholder={"Select " + CurrentdisplayfieldsName[item.IntName] + (item.Required !== "Yes" ? " (optional)" : "")}
                                  onSelectDate={(date) =>
                                    ondobChange(date, item.IntName)
                                  }
                                  value={
                                    // (item.IntName === "Contract_End_Date" && selectedChoiceKey === "Indefinite")
                                    (item.IntName === "Contract_End_Date" && selectedTerm === "Indefinite")
                                    ? null  
                                    :dateDatepicker[item.IntName]
                                      ? new Date(dateDatepicker[item.IntName])
                                      : null
                                  }
                                  formatDate={onFormatDate}
                                  // disabled={
                                  //   item.IntName == "Contract_End_Date" &&
                                  //   selectedChoiceKey == "Indefinite"
                                  //     ? true
                                  //     : false
                                  // }
                                  disabled={
                                    item.IntName == "Contract_End_Date" &&
                                    selectedTerm == "Indefinite"
                                      ? true
                                      : false
                                  }
                                  // disabled={isDisabled}
                                />
                                )}

{item.IntName == "Contract_End_Date" && (dateDatepicker[item.IntName]) &&
                            //   <Icon
                            //   iconName="Cancel"
                            //   // onClick={clearTextField}
                           
                            // />
                            <Dismiss32Filled    className="closeIcon"  onClick={() => {
                              setdateDatepicker((prevState) => ({
                                ...prevState,
                                "Contract_End_Date": null,
                              }));
                              setShowDurationTextField(true)
                             }}
                            style={{
                              // root: {
                                position: 'absolute',
                                height:'15px',
                                marginLeft:'14rem',
                                marginTop:'-28px',
                                // transform: 'translateY(-50%)',
                                cursor: 'pointer',
                              
                              // }
                            }}/>
                              }
                              {isDisabled && item.IntName == "Contract_End_Date" &&
                            //   <Icon
                            //   iconName="Cancel"
                            //   // onClick={clearTextField}
                            //   onClick={() => {
                            //     setIsDisabled(false)
                            //    }}
                            //   styles={{
                            //     root: {
                            //       position: 'absolute',
                            //       right: 10,
                            //       top: 38,
                            //       // transform: 'translateY(-50%)',
                            //       cursor: 'pointer',
                            //       fontSize: 17,
                            //       color: 'rgb(96, 94, 92)'
                            //     }
                            //   }}
                            // />
                            <Dismiss32Filled  
                            onClick={() => {
                              setIsDisabled(false)
                             }}
                             className="closeIcon"
                            style={{
                              // root: {
                                position: 'absolute',
                                height:'15px',
                                marginLeft:'15.6rem',
                                marginTop:'-24px',
                                // transform: 'translateY(-50%)',
                                cursor: 'pointer',
                              // }
                            }}
                            />
                              }

                              </div>
                            </>
                          );
                        }
                        if (
                          item.Type == "Attachments" //&& item.Display == true
                        ) {
                          return (
                            <>
                              <div>
                                <Label required={item.Required == "Yes" ? true : false}>
                                  {" "}
                                  {CurrentdisplayfieldsName[item.IntName]}
                                </Label>
                                <div>
                                  {attachmentFileData[item.IntName] == null ||
                                  attachmentFileData[item.IntName]?.length == 0 ? (
                                    <CustomAttachment
                                      showLabel={false}
                                      onChangeAdd={(ev) => {
                                        onCustomAttachmentChange(ev, item.IntName);
                                      }}
                                      accept=".docx,.pdf,.doc,.jpg,.jpeg,.png,.zip,.xlsx,.xls"
                                      selectedFile={attachmentFileData[item.IntName]?.[0]}
                                      key={JSON.stringify(attachmentFileData[item.IntName]?.[0])}
                                    />
                                  ) : null}
                                  {attachmentFileData[item.IntName]?.[0]}
                                </div>
                              </div>
                            </>
                          );
                        }
                        if (
                          item.Type == "Choice" //&& item.Display == true
                        ) {
                          let optionscond;
                          conditionaldata
                            ? conditionaldata.map((items) => {
                                ////console.log(items.internalname, item.IntName, items.value)
                                if (items.internalname == item.IntName) {
                                  optionscond = items.value;
                                }
                              })
                            : null;
                          return (
                            <>
                              <div>
                                <Dropdown
                                  placeholder={"Select " + CurrentdisplayfieldsName[item.IntName] + (item.Required !== "Yes" ? " (optional)" : "")}
                                  id={item.IntName}
                                  // label={iterm.DisplayName}
                                  //selectedKey={selectedstatus}
                                  selectedKey={dataChoice2[item.IntName] ? dataChoice2[item.IntName] : null}
                                  // options={optionscond}
                                  responsiveMode={ResponsiveMode.large}
                                  options={item.IntName==="Payment_Term" ? getFilteredPaymentTerms(dateDatepicker?.['Contract_Start_Date'], dateDatepicker?.['Contract_End_Date'], selectedTerm):optionscond}
                                  disabled={item.IntName==="Payment_Term" ? !dateDatepicker?.['Contract_Start_Date'] || (!dateDatepicker?.['Contract_End_Date'] && selectedTerm !== 'Indefinite') : false}
                                  onChange={(e, items) => getChoice(items, item.IntName)}
                                />
                              </div>
                              {finalconditional
                                ? Object.entries(finalconditional).map(([Outerkey, column]: any, index: any) => {
                                    if (item.IntName == Outerkey) {
                                      return Object.entries(column).map(([Innerkey, innerfields]: any, index: any) => {
                                        return innerfields.Fields.length
                                          ? innerfields.Fields.map((choicefields) => {
                                              let displayvaluetext2;
                                              props.currentfieldname?.map((o) => {
                                                if (o.key == choicefields.InternalName) {
                                                  displayvaluetext2 = o.text.replaceAll("_", " ");
                                                }
                                              });
                                              if (choicefields.type == "Text")
                                                return (
                                                  <div id={choicefields.InternalName}>
                                                    <Label required={choicefields.Required == "Yes" ? true : false}>
                                                      {displayvaluetext2 ? displayvaluetext2 : choicefields.FieldName}
                                                    </Label>
                                                    <TextField
                                                      id={choicefields.InternalName}
                                                      name={choicefields.FieldName}
                                                      value={dataText[choicefields.InternalName] || ""}
                                                      onBlur={() =>
                                                        setdataText((c) => ({
                                                          ...dataText,
                                                          [choicefields.InternalName]:
                                                            dataText[choicefields.InternalName]?.trim(),
                                                        }))
                                                      }
                                                      onChange={gettextvalue}
                                                    ></TextField>
                                                  </div>
                                                );
                                              if (choicefields.type == "Note")
                                                return (
                                                  <div id={choicefields.InternalName}>
                                                    <Label required={choicefields.Required == "Yes" ? true : false}>
                                                      {displayvaluetext2 ? displayvaluetext2 : choicefields.FieldName}
                                                    </Label>
                                                    <TextField
                                                      id={choicefields.InternalName}
                                                      name={choicefields.FieldName}
                                                      value={
                                                        dataNote[choicefields.InternalName]
                                                          ? dataNote[choicefields.InternalName]
                                                          : null
                                                      }
                                                      onChange={getnotevalue}
                                                      multiline
                                                    ></TextField>
                                                  </div>
                                                );
                                              if (choicefields.type == "Number")
                                                return (
                                                  <div id={choicefields.InternalName}>
                                                    <Label>
                                                      {displayvaluetext2 ? displayvaluetext2 : choicefields.FieldName}
                                                    </Label>
                                                    <TextField
                                                      id={choicefields.InternalName}
                                                      value={choicefields.FieldName}
                                                      name="value"
                                                      type="Number"
                                                      onChange={getnumbervalue}
                                                    ></TextField>
                                                  </div>
                                                );
                                              if (choicefields.type == "DateTime")
                                                return (
                                                  <div id={choicefields.InternalName}>
                                                    <Label required={item.Required == "Yes" ? true : false}>
                                                      {displayvaluetext2 ? displayvaluetext2 : choicefields.FieldName}
                                                    </Label>
                                                    <DatePicker
                                                        showWeekNumbers={true}
                                                        showMonthPickerAsOverlay={true}
                                                      id={choicefields.InternalName}
                                                      onSelectDate={(date) =>
                                                        ondobChange(date, choicefields.InternalName)
                                                      }
                                                      // value={Dateofbirth == undefined || Dateofbirth == null ? null : new Date(Dateofbirth)}
                                                      value={
                                                        dateDatepicker[choicefields.InternalName]
                                                          ? new dateDatepicker[choicefields.InternalName]()
                                                          : null
                                                      }
                                                      formatDate={onFormatDate}
                                                    />
                                                  </div>
                                                );
                                            })
                                          : null;
                                      });
                                    }
                                  })
                                : null}
                              {/* <TextField id={item.InternalName} value={item.value} name="value" //onChange={(e) => getnotevalue(e, ind, key1)} 
                              multiline ></TextField> */}
                              {/* {conditionaljson ? Object.entries(conditionaljson).map(([key1, column]: any, index: any) => {
                        return (
                          key1 == item.IntName ? <>
                            {column.Choices.map((data: any, ind: any) => (<>
                              {data.type == "Text" ?
                                <div id={data.value//.replaceAll(/\s+/g, '').toLowerCase()
                                } style={{ display: 'none' }}>
                                  {////console.log(data.value, "1234")}
                                  <Label required={data.Required == 'Yes' ? true : false}>{data.FieldName}</Label>
                                  <TextField id={data.InternalName} name={data.FieldName} onChange={gettextvalue}></TextField>
                                </div> : data.type == "DateTime" ? <div id={data.value//.replaceAll(/\s+/g, '').toLowerCase()
                                } style={{ display: 'none' }}>
                                  <Label required={data.Required == 'Yes' ? true : false}>{data.FieldName}</Label>
                                  <DatePicker id={data.InternalName} onSelectDate={ondobChange} value={Dateofbirth == undefined || Dateofbirth == null ? null : new Date(Dateofbirth)} />
                                </div> : data.type == "Note" ? <div id={data.value//.replaceAll(/\s+/g, '').toLowerCase()
                                } style={{ display: 'none' }}>
                                  <Label required={data.Required == 'Yes' ? true : false}>{data.FieldName}</Label>
                                  <TextField id={data.InternalName} name={data.FieldName} onChange={getnotevalue} multiline></TextField>
                                </div> : ""}
                            </>)
                              // )

                            )}
                            {/* <Label required>{key1}</Label>
                                   </> : null    )}) : null} */}
                            </>
                          );
                        }
                        if(item.Type == "NumberWithSuffix"&&item.IntName=="Contract_Cost"){
                            return (
                              <ContractCostTextField ContractCostData={ContractCostData} setContractCostData={setContractCostData} disabled={!dateDatepicker?.['Contract_Start_Date'] || (!dateDatepicker?.['Contract_End_Date'] && selectedTerm !== 'Indefinite') }/>)
                        }
                      })}
                      {/* </div></div></div></div> */}
                    </div>:null}
                  </div>
                );
                //}
              })
            : null}
        </div>
        <div>
          {documentTypes && documentTypes?.length > 0 && (
            <>
              <h3 style={{ marginBottom: "8px", color: SettingService.GetTheme() == "dark" ? "#fff" : "#000" }}>
                {documenttitle}
              </h3>
              {documentTypes ? (
                <div ></div>
                // style={{ borderBottom: "1.5px solid var(--lightdarkBGTable)" }}
              ) : (
                <div  />
                // style={{ borderBottom: "1.5px solid var(--lightdarkBGTable)" }}
              )}
              <div className={"addnewrequestersection"}>
                {documentTypes &&
                  documentTypes?.map((item) => {
                    if (item.Type === "Attachments") {
                      return (
                        <div key={item.IntName}>
                          <Label required={item.Required === "Yes"}>{CurrentdisplayDocfields[item.IntName]}</Label>
                          <div>
                            {documentTypesData[item.IntName] == null ||
                            documentTypesData[item.IntName]?.length === 0 ? (
                              <CustomAttachment
                                showLabel={false}
                                onChangeAdd={(ev) => {
                                  onDocumentTypeChange(ev, item.IntName);
                                }}
                                accept=".docx,.pdf,.doc,.jpg,.jpeg,.png,.zip,.xlsx,.xls"
                                selectedFile={documentTypesData[item.IntName]?.[0]}
                                key={JSON.stringify(documentTypesData[item.IntName]?.[0])}
                              />
                            ) : null}
                            {documentTypesData[item.IntName]?.[0]}
                          </div>
                        </div>
                      );
                    }
                    return null;
                  })}
              </div>
            </>
          )}
        </div>
        {formfieldjson ? (
          <div
            id="Sweetalertremarksdailoge"
            onDragOver={handleDrag}
            onDragLeave={handleDragLeave}
            style={{ marginTop: "5px" }}
          >
            {/* <Label required>Remarks</Label> */}
            <Label style={{ marginBottom: "8px", color: SettingService.GetTheme() == "dark" ? "#fff" : "#000" }}>
              {strings.Remarks} <span style={{ color: "rgb(164, 38, 44)" }}>*</span>
            </Label>
            <div style={{marginBottom: "5px" }}></div>
            {/* borderBottom: "1.5px solid var(--lightdarkBGTable)" */}
            {/* <TextField multiline value={remark || ""} rows={5} onChange={onChangeRemark} /> */}
            <ReactQuill
                style={{ width: "100%", height: "100px" }}
                theme="snow"
                value={remark || ""}
                onChange={onChangeRemark}
                />
            <>
              <label
                htmlFor="DragandDropFileId"
                style={{
                  display: "flex",
                  marginTop: "4.5rem",
                  width: "fit-content",
                }}
              >
                <Label htmlFor="DragandDropFileId" style={{ display: "flex" }}>
                  <div>
                    <span>{strings.AttachmentsHome}</span>
                  </div>
                  <div style={{ marginTop: "2px", marginLeft: "4px" }}>
                    <Icon
                      iconName="Attach"
                      style={{ height: "25px", marginLeft: "5px" }}
                      styles={{
                        root: {
                          color: "var(--layoutIconColor)",
                        },
                      }}
                    ></Icon>
                  </div>
                </Label>
                {/* className={"imgload"} */}
                <div className={"imgload"}>
                  <TooltipHost content={strings.attachment} id="field4" styles={hostStyles}>
                    <IconButton
                      id="field4"
                      aria-describedby="field4"
                      style={{ height: "22px", marginLeft: "0px" }}
                      iconProps={{ iconName: "Info" }}
                      className={"info"}
                      styles={{
                        icon: {
                          color: "var(--layoutIconColor)",
                        },
                      }}
                    ></IconButton>
                  </TooltipHost>
                </div>
              </label>
              <DragAndDrop
                FileID="DragandDropFileId"
                draggableContainerStyle={{
                  minHeight: "5px",
                  height: heightValue,
                  marginTop: "-1rem",
                }}
                draggableContainerStyle1={{ left: "44%" }}
                showLabel={false}
                multiple={true}
                onChangeAdd={onAttachmentChangeremark}
                accept=".docx,.pdf,.doc"
                selectedFile={attachremarkFile1}
                key={JSON.stringify(attachremarkFile1)}
              />
              <div className="ModalAttachmentsDivrequestform">{attachremarkFile1}</div>
            </>
          </div>
        ) : (
          ""
        )}
        <div style={{ marginTop: "25px" }}>
          {/* {formfieldjson ? (
            <div className={"Buttons"}>
              <PrimaryButton
                text={ButtonSaveText1}
                className={"savebutton"}
                disabled={loading}
                onClick={openDialogRemark}
              >
                {loading && (
                  <div className={"elementToFadeInAndOut"}>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                )}
              </PrimaryButton>
              <DefaultButton
                text={ButtonSaveText}
                className={"DefaultButton1"}
                onClick={() => PostContractformdata("Draft", approvalInfo)}
                style={{ maxWidth: "130px" }}
              >
                {loading1 && (
                  <div className={"elementToFadeInAndOut1"}>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                )}
              </DefaultButton>
            </div>
          ) : (
            ""
          )} */}

          {isDialogvisible === true && (
          <Dialog
            hidden={!isDialogvisible}
            onDismiss={hideDialog}
            dialogContentProps={dialogContentProps}
            modalProps={modalProps}
            // styles={dialogStyles}
          >
            <div id="SweetAlertsCounterparty" />
            {/* <Counterparty
              fetchdata={getcounterpartyDetails}
              closedialog={hideDialog}
              setcounterpartyname={setcounterpartyname}
              optionsCounterparty={optionsCounterparty}
              reqcounterparty={counterparty}
            /> */}
          </Dialog>
        )}

          {isTermDialogvisible && (
            <Callout
              className={stylesCallout.callout}
              role="dialog"
              gapSpace={0}
              target={`#addRequestTerm`}
              onDismiss={hideDialog}
              setInitialFocus
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Label>{strings.AddTerm}</Label>
                <Icon
                  iconName="ChromeClose"
                  styles={{ root: { fontSize: 12, cursor: "pointer" } }}
                  onClick={() => setIsTermDialogvisible(false)}
                ></Icon>
              </div>
              <AddTermDialog
                addTermCallback={handleTermCallback}
                defaultValues={termPeriodObj}
                onTermChangeCallback={handleTermChange}
                isTermDialogvisible={isTermDialogvisible}
              />
            </Callout>
          )}



          {isDialogvisibleOptional && (
          <Dialog
            hidden={!isDialogvisibleOptional}
            onDismiss={hideDialogOptional}
            dialogContentProps={dialogOptionalContentProps}
            // modalProps={dialogModalPropsoptional}
            styles={remarkMod}
          >
            <>
            <div id="Sweetalertsoptional" />
            <span style={{ fontSize: "14px", fontWeight: "400" }}>
              {strings.Youcanskiorchangeexecution}
            </span>
            <div style={{ marginTop: "13px" }}>
              <div
                style={{
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: "8% 26% 32% 32%",
                }}
              >
                <div></div>
                <Label style={{ textAlign: "center" }}>{strings.Action}</Label>
                <Label style={{ textAlign: "center" }}>
                  {strings.Execution}
                </Label>
                <div style={{ textAlign: "center" }}>
                  <Label>{strings.Owner}</Label>
                </div>
              </div>
              {loadApprovalsInfos
                ? approvalInfo.map((item, index) => {
                    return (
                      <div>
                        <div
                          style={{
                            width: "100%",
                            display: "grid",
                            gridTemplateColumns: "8% 26% 32% 32%",
                            margin: "10px 0px",
                            gridColumnGap: "5px",
                          }}
                        >
                          <div>
                            {JSON.parse(item.TaskData)?.Optional ? (
                              <Checkbox
                                styles={checkboxStyles}
                                // onClick={() => setSelectedLevel(1)}
                                onChange={(ev, checked) =>
                                  onchangeMandatorylevel(checked, index)
                                }
                                disabled={!JSON.parse(item.TaskData)?.Optional}
                                // disabled={
                                //   !item.Optional
                                // }
                                checked={JSON.parse(item.TaskData)?.Mandatory}
                              />
                            ) : null}
                          </div>
                          <div>
                            <TextField
                              type="text"
                              styles={TextFieldStyles}
                              value={JSON.parse(item.TaskData)?.TaskTitle}
                              // value={item?.TaskName}
                              disabled={true}
                            />
                          </div>
                          <div>
                            <Dropdown
                              //  selectedKey={workflowname}
                              //selectedKey={"A"}
                              options={optionalAssignedto}
                              multiSelect
                              styles={dropdownStylesapprove}
                              // defaultSelectedKeys={finalapprover}
                              // defaultSelectedKeys={[item?.EmpName?"EmployeeName":item?.EmpManager?"EmployeeManager": item?.EmpManagersManager?"EmployeeManagersManager": item?.JobTitle?  "Role":null]}
                              defaultSelectedKeys={[
                                item?.EmpName ? "EmployeeName" : null,
                                item?.EmpManager ? "EmployeeManager" : null,
                                item?.EmpManagersManager
                                  ? "EmployeeManagersManager"
                                  : null,
                                item?.JobTitle ? "Role" : null,
                              ].filter((c) => c)}
                              disabled={
                                JSON.parse(item.TaskData)?.Optional
                                  ? false
                                  : true
                              }
                              //checkedApprover
                              onChange={(e, items) =>
                                onchangeapprover(items, index)
                              }
                            />
                          </div>
                          <div>
                            <Dropdown
                              placeholder={"Select " + CurrentdisplayfieldsName[item.IntName] + (item.Required !== "Yes" ? " (optional)" : "")}
                              options={UsersOptions}
                              // key={optionsBU.length ? "uniqueeejsdhfjksdh" : "uniqueeejsdhfjksdaskdjkh"}
                              onChange={(_ev, newVal) =>
                                onchangeUser(newVal, index)
                              }
                              selectedKeys={
                                JSON.parse(item.TaskData)?.AssignedToEmail
                              }
                              // className={"ChoiceDropdown"}
                              multiSelect
                              disabled={
                                JSON.parse(item.TaskData)?.Optional
                                  ? false
                                  : true
                              }
                            />
                            
                          </div>
                          <div></div>
                          <div></div>
                          {item?.JobTitle ? (
                            <div style={{ margin: "5px 5px 0px 5px" }}>
                              <Label style={{ textAlign: "end" }}>Role</Label>
                            </div>
                          ) : null}
                          {item?.JobTitle ? (
                            <div style={{ marginTop: "5px" }}>
                              <Dropdown
                                options={allRoleOptions || []}
                                //selectedKey={Rolevalue}
                                selectedKey={item?.TaskAssignedToRole}
                                // id={index}
                                // multiSelect
                                key={
                                  "changed optionsNumber" +
                                  allRoleOptions?.length
                                }
                                styles={dropdownStylesapprove}
                                onChange={(e, items) =>
                                  onchangerole(items, index)
                                }
                                disabled={
                                JSON.parse(item?.TaskData||"{}")?.Optional
                                  ? false
                                  : true
                              }
                              />
                            </div>
                          ) : null}
                        </div>
                        {index !== approvalInfo.length - 1 && (
                          <hr
                            style={{
                              margin: "10px 0",
                              borderColor: "#cececece",
                            }}
                          />
                        )}
                      </div>
                    );
                  })
                : null}
            </div>
            <div style={{ marginTop: "2rem" }}>
              <PrimaryButton
                text={strings.Submit}
                className={"savebutton"}
                onClick={() => showremarkdiabox()}
              ></PrimaryButton>
            </div>
            </>
          </Dialog>
        )}
        </div>
        {/* </>:null} */}
        {/* <PrimaryButton
                text={strings.Submit}
                className={"savebutton"}
                onClick={() => DocumentIntelligence()}
              ></PrimaryButton> */}
      </div>
    

    </div>
  );
}

export default NewContract;


